
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8607"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8607"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2M70Q", function(module, exports) {
'use strict';

module.exports = (parcelRequire("qiYOU"));

});
parcelRegister("qiYOU", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $04f126d959d1d956$export$ffb0004e005737fa, (v) => $04f126d959d1d956$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $04f126d959d1d956$export$34b9dba7ce09269b, (v) => $04f126d959d1d956$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $04f126d959d1d956$export$25062201e9e25d76, (v) => $04f126d959d1d956$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $04f126d959d1d956$export$ffb0004e005737fa;
var $04f126d959d1d956$export$34b9dba7ce09269b;
var $04f126d959d1d956$export$25062201e9e25d76;
"use strict";
var $04f126d959d1d956$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $04f126d959d1d956$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $04f126d959d1d956$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $04f126d959d1d956$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$04f126d959d1d956$export$ffb0004e005737fa = $04f126d959d1d956$var$REACT_FRAGMENT_TYPE;
$04f126d959d1d956$export$34b9dba7ce09269b = $04f126d959d1d956$var$jsxProd;
$04f126d959d1d956$export$25062201e9e25d76 = $04f126d959d1d956$var$jsxProd;

});


parcelRegister("b8xcN", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $81ba32fa4505fca9$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $81ba32fa4505fca9$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $81ba32fa4505fca9$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $81ba32fa4505fca9$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $81ba32fa4505fca9$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spreadArray", () => $81ba32fa4505fca9$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $81ba32fa4505fca9$var$extendStatics = function(d, b) {
    $81ba32fa4505fca9$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $81ba32fa4505fca9$var$extendStatics(d, b);
};
function $81ba32fa4505fca9$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $81ba32fa4505fca9$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $81ba32fa4505fca9$export$18ce0697a983be9b = function() {
    $81ba32fa4505fca9$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $81ba32fa4505fca9$export$18ce0697a983be9b.apply(this, arguments);
};
function $81ba32fa4505fca9$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $81ba32fa4505fca9$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $81ba32fa4505fca9$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $81ba32fa4505fca9$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $81ba32fa4505fca9$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $81ba32fa4505fca9$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $81ba32fa4505fca9$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $81ba32fa4505fca9$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $81ba32fa4505fca9$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $81ba32fa4505fca9$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $81ba32fa4505fca9$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $81ba32fa4505fca9$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $81ba32fa4505fca9$export$45d3717a4c69092e(o, m, p);
}
function $81ba32fa4505fca9$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $81ba32fa4505fca9$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $81ba32fa4505fca9$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($81ba32fa4505fca9$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $81ba32fa4505fca9$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $81ba32fa4505fca9$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $81ba32fa4505fca9$export$10c90e4f7922046c(v) {
    return this instanceof $81ba32fa4505fca9$export$10c90e4f7922046c ? (this.v = v, this) : new $81ba32fa4505fca9$export$10c90e4f7922046c(v);
}
function $81ba32fa4505fca9$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $81ba32fa4505fca9$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $81ba32fa4505fca9$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $81ba32fa4505fca9$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $81ba32fa4505fca9$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $81ba32fa4505fca9$export$19a8beecd37a4c45 === "function" ? $81ba32fa4505fca9$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $81ba32fa4505fca9$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $81ba32fa4505fca9$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $81ba32fa4505fca9$var$ownKeys = function(o) {
    $81ba32fa4505fca9$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $81ba32fa4505fca9$var$ownKeys(o);
};
function $81ba32fa4505fca9$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $81ba32fa4505fca9$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $81ba32fa4505fca9$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $81ba32fa4505fca9$var$__setModuleDefault(result, mod);
    return result;
}
function $81ba32fa4505fca9$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $81ba32fa4505fca9$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $81ba32fa4505fca9$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $81ba32fa4505fca9$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $81ba32fa4505fca9$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $81ba32fa4505fca9$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $81ba32fa4505fca9$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $81ba32fa4505fca9$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $81ba32fa4505fca9$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $81ba32fa4505fca9$export$2e2bcd8739ae039 = {
    __extends: $81ba32fa4505fca9$export$a8ba968b8961cb8a,
    __assign: $81ba32fa4505fca9$export$18ce0697a983be9b,
    __rest: $81ba32fa4505fca9$export$3c9a16f847548506,
    __decorate: $81ba32fa4505fca9$export$29e00dfd3077644b,
    __param: $81ba32fa4505fca9$export$d5ad3fd78186038f,
    __esDecorate: $81ba32fa4505fca9$export$3a84e1ae4e97e9b0,
    __runInitializers: $81ba32fa4505fca9$export$d831c04e792af3d,
    __propKey: $81ba32fa4505fca9$export$6a2a36740a146cb8,
    __setFunctionName: $81ba32fa4505fca9$export$d1a06452d3489bc7,
    __metadata: $81ba32fa4505fca9$export$f1db080c865becb9,
    __awaiter: $81ba32fa4505fca9$export$1050f835b63b671e,
    __generator: $81ba32fa4505fca9$export$67ebef60e6f28a6,
    __createBinding: $81ba32fa4505fca9$export$45d3717a4c69092e,
    __exportStar: $81ba32fa4505fca9$export$f33643c0debef087,
    __values: $81ba32fa4505fca9$export$19a8beecd37a4c45,
    __read: $81ba32fa4505fca9$export$8d051b38c9118094,
    __spread: $81ba32fa4505fca9$export$afc72e2116322959,
    __spreadArrays: $81ba32fa4505fca9$export$6388937ca91ccae8,
    __spreadArray: $81ba32fa4505fca9$export$1216008129fb82ed,
    __await: $81ba32fa4505fca9$export$10c90e4f7922046c,
    __asyncGenerator: $81ba32fa4505fca9$export$e427f37a30a4de9b,
    __asyncDelegator: $81ba32fa4505fca9$export$bbd80228419bb833,
    __asyncValues: $81ba32fa4505fca9$export$e3b29a3d6162315f,
    __makeTemplateObject: $81ba32fa4505fca9$export$4fb47efe1390b86f,
    __importStar: $81ba32fa4505fca9$export$c21735bcef00d192,
    __importDefault: $81ba32fa4505fca9$export$da59b14a69baef04,
    __classPrivateFieldGet: $81ba32fa4505fca9$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $81ba32fa4505fca9$export$d40a35129aaff81f,
    __classPrivateFieldIn: $81ba32fa4505fca9$export$81fdc39f203e4e04,
    __addDisposableResource: $81ba32fa4505fca9$export$88ac25d8e944e405,
    __disposeResources: $81ba32fa4505fca9$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $81ba32fa4505fca9$export$889dfb5d17574b0b
};

});

parcelRegister("3OyDL", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i8ON0"));

});
parcelRegister("i8ON0", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $d3505f169c21e433$export$9c16c1426311996d, (v) => $d3505f169c21e433$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $d3505f169c21e433$export$dca3b0875bd9a954, (v) => $d3505f169c21e433$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $d3505f169c21e433$export$16fa2f45be04daa8, (v) => $d3505f169c21e433$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $d3505f169c21e433$export$ffb0004e005737fa, (v) => $d3505f169c21e433$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $d3505f169c21e433$export$e2c29f18771995cb, (v) => $d3505f169c21e433$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $d3505f169c21e433$export$221d75b3f55bb0bd, (v) => $d3505f169c21e433$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $d3505f169c21e433$export$5f8d39834fd61797, (v) => $d3505f169c21e433$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $d3505f169c21e433$export$74bf444e3cd11ea5, (v) => $d3505f169c21e433$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $d3505f169c21e433$export$1ced07cd6b1985ce, (v) => $d3505f169c21e433$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $d3505f169c21e433$export$abd8e32b826d7ea7, (v) => $d3505f169c21e433$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $d3505f169c21e433$export$69a3209f1a06c04d, (v) => $d3505f169c21e433$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $d3505f169c21e433$export$8c538325882c7eec, (v) => $d3505f169c21e433$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $d3505f169c21e433$export$e530037191fcd5d7, (v) => $d3505f169c21e433$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $d3505f169c21e433$export$fd42f52fd3ae1109, (v) => $d3505f169c21e433$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $d3505f169c21e433$export$c8a8987d4410bf2d, (v) => $d3505f169c21e433$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $d3505f169c21e433$export$7d1e3a5e95ceca43, (v) => $d3505f169c21e433$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $d3505f169c21e433$export$257a8862b851cb5b, (v) => $d3505f169c21e433$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $d3505f169c21e433$export$a8257692ac88316c, (v) => $d3505f169c21e433$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $d3505f169c21e433$export$488013bae63b21da, (v) => $d3505f169c21e433$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $d3505f169c21e433$export$7c73462e0d25e514, (v) => $d3505f169c21e433$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $d3505f169c21e433$export$7568632d0d33d16d, (v) => $d3505f169c21e433$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $d3505f169c21e433$export$f93f40ac0ca7e3a8, (v) => $d3505f169c21e433$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $d3505f169c21e433$export$1f96ae73734a86cc, (v) => $d3505f169c21e433$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $d3505f169c21e433$export$9a47ced3238df325, (v) => $d3505f169c21e433$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $d3505f169c21e433$export$35808ee640e87ca7, (v) => $d3505f169c21e433$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $d3505f169c21e433$export$fae74005e78b1a27, (v) => $d3505f169c21e433$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $d3505f169c21e433$export$dc8fbce3eb94dc1e, (v) => $d3505f169c21e433$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $d3505f169c21e433$export$6a7bc4e911dc01cf, (v) => $d3505f169c21e433$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $d3505f169c21e433$export$6d9c69b0de29b591, (v) => $d3505f169c21e433$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $d3505f169c21e433$export$7f54fc3180508a52, (v) => $d3505f169c21e433$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $d3505f169c21e433$export$f680877a34711e37, (v) => $d3505f169c21e433$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $d3505f169c21e433$export$d5a552a76deda3c2, (v) => $d3505f169c21e433$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $d3505f169c21e433$export$aaabe4eda9ed9969, (v) => $d3505f169c21e433$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $d3505f169c21e433$export$e5c5a5f917a5871c, (v) => $d3505f169c21e433$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $d3505f169c21e433$export$1538c33de8887b59, (v) => $d3505f169c21e433$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $d3505f169c21e433$export$fca7f784ae7a249a, (v) => $d3505f169c21e433$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $d3505f169c21e433$export$13e3392192263954, (v) => $d3505f169c21e433$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $d3505f169c21e433$export$b8f5890fc79d6aca, (v) => $d3505f169c21e433$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $d3505f169c21e433$export$60241385465d0a34, (v) => $d3505f169c21e433$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $d3505f169c21e433$export$306c0aa65ff9ec16, (v) => $d3505f169c21e433$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $d3505f169c21e433$export$7b286972b8d8ccbf, (v) => $d3505f169c21e433$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $d3505f169c21e433$export$83d89fbfd8236492, (v) => $d3505f169c21e433$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d3505f169c21e433$export$9c16c1426311996d;
var $d3505f169c21e433$export$dca3b0875bd9a954;
var $d3505f169c21e433$export$16fa2f45be04daa8;
var $d3505f169c21e433$export$ffb0004e005737fa;
var $d3505f169c21e433$export$e2c29f18771995cb;
var $d3505f169c21e433$export$221d75b3f55bb0bd;
var $d3505f169c21e433$export$5f8d39834fd61797;
var $d3505f169c21e433$export$74bf444e3cd11ea5;
var $d3505f169c21e433$export$1ced07cd6b1985ce;
var $d3505f169c21e433$export$abd8e32b826d7ea7;
var $d3505f169c21e433$export$69a3209f1a06c04d;
var $d3505f169c21e433$export$8c538325882c7eec;
var $d3505f169c21e433$export$e530037191fcd5d7;
var $d3505f169c21e433$export$fd42f52fd3ae1109;
var $d3505f169c21e433$export$c8a8987d4410bf2d;
var $d3505f169c21e433$export$7d1e3a5e95ceca43;
var $d3505f169c21e433$export$257a8862b851cb5b;
var $d3505f169c21e433$export$a8257692ac88316c;
var $d3505f169c21e433$export$488013bae63b21da;
var $d3505f169c21e433$export$7c73462e0d25e514;
var $d3505f169c21e433$export$7568632d0d33d16d;
var $d3505f169c21e433$export$f93f40ac0ca7e3a8;
var $d3505f169c21e433$export$1f96ae73734a86cc;
var $d3505f169c21e433$export$9a47ced3238df325;
var $d3505f169c21e433$export$35808ee640e87ca7;
var $d3505f169c21e433$export$fae74005e78b1a27;
var $d3505f169c21e433$export$dc8fbce3eb94dc1e;
var $d3505f169c21e433$export$6a7bc4e911dc01cf;
var $d3505f169c21e433$export$6d9c69b0de29b591;
var $d3505f169c21e433$export$7f54fc3180508a52;
var $d3505f169c21e433$export$f680877a34711e37;
var $d3505f169c21e433$export$d5a552a76deda3c2;
var $d3505f169c21e433$export$aaabe4eda9ed9969;
var $d3505f169c21e433$export$e5c5a5f917a5871c;
var $d3505f169c21e433$export$1538c33de8887b59;
var $d3505f169c21e433$export$fca7f784ae7a249a;
var $d3505f169c21e433$export$13e3392192263954;
var $d3505f169c21e433$export$b8f5890fc79d6aca;
var $d3505f169c21e433$export$60241385465d0a34;
var $d3505f169c21e433$export$306c0aa65ff9ec16;
var $d3505f169c21e433$export$7b286972b8d8ccbf;
var $d3505f169c21e433$export$83d89fbfd8236492;
"use strict";
var $d3505f169c21e433$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d3505f169c21e433$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $d3505f169c21e433$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $d3505f169c21e433$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $d3505f169c21e433$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $d3505f169c21e433$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $d3505f169c21e433$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $d3505f169c21e433$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $d3505f169c21e433$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $d3505f169c21e433$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $d3505f169c21e433$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $d3505f169c21e433$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $d3505f169c21e433$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $d3505f169c21e433$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $d3505f169c21e433$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$d3505f169c21e433$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $d3505f169c21e433$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $d3505f169c21e433$var$assign = Object.assign, $d3505f169c21e433$var$emptyObject = {};
function $d3505f169c21e433$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $d3505f169c21e433$var$emptyObject;
    this.updater = updater || $d3505f169c21e433$var$ReactNoopUpdateQueue;
}
$d3505f169c21e433$var$Component.prototype.isReactComponent = {};
$d3505f169c21e433$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$d3505f169c21e433$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $d3505f169c21e433$var$ComponentDummy() {}
$d3505f169c21e433$var$ComponentDummy.prototype = $d3505f169c21e433$var$Component.prototype;
function $d3505f169c21e433$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $d3505f169c21e433$var$emptyObject;
    this.updater = updater || $d3505f169c21e433$var$ReactNoopUpdateQueue;
}
var $d3505f169c21e433$var$pureComponentPrototype = $d3505f169c21e433$var$PureComponent.prototype = new $d3505f169c21e433$var$ComponentDummy();
$d3505f169c21e433$var$pureComponentPrototype.constructor = $d3505f169c21e433$var$PureComponent;
$d3505f169c21e433$var$assign($d3505f169c21e433$var$pureComponentPrototype, $d3505f169c21e433$var$Component.prototype);
$d3505f169c21e433$var$pureComponentPrototype.isPureReactComponent = !0;
var $d3505f169c21e433$var$isArrayImpl = Array.isArray;
function $d3505f169c21e433$var$noop() {}
var $d3505f169c21e433$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $d3505f169c21e433$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $d3505f169c21e433$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $d3505f169c21e433$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $d3505f169c21e433$var$cloneAndReplaceKey(oldElement, newKey) {
    return $d3505f169c21e433$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $d3505f169c21e433$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $d3505f169c21e433$var$REACT_ELEMENT_TYPE;
}
function $d3505f169c21e433$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $d3505f169c21e433$var$userProvidedKeyEscapeRegex = /\/+/g;
function $d3505f169c21e433$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $d3505f169c21e433$var$escape("" + element.key) : index.toString(36);
}
function $d3505f169c21e433$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($d3505f169c21e433$var$noop, $d3505f169c21e433$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $d3505f169c21e433$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $d3505f169c21e433$var$REACT_ELEMENT_TYPE:
                case $d3505f169c21e433$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $d3505f169c21e433$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $d3505f169c21e433$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $d3505f169c21e433$var$getElementKey(children, 0) : nameSoFar, $d3505f169c21e433$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($d3505f169c21e433$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $d3505f169c21e433$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($d3505f169c21e433$var$isValidElement(callback) && (callback = $d3505f169c21e433$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($d3505f169c21e433$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($d3505f169c21e433$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $d3505f169c21e433$var$getElementKey(nameSoFar, i), invokeCallback += $d3505f169c21e433$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $d3505f169c21e433$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $d3505f169c21e433$var$getElementKey(nameSoFar, i++), invokeCallback += $d3505f169c21e433$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $d3505f169c21e433$var$mapIntoArray($d3505f169c21e433$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $d3505f169c21e433$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $d3505f169c21e433$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $d3505f169c21e433$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $d3505f169c21e433$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $d3505f169c21e433$var$Children = {
    map: $d3505f169c21e433$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $d3505f169c21e433$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $d3505f169c21e433$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $d3505f169c21e433$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$d3505f169c21e433$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$d3505f169c21e433$export$9c16c1426311996d = $d3505f169c21e433$var$REACT_ACTIVITY_TYPE;
$d3505f169c21e433$export$dca3b0875bd9a954 = $d3505f169c21e433$var$Children;
$d3505f169c21e433$export$16fa2f45be04daa8 = $d3505f169c21e433$var$Component;
$d3505f169c21e433$export$ffb0004e005737fa = $d3505f169c21e433$var$REACT_FRAGMENT_TYPE;
$d3505f169c21e433$export$e2c29f18771995cb = $d3505f169c21e433$var$REACT_PROFILER_TYPE;
$d3505f169c21e433$export$221d75b3f55bb0bd = $d3505f169c21e433$var$PureComponent;
$d3505f169c21e433$export$5f8d39834fd61797 = $d3505f169c21e433$var$REACT_STRICT_MODE_TYPE;
$d3505f169c21e433$export$74bf444e3cd11ea5 = $d3505f169c21e433$var$REACT_SUSPENSE_TYPE;
$d3505f169c21e433$export$1ced07cd6b1985ce = $d3505f169c21e433$var$ReactSharedInternals;
$d3505f169c21e433$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $d3505f169c21e433$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$d3505f169c21e433$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$d3505f169c21e433$export$8c538325882c7eec = function() {
    return null;
};
$d3505f169c21e433$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $d3505f169c21e433$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$d3505f169c21e433$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $d3505f169c21e433$var$ReactElement(element.type, key, props);
};
$d3505f169c21e433$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $d3505f169c21e433$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $d3505f169c21e433$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$d3505f169c21e433$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$d3505f169c21e433$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $d3505f169c21e433$var$ReactElement(type, key, props);
};
$d3505f169c21e433$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$d3505f169c21e433$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $d3505f169c21e433$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$d3505f169c21e433$export$a8257692ac88316c = $d3505f169c21e433$var$isValidElement;
$d3505f169c21e433$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $d3505f169c21e433$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $d3505f169c21e433$var$lazyInitializer
    };
};
$d3505f169c21e433$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $d3505f169c21e433$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$d3505f169c21e433$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $d3505f169c21e433$var$ReactSharedInternals.T, currentTransition = {};
    $d3505f169c21e433$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $d3505f169c21e433$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($d3505f169c21e433$var$noop, $d3505f169c21e433$var$reportGlobalError);
    } catch (error) {
        $d3505f169c21e433$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $d3505f169c21e433$var$ReactSharedInternals.T = prevTransition;
    }
};
$d3505f169c21e433$export$f93f40ac0ca7e3a8 = function() {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useCacheRefresh();
};
$d3505f169c21e433$export$1f96ae73734a86cc = function(usable) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.use(usable);
};
$d3505f169c21e433$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$d3505f169c21e433$export$35808ee640e87ca7 = function(callback, deps) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$d3505f169c21e433$export$fae74005e78b1a27 = function(Context) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useContext(Context);
};
$d3505f169c21e433$export$dc8fbce3eb94dc1e = function() {};
$d3505f169c21e433$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$d3505f169c21e433$export$6d9c69b0de29b591 = function(create, deps) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useEffect(create, deps);
};
$d3505f169c21e433$export$7f54fc3180508a52 = function(callback) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$d3505f169c21e433$export$f680877a34711e37 = function() {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useId();
};
$d3505f169c21e433$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$d3505f169c21e433$export$aaabe4eda9ed9969 = function(create, deps) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$d3505f169c21e433$export$e5c5a5f917a5871c = function(create, deps) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$d3505f169c21e433$export$1538c33de8887b59 = function(create, deps) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useMemo(create, deps);
};
$d3505f169c21e433$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$d3505f169c21e433$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$d3505f169c21e433$export$b8f5890fc79d6aca = function(initialValue) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useRef(initialValue);
};
$d3505f169c21e433$export$60241385465d0a34 = function(initialState) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useState(initialState);
};
$d3505f169c21e433$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$d3505f169c21e433$export$7b286972b8d8ccbf = function() {
    return $d3505f169c21e433$var$ReactSharedInternals.H.useTransition();
};
$d3505f169c21e433$export$83d89fbfd8236492 = "19.2.8";

});


parcelRegister("lApLI", function(module, exports) {
'use strict';
function $fb70f2e0233665b5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($fb70f2e0233665b5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$fb70f2e0233665b5$var$checkDCE();

module.exports = (parcelRequire("ipsyb"));

});
parcelRegister("ipsyb", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $d670b54f7076e4a4$export$882461b6382ed46c, (v) => $d670b54f7076e4a4$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $d670b54f7076e4a4$export$757ceba2d55c277e, (v) => $d670b54f7076e4a4$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $d670b54f7076e4a4$export$83d89fbfd8236492, (v) => $d670b54f7076e4a4$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $d670b54f7076e4a4$export$882461b6382ed46c;
var $d670b54f7076e4a4$export$757ceba2d55c277e;
var $d670b54f7076e4a4$export$83d89fbfd8236492;
"use strict";

var $jztx6 = parcelRequire("jztx6");

var $3OyDL = parcelRequire("3OyDL");

var $dy6Cj = parcelRequire("dy6Cj");
function $d670b54f7076e4a4$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $d670b54f7076e4a4$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $d670b54f7076e4a4$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $d670b54f7076e4a4$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $d670b54f7076e4a4$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $d670b54f7076e4a4$var$assertIsMounted(fiber) {
    if ($d670b54f7076e4a4$var$getNearestMountedFiber(fiber) !== fiber) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(188));
}
function $d670b54f7076e4a4$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $d670b54f7076e4a4$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $d670b54f7076e4a4$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $d670b54f7076e4a4$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $d670b54f7076e4a4$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $d670b54f7076e4a4$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $d670b54f7076e4a4$var$assign = Object.assign, $d670b54f7076e4a4$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $d670b54f7076e4a4$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d670b54f7076e4a4$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $d670b54f7076e4a4$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $d670b54f7076e4a4$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $d670b54f7076e4a4$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $d670b54f7076e4a4$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $d670b54f7076e4a4$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $d670b54f7076e4a4$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $d670b54f7076e4a4$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $d670b54f7076e4a4$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $d670b54f7076e4a4$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $d670b54f7076e4a4$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $d670b54f7076e4a4$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $d670b54f7076e4a4$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $d670b54f7076e4a4$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $d670b54f7076e4a4$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $d670b54f7076e4a4$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$d670b54f7076e4a4$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $d670b54f7076e4a4$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $d670b54f7076e4a4$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $d670b54f7076e4a4$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $d670b54f7076e4a4$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $d670b54f7076e4a4$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $d670b54f7076e4a4$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $d670b54f7076e4a4$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $d670b54f7076e4a4$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $d670b54f7076e4a4$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $d670b54f7076e4a4$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $d670b54f7076e4a4$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $d670b54f7076e4a4$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $d670b54f7076e4a4$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $d670b54f7076e4a4$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $d670b54f7076e4a4$var$getComponentNameFromType(type.type) || "Memo";
        case $d670b54f7076e4a4$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $d670b54f7076e4a4$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $d670b54f7076e4a4$var$isArrayImpl = Array.isArray, $d670b54f7076e4a4$var$ReactSharedInternals = $3OyDL.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $d670b54f7076e4a4$var$ReactDOMSharedInternals = $dy6Cj.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $d670b54f7076e4a4$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $d670b54f7076e4a4$var$valueStack = [], $d670b54f7076e4a4$var$index = -1;
function $d670b54f7076e4a4$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $d670b54f7076e4a4$var$pop(cursor) {
    0 > $d670b54f7076e4a4$var$index || (cursor.current = $d670b54f7076e4a4$var$valueStack[$d670b54f7076e4a4$var$index], $d670b54f7076e4a4$var$valueStack[$d670b54f7076e4a4$var$index] = null, $d670b54f7076e4a4$var$index--);
}
function $d670b54f7076e4a4$var$push(cursor, value) {
    $d670b54f7076e4a4$var$index++;
    $d670b54f7076e4a4$var$valueStack[$d670b54f7076e4a4$var$index] = cursor.current;
    cursor.current = value;
}
var $d670b54f7076e4a4$var$contextStackCursor = $d670b54f7076e4a4$var$createCursor(null), $d670b54f7076e4a4$var$contextFiberStackCursor = $d670b54f7076e4a4$var$createCursor(null), $d670b54f7076e4a4$var$rootInstanceStackCursor = $d670b54f7076e4a4$var$createCursor(null), $d670b54f7076e4a4$var$hostTransitionProviderCursor = $d670b54f7076e4a4$var$createCursor(null);
function $d670b54f7076e4a4$var$pushHostContainer(fiber, nextRootInstance) {
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$rootInstanceStackCursor, nextRootInstance);
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$contextFiberStackCursor, fiber);
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $d670b54f7076e4a4$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $d670b54f7076e4a4$var$getOwnHostContext(nextRootInstance), fiber = $d670b54f7076e4a4$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$contextStackCursor);
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$contextStackCursor, fiber);
}
function $d670b54f7076e4a4$var$popHostContainer() {
    $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$contextStackCursor);
    $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$contextFiberStackCursor);
    $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$rootInstanceStackCursor);
}
function $d670b54f7076e4a4$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$hostTransitionProviderCursor, fiber);
    var context = $d670b54f7076e4a4$var$contextStackCursor.current;
    var JSCompiler_inline_result = $d670b54f7076e4a4$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$contextFiberStackCursor, fiber), $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$contextStackCursor, JSCompiler_inline_result));
}
function $d670b54f7076e4a4$var$popHostContext(fiber) {
    $d670b54f7076e4a4$var$contextFiberStackCursor.current === fiber && ($d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$contextStackCursor), $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$contextFiberStackCursor));
    $d670b54f7076e4a4$var$hostTransitionProviderCursor.current === fiber && ($d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$hostTransitionProviderCursor), $d670b54f7076e4a4$var$HostTransitionContext._currentValue = $d670b54f7076e4a4$var$sharedNotPendingObject);
}
var $d670b54f7076e4a4$var$prefix, $d670b54f7076e4a4$var$suffix;
function $d670b54f7076e4a4$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $d670b54f7076e4a4$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $d670b54f7076e4a4$var$prefix = match && match[1] || "";
        $d670b54f7076e4a4$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $d670b54f7076e4a4$var$prefix + name + $d670b54f7076e4a4$var$suffix;
}
var $d670b54f7076e4a4$var$reentry = !1;
function $d670b54f7076e4a4$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $d670b54f7076e4a4$var$reentry) return "";
    $d670b54f7076e4a4$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $d670b54f7076e4a4$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $d670b54f7076e4a4$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $d670b54f7076e4a4$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $d670b54f7076e4a4$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $d670b54f7076e4a4$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $d670b54f7076e4a4$var$describeBuiltInComponentFrame("Suspense Fallback") : $d670b54f7076e4a4$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $d670b54f7076e4a4$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $d670b54f7076e4a4$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $d670b54f7076e4a4$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $d670b54f7076e4a4$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $d670b54f7076e4a4$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $d670b54f7076e4a4$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $d670b54f7076e4a4$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $d670b54f7076e4a4$var$hasOwnProperty = Object.prototype.hasOwnProperty, $d670b54f7076e4a4$var$scheduleCallback$3 = $jztx6.unstable_scheduleCallback, $d670b54f7076e4a4$var$cancelCallback$1 = $jztx6.unstable_cancelCallback, $d670b54f7076e4a4$var$shouldYield = $jztx6.unstable_shouldYield, $d670b54f7076e4a4$var$requestPaint = $jztx6.unstable_requestPaint, $d670b54f7076e4a4$var$now = $jztx6.unstable_now, $d670b54f7076e4a4$var$getCurrentPriorityLevel = $jztx6.unstable_getCurrentPriorityLevel, $d670b54f7076e4a4$var$ImmediatePriority = $jztx6.unstable_ImmediatePriority, $d670b54f7076e4a4$var$UserBlockingPriority = $jztx6.unstable_UserBlockingPriority, $d670b54f7076e4a4$var$NormalPriority$1 = $jztx6.unstable_NormalPriority, $d670b54f7076e4a4$var$LowPriority = $jztx6.unstable_LowPriority, $d670b54f7076e4a4$var$IdlePriority = $jztx6.unstable_IdlePriority, $d670b54f7076e4a4$var$log$1 = $jztx6.log, $d670b54f7076e4a4$var$unstable_setDisableYieldValue = $jztx6.unstable_setDisableYieldValue, $d670b54f7076e4a4$var$rendererID = null, $d670b54f7076e4a4$var$injectedHook = null;
function $d670b54f7076e4a4$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $d670b54f7076e4a4$var$log$1 && $d670b54f7076e4a4$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($d670b54f7076e4a4$var$injectedHook && "function" === typeof $d670b54f7076e4a4$var$injectedHook.setStrictMode) try {
        $d670b54f7076e4a4$var$injectedHook.setStrictMode($d670b54f7076e4a4$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $d670b54f7076e4a4$var$clz32 = Math.clz32 ? Math.clz32 : $d670b54f7076e4a4$var$clz32Fallback, $d670b54f7076e4a4$var$log = Math.log, $d670b54f7076e4a4$var$LN2 = Math.LN2;
function $d670b54f7076e4a4$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($d670b54f7076e4a4$var$log(x) / $d670b54f7076e4a4$var$LN2 | 0) | 0;
}
var $d670b54f7076e4a4$var$nextTransitionUpdateLane = 256, $d670b54f7076e4a4$var$nextTransitionDeferredLane = 262144, $d670b54f7076e4a4$var$nextRetryLane = 4194304;
function $d670b54f7076e4a4$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $d670b54f7076e4a4$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $d670b54f7076e4a4$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $d670b54f7076e4a4$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $d670b54f7076e4a4$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $d670b54f7076e4a4$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $d670b54f7076e4a4$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $d670b54f7076e4a4$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $d670b54f7076e4a4$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $d670b54f7076e4a4$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $d670b54f7076e4a4$var$claimNextRetryLane() {
    var lane = $d670b54f7076e4a4$var$nextRetryLane;
    $d670b54f7076e4a4$var$nextRetryLane <<= 1;
    0 === ($d670b54f7076e4a4$var$nextRetryLane & 62914560) && ($d670b54f7076e4a4$var$nextRetryLane = 4194304);
    return lane;
}
function $d670b54f7076e4a4$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $d670b54f7076e4a4$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $d670b54f7076e4a4$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $d670b54f7076e4a4$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $d670b54f7076e4a4$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $d670b54f7076e4a4$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $d670b54f7076e4a4$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $d670b54f7076e4a4$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $d670b54f7076e4a4$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $d670b54f7076e4a4$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $d670b54f7076e4a4$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $d670b54f7076e4a4$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $d670b54f7076e4a4$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $d670b54f7076e4a4$var$resolveUpdatePriority() {
    var updatePriority = $d670b54f7076e4a4$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $d670b54f7076e4a4$var$getEventPriority(updatePriority.type);
}
function $d670b54f7076e4a4$var$runWithPriority(priority, fn) {
    var previousPriority = $d670b54f7076e4a4$var$ReactDOMSharedInternals.p;
    try {
        return $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $d670b54f7076e4a4$var$randomKey = Math.random().toString(36).slice(2), $d670b54f7076e4a4$var$internalInstanceKey = "__reactFiber$" + $d670b54f7076e4a4$var$randomKey, $d670b54f7076e4a4$var$internalPropsKey = "__reactProps$" + $d670b54f7076e4a4$var$randomKey, $d670b54f7076e4a4$var$internalContainerInstanceKey = "__reactContainer$" + $d670b54f7076e4a4$var$randomKey, $d670b54f7076e4a4$var$internalEventHandlersKey = "__reactEvents$" + $d670b54f7076e4a4$var$randomKey, $d670b54f7076e4a4$var$internalEventHandlerListenersKey = "__reactListeners$" + $d670b54f7076e4a4$var$randomKey, $d670b54f7076e4a4$var$internalEventHandlesSetKey = "__reactHandles$" + $d670b54f7076e4a4$var$randomKey, $d670b54f7076e4a4$var$internalRootNodeResourcesKey = "__reactResources$" + $d670b54f7076e4a4$var$randomKey, $d670b54f7076e4a4$var$internalHoistableMarker = "__reactMarker$" + $d670b54f7076e4a4$var$randomKey;
function $d670b54f7076e4a4$var$detachDeletedInstance(node) {
    delete node[$d670b54f7076e4a4$var$internalInstanceKey];
    delete node[$d670b54f7076e4a4$var$internalPropsKey];
    delete node[$d670b54f7076e4a4$var$internalEventHandlersKey];
    delete node[$d670b54f7076e4a4$var$internalEventHandlerListenersKey];
    delete node[$d670b54f7076e4a4$var$internalEventHandlesSetKey];
}
function $d670b54f7076e4a4$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$d670b54f7076e4a4$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$d670b54f7076e4a4$var$internalContainerInstanceKey] || parentNode[$d670b54f7076e4a4$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $d670b54f7076e4a4$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$d670b54f7076e4a4$var$internalInstanceKey]) return parentNode;
                targetNode = $d670b54f7076e4a4$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $d670b54f7076e4a4$var$getInstanceFromNode(node) {
    if (node = node[$d670b54f7076e4a4$var$internalInstanceKey] || node[$d670b54f7076e4a4$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $d670b54f7076e4a4$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(33));
}
function $d670b54f7076e4a4$var$getResourcesFromRoot(root) {
    var resources = root[$d670b54f7076e4a4$var$internalRootNodeResourcesKey];
    resources || (resources = root[$d670b54f7076e4a4$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $d670b54f7076e4a4$var$markNodeAsHoistable(node) {
    node[$d670b54f7076e4a4$var$internalHoistableMarker] = !0;
}
var $d670b54f7076e4a4$var$allNativeEvents = new Set(), $d670b54f7076e4a4$var$registrationNameDependencies = {};
function $d670b54f7076e4a4$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $d670b54f7076e4a4$var$registerDirectEvent(registrationName, dependencies);
    $d670b54f7076e4a4$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $d670b54f7076e4a4$var$registerDirectEvent(registrationName, dependencies) {
    $d670b54f7076e4a4$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$d670b54f7076e4a4$var$allNativeEvents.add(dependencies[registrationName]);
}
var $d670b54f7076e4a4$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $d670b54f7076e4a4$var$illegalAttributeNameCache = {}, $d670b54f7076e4a4$var$validatedAttributeNameCache = {};
function $d670b54f7076e4a4$var$isAttributeNameSafe(attributeName) {
    if ($d670b54f7076e4a4$var$hasOwnProperty.call($d670b54f7076e4a4$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($d670b54f7076e4a4$var$hasOwnProperty.call($d670b54f7076e4a4$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($d670b54f7076e4a4$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $d670b54f7076e4a4$var$validatedAttributeNameCache[attributeName] = !0;
    $d670b54f7076e4a4$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $d670b54f7076e4a4$var$setValueForAttribute(node, name, value) {
    if ($d670b54f7076e4a4$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $d670b54f7076e4a4$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $d670b54f7076e4a4$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $d670b54f7076e4a4$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $d670b54f7076e4a4$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $d670b54f7076e4a4$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $d670b54f7076e4a4$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $d670b54f7076e4a4$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $d670b54f7076e4a4$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $d670b54f7076e4a4$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $d670b54f7076e4a4$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $d670b54f7076e4a4$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $d670b54f7076e4a4$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $d670b54f7076e4a4$var$getToStringValue(value);
        } else element.value !== "" + $d670b54f7076e4a4$var$getToStringValue(value) && (element.value = "" + $d670b54f7076e4a4$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $d670b54f7076e4a4$var$setDefaultValue(element, type, $d670b54f7076e4a4$var$getToStringValue(value)) : null != defaultValue ? $d670b54f7076e4a4$var$setDefaultValue(element, type, $d670b54f7076e4a4$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $d670b54f7076e4a4$var$getToStringValue(name) : element.removeAttribute("name");
}
function $d670b54f7076e4a4$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $d670b54f7076e4a4$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $d670b54f7076e4a4$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $d670b54f7076e4a4$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $d670b54f7076e4a4$var$track(element);
}
function $d670b54f7076e4a4$var$setDefaultValue(node, type, value) {
    "number" === type && $d670b54f7076e4a4$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $d670b54f7076e4a4$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $d670b54f7076e4a4$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $d670b54f7076e4a4$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $d670b54f7076e4a4$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $d670b54f7076e4a4$var$getToStringValue(defaultValue) : "";
}
function $d670b54f7076e4a4$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(92));
            if ($d670b54f7076e4a4$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $d670b54f7076e4a4$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $d670b54f7076e4a4$var$track(element);
}
function $d670b54f7076e4a4$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $d670b54f7076e4a4$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $d670b54f7076e4a4$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $d670b54f7076e4a4$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $d670b54f7076e4a4$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $d670b54f7076e4a4$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $d670b54f7076e4a4$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $d670b54f7076e4a4$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $d670b54f7076e4a4$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $d670b54f7076e4a4$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $d670b54f7076e4a4$var$sanitizeURL(url) {
    return $d670b54f7076e4a4$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $d670b54f7076e4a4$var$noop$1() {}
var $d670b54f7076e4a4$var$currentReplayingEvent = null;
function $d670b54f7076e4a4$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $d670b54f7076e4a4$var$restoreTarget = null, $d670b54f7076e4a4$var$restoreQueue = null;
function $d670b54f7076e4a4$var$restoreStateOfTarget(target) {
    var internalInstance = $d670b54f7076e4a4$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$d670b54f7076e4a4$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $d670b54f7076e4a4$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$d670b54f7076e4a4$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(90));
                            $d670b54f7076e4a4$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $d670b54f7076e4a4$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $d670b54f7076e4a4$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $d670b54f7076e4a4$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $d670b54f7076e4a4$var$isInsideEventHandler = !1;
function $d670b54f7076e4a4$var$batchedUpdates$1(fn, a, b) {
    if ($d670b54f7076e4a4$var$isInsideEventHandler) return fn(a, b);
    $d670b54f7076e4a4$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($d670b54f7076e4a4$var$isInsideEventHandler = !1, null !== $d670b54f7076e4a4$var$restoreTarget || null !== $d670b54f7076e4a4$var$restoreQueue) {
            if ($d670b54f7076e4a4$var$flushSyncWork$1(), $d670b54f7076e4a4$var$restoreTarget && (a = $d670b54f7076e4a4$var$restoreTarget, fn = $d670b54f7076e4a4$var$restoreQueue, $d670b54f7076e4a4$var$restoreQueue = $d670b54f7076e4a4$var$restoreTarget = null, $d670b54f7076e4a4$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$d670b54f7076e4a4$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $d670b54f7076e4a4$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$d670b54f7076e4a4$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $d670b54f7076e4a4$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $d670b54f7076e4a4$var$passiveBrowserEventsSupported = !1;
if ($d670b54f7076e4a4$var$canUseDOM) try {
    var $d670b54f7076e4a4$var$options = {};
    Object.defineProperty($d670b54f7076e4a4$var$options, "passive", {
        get: function() {
            $d670b54f7076e4a4$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $d670b54f7076e4a4$var$options, $d670b54f7076e4a4$var$options);
    window.removeEventListener("test", $d670b54f7076e4a4$var$options, $d670b54f7076e4a4$var$options);
} catch (e) {
    $d670b54f7076e4a4$var$passiveBrowserEventsSupported = !1;
}
var $d670b54f7076e4a4$var$root = null, $d670b54f7076e4a4$var$startText = null, $d670b54f7076e4a4$var$fallbackText = null;
function $d670b54f7076e4a4$var$getData() {
    if ($d670b54f7076e4a4$var$fallbackText) return $d670b54f7076e4a4$var$fallbackText;
    var start, startValue = $d670b54f7076e4a4$var$startText, startLength = startValue.length, end, endValue = "value" in $d670b54f7076e4a4$var$root ? $d670b54f7076e4a4$var$root.value : $d670b54f7076e4a4$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $d670b54f7076e4a4$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $d670b54f7076e4a4$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $d670b54f7076e4a4$var$functionThatReturnsTrue() {
    return !0;
}
function $d670b54f7076e4a4$var$functionThatReturnsFalse() {
    return !1;
}
function $d670b54f7076e4a4$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $d670b54f7076e4a4$var$functionThatReturnsTrue : $d670b54f7076e4a4$var$functionThatReturnsFalse;
        this.isPropagationStopped = $d670b54f7076e4a4$var$functionThatReturnsFalse;
        return this;
    }
    $d670b54f7076e4a4$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $d670b54f7076e4a4$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $d670b54f7076e4a4$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $d670b54f7076e4a4$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $d670b54f7076e4a4$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $d670b54f7076e4a4$var$SyntheticEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$EventInterface), $d670b54f7076e4a4$var$UIEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$EventInterface, {
    view: 0,
    detail: 0
}), $d670b54f7076e4a4$var$SyntheticUIEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$UIEventInterface), $d670b54f7076e4a4$var$lastMovementX, $d670b54f7076e4a4$var$lastMovementY, $d670b54f7076e4a4$var$lastMouseEvent, $d670b54f7076e4a4$var$MouseEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $d670b54f7076e4a4$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $d670b54f7076e4a4$var$lastMouseEvent && ($d670b54f7076e4a4$var$lastMouseEvent && "mousemove" === event.type ? ($d670b54f7076e4a4$var$lastMovementX = event.screenX - $d670b54f7076e4a4$var$lastMouseEvent.screenX, $d670b54f7076e4a4$var$lastMovementY = event.screenY - $d670b54f7076e4a4$var$lastMouseEvent.screenY) : $d670b54f7076e4a4$var$lastMovementY = $d670b54f7076e4a4$var$lastMovementX = 0, $d670b54f7076e4a4$var$lastMouseEvent = event);
        return $d670b54f7076e4a4$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $d670b54f7076e4a4$var$lastMovementY;
    }
}), $d670b54f7076e4a4$var$SyntheticMouseEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$MouseEventInterface), $d670b54f7076e4a4$var$DragEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$MouseEventInterface, {
    dataTransfer: 0
}), $d670b54f7076e4a4$var$SyntheticDragEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$DragEventInterface), $d670b54f7076e4a4$var$FocusEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$UIEventInterface, {
    relatedTarget: 0
}), $d670b54f7076e4a4$var$SyntheticFocusEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$FocusEventInterface), $d670b54f7076e4a4$var$AnimationEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d670b54f7076e4a4$var$SyntheticAnimationEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$AnimationEventInterface), $d670b54f7076e4a4$var$ClipboardEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $d670b54f7076e4a4$var$SyntheticClipboardEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$ClipboardEventInterface), $d670b54f7076e4a4$var$CompositionEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$EventInterface, {
    data: 0
}), $d670b54f7076e4a4$var$SyntheticCompositionEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$CompositionEventInterface), $d670b54f7076e4a4$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $d670b54f7076e4a4$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $d670b54f7076e4a4$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $d670b54f7076e4a4$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $d670b54f7076e4a4$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $d670b54f7076e4a4$var$getEventModifierState() {
    return $d670b54f7076e4a4$var$modifierStateGetter;
}
var $d670b54f7076e4a4$var$KeyboardEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $d670b54f7076e4a4$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $d670b54f7076e4a4$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $d670b54f7076e4a4$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $d670b54f7076e4a4$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $d670b54f7076e4a4$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $d670b54f7076e4a4$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $d670b54f7076e4a4$var$SyntheticKeyboardEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$KeyboardEventInterface), $d670b54f7076e4a4$var$PointerEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $d670b54f7076e4a4$var$SyntheticPointerEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$PointerEventInterface), $d670b54f7076e4a4$var$TouchEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $d670b54f7076e4a4$var$getEventModifierState
}), $d670b54f7076e4a4$var$SyntheticTouchEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$TouchEventInterface), $d670b54f7076e4a4$var$TransitionEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d670b54f7076e4a4$var$SyntheticTransitionEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$TransitionEventInterface), $d670b54f7076e4a4$var$WheelEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $d670b54f7076e4a4$var$SyntheticWheelEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$WheelEventInterface), $d670b54f7076e4a4$var$ToggleEventInterface = $d670b54f7076e4a4$var$assign({}, $d670b54f7076e4a4$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $d670b54f7076e4a4$var$SyntheticToggleEvent = $d670b54f7076e4a4$var$createSyntheticEvent($d670b54f7076e4a4$var$ToggleEventInterface), $d670b54f7076e4a4$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $d670b54f7076e4a4$var$canUseCompositionEvent = $d670b54f7076e4a4$var$canUseDOM && "CompositionEvent" in window, $d670b54f7076e4a4$var$documentMode = null;
$d670b54f7076e4a4$var$canUseDOM && "documentMode" in document && ($d670b54f7076e4a4$var$documentMode = document.documentMode);
var $d670b54f7076e4a4$var$canUseTextInputEvent = $d670b54f7076e4a4$var$canUseDOM && "TextEvent" in window && !$d670b54f7076e4a4$var$documentMode, $d670b54f7076e4a4$var$useFallbackCompositionData = $d670b54f7076e4a4$var$canUseDOM && (!$d670b54f7076e4a4$var$canUseCompositionEvent || $d670b54f7076e4a4$var$documentMode && 8 < $d670b54f7076e4a4$var$documentMode && 11 >= $d670b54f7076e4a4$var$documentMode), $d670b54f7076e4a4$var$SPACEBAR_CHAR = String.fromCharCode(32), $d670b54f7076e4a4$var$hasSpaceKeypress = !1;
function $d670b54f7076e4a4$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $d670b54f7076e4a4$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $d670b54f7076e4a4$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $d670b54f7076e4a4$var$isComposing = !1;
function $d670b54f7076e4a4$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $d670b54f7076e4a4$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $d670b54f7076e4a4$var$hasSpaceKeypress = !0;
            return $d670b54f7076e4a4$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $d670b54f7076e4a4$var$SPACEBAR_CHAR && $d670b54f7076e4a4$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $d670b54f7076e4a4$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($d670b54f7076e4a4$var$isComposing) return "compositionend" === domEventName || !$d670b54f7076e4a4$var$canUseCompositionEvent && $d670b54f7076e4a4$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $d670b54f7076e4a4$var$getData(), $d670b54f7076e4a4$var$fallbackText = $d670b54f7076e4a4$var$startText = $d670b54f7076e4a4$var$root = null, $d670b54f7076e4a4$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $d670b54f7076e4a4$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $d670b54f7076e4a4$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $d670b54f7076e4a4$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$d670b54f7076e4a4$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $d670b54f7076e4a4$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $d670b54f7076e4a4$var$restoreTarget ? $d670b54f7076e4a4$var$restoreQueue ? $d670b54f7076e4a4$var$restoreQueue.push(target) : $d670b54f7076e4a4$var$restoreQueue = [
        target
    ] : $d670b54f7076e4a4$var$restoreTarget = target;
    inst = $d670b54f7076e4a4$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $d670b54f7076e4a4$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $d670b54f7076e4a4$var$activeElement$1 = null, $d670b54f7076e4a4$var$activeElementInst$1 = null;
function $d670b54f7076e4a4$var$runEventInBatch(dispatchQueue) {
    $d670b54f7076e4a4$var$processDispatchQueue(dispatchQueue, 0);
}
function $d670b54f7076e4a4$var$getInstIfValueChanged(targetInst) {
    var targetNode = $d670b54f7076e4a4$var$getNodeFromInstance(targetInst);
    if ($d670b54f7076e4a4$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $d670b54f7076e4a4$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $d670b54f7076e4a4$var$isInputEventSupported = !1;
if ($d670b54f7076e4a4$var$canUseDOM) {
    var $d670b54f7076e4a4$var$JSCompiler_inline_result$jscomp$286;
    if ($d670b54f7076e4a4$var$canUseDOM) {
        var $d670b54f7076e4a4$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$d670b54f7076e4a4$var$isSupported$jscomp$inline_427) {
            var $d670b54f7076e4a4$var$element$jscomp$inline_428 = document.createElement("div");
            $d670b54f7076e4a4$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $d670b54f7076e4a4$var$isSupported$jscomp$inline_427 = "function" === typeof $d670b54f7076e4a4$var$element$jscomp$inline_428.oninput;
        }
        $d670b54f7076e4a4$var$JSCompiler_inline_result$jscomp$286 = $d670b54f7076e4a4$var$isSupported$jscomp$inline_427;
    } else $d670b54f7076e4a4$var$JSCompiler_inline_result$jscomp$286 = !1;
    $d670b54f7076e4a4$var$isInputEventSupported = $d670b54f7076e4a4$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $d670b54f7076e4a4$var$stopWatchingForValueChange() {
    $d670b54f7076e4a4$var$activeElement$1 && ($d670b54f7076e4a4$var$activeElement$1.detachEvent("onpropertychange", $d670b54f7076e4a4$var$handlePropertyChange), $d670b54f7076e4a4$var$activeElementInst$1 = $d670b54f7076e4a4$var$activeElement$1 = null);
}
function $d670b54f7076e4a4$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $d670b54f7076e4a4$var$getInstIfValueChanged($d670b54f7076e4a4$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $d670b54f7076e4a4$var$createAndAccumulateChangeEvent(dispatchQueue, $d670b54f7076e4a4$var$activeElementInst$1, nativeEvent, $d670b54f7076e4a4$var$getEventTarget(nativeEvent));
        $d670b54f7076e4a4$var$batchedUpdates$1($d670b54f7076e4a4$var$runEventInBatch, dispatchQueue);
    }
}
function $d670b54f7076e4a4$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($d670b54f7076e4a4$var$stopWatchingForValueChange(), $d670b54f7076e4a4$var$activeElement$1 = target, $d670b54f7076e4a4$var$activeElementInst$1 = targetInst, $d670b54f7076e4a4$var$activeElement$1.attachEvent("onpropertychange", $d670b54f7076e4a4$var$handlePropertyChange)) : "focusout" === domEventName && $d670b54f7076e4a4$var$stopWatchingForValueChange();
}
function $d670b54f7076e4a4$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $d670b54f7076e4a4$var$getInstIfValueChanged($d670b54f7076e4a4$var$activeElementInst$1);
}
function $d670b54f7076e4a4$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $d670b54f7076e4a4$var$getInstIfValueChanged(targetInst);
}
function $d670b54f7076e4a4$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $d670b54f7076e4a4$var$getInstIfValueChanged(targetInst);
}
function $d670b54f7076e4a4$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d670b54f7076e4a4$var$objectIs = "function" === typeof Object.is ? Object.is : $d670b54f7076e4a4$var$is;
function $d670b54f7076e4a4$var$shallowEqual(objA, objB) {
    if ($d670b54f7076e4a4$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$d670b54f7076e4a4$var$hasOwnProperty.call(objB, currentKey) || !$d670b54f7076e4a4$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $d670b54f7076e4a4$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $d670b54f7076e4a4$var$getNodeForCharacterOffset(root, offset) {
    var node = $d670b54f7076e4a4$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $d670b54f7076e4a4$var$getLeafNode(node);
    }
}
function $d670b54f7076e4a4$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $d670b54f7076e4a4$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $d670b54f7076e4a4$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $d670b54f7076e4a4$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $d670b54f7076e4a4$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $d670b54f7076e4a4$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $d670b54f7076e4a4$var$skipSelectionChangeEvent = $d670b54f7076e4a4$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $d670b54f7076e4a4$var$activeElement = null, $d670b54f7076e4a4$var$activeElementInst = null, $d670b54f7076e4a4$var$lastSelection = null, $d670b54f7076e4a4$var$mouseDown = !1;
function $d670b54f7076e4a4$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $d670b54f7076e4a4$var$mouseDown || null == $d670b54f7076e4a4$var$activeElement || $d670b54f7076e4a4$var$activeElement !== $d670b54f7076e4a4$var$getActiveElement(doc) || (doc = $d670b54f7076e4a4$var$activeElement, "selectionStart" in doc && $d670b54f7076e4a4$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $d670b54f7076e4a4$var$lastSelection && $d670b54f7076e4a4$var$shallowEqual($d670b54f7076e4a4$var$lastSelection, doc) || ($d670b54f7076e4a4$var$lastSelection = doc, doc = $d670b54f7076e4a4$var$accumulateTwoPhaseListeners($d670b54f7076e4a4$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $d670b54f7076e4a4$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $d670b54f7076e4a4$var$activeElement)));
}
function $d670b54f7076e4a4$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $d670b54f7076e4a4$var$vendorPrefixes = {
    animationend: $d670b54f7076e4a4$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $d670b54f7076e4a4$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $d670b54f7076e4a4$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $d670b54f7076e4a4$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $d670b54f7076e4a4$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $d670b54f7076e4a4$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $d670b54f7076e4a4$var$makePrefixMap("Transition", "TransitionEnd")
}, $d670b54f7076e4a4$var$prefixedEventNames = {}, $d670b54f7076e4a4$var$style = {};
$d670b54f7076e4a4$var$canUseDOM && ($d670b54f7076e4a4$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $d670b54f7076e4a4$var$vendorPrefixes.animationend.animation, delete $d670b54f7076e4a4$var$vendorPrefixes.animationiteration.animation, delete $d670b54f7076e4a4$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $d670b54f7076e4a4$var$vendorPrefixes.transitionend.transition);
function $d670b54f7076e4a4$var$getVendorPrefixedEventName(eventName) {
    if ($d670b54f7076e4a4$var$prefixedEventNames[eventName]) return $d670b54f7076e4a4$var$prefixedEventNames[eventName];
    if (!$d670b54f7076e4a4$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $d670b54f7076e4a4$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $d670b54f7076e4a4$var$style) return $d670b54f7076e4a4$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $d670b54f7076e4a4$var$ANIMATION_END = $d670b54f7076e4a4$var$getVendorPrefixedEventName("animationend"), $d670b54f7076e4a4$var$ANIMATION_ITERATION = $d670b54f7076e4a4$var$getVendorPrefixedEventName("animationiteration"), $d670b54f7076e4a4$var$ANIMATION_START = $d670b54f7076e4a4$var$getVendorPrefixedEventName("animationstart"), $d670b54f7076e4a4$var$TRANSITION_RUN = $d670b54f7076e4a4$var$getVendorPrefixedEventName("transitionrun"), $d670b54f7076e4a4$var$TRANSITION_START = $d670b54f7076e4a4$var$getVendorPrefixedEventName("transitionstart"), $d670b54f7076e4a4$var$TRANSITION_CANCEL = $d670b54f7076e4a4$var$getVendorPrefixedEventName("transitioncancel"), $d670b54f7076e4a4$var$TRANSITION_END = $d670b54f7076e4a4$var$getVendorPrefixedEventName("transitionend"), $d670b54f7076e4a4$var$topLevelEventsToReactNames = new Map(), $d670b54f7076e4a4$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$d670b54f7076e4a4$var$simpleEventPluginEvents.push("scrollEnd");
function $d670b54f7076e4a4$var$registerSimpleEvent(domEventName, reactName) {
    $d670b54f7076e4a4$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $d670b54f7076e4a4$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $d670b54f7076e4a4$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $d670b54f7076e4a4$var$concurrentQueues = [], $d670b54f7076e4a4$var$concurrentQueuesIndex = 0, $d670b54f7076e4a4$var$concurrentlyUpdatedLanes = 0;
function $d670b54f7076e4a4$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $d670b54f7076e4a4$var$concurrentQueuesIndex, i = $d670b54f7076e4a4$var$concurrentlyUpdatedLanes = $d670b54f7076e4a4$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $d670b54f7076e4a4$var$concurrentQueues[i];
        $d670b54f7076e4a4$var$concurrentQueues[i++] = null;
        var queue = $d670b54f7076e4a4$var$concurrentQueues[i];
        $d670b54f7076e4a4$var$concurrentQueues[i++] = null;
        var update = $d670b54f7076e4a4$var$concurrentQueues[i];
        $d670b54f7076e4a4$var$concurrentQueues[i++] = null;
        var lane = $d670b54f7076e4a4$var$concurrentQueues[i];
        $d670b54f7076e4a4$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $d670b54f7076e4a4$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $d670b54f7076e4a4$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $d670b54f7076e4a4$var$concurrentQueues[$d670b54f7076e4a4$var$concurrentQueuesIndex++] = fiber;
    $d670b54f7076e4a4$var$concurrentQueues[$d670b54f7076e4a4$var$concurrentQueuesIndex++] = queue;
    $d670b54f7076e4a4$var$concurrentQueues[$d670b54f7076e4a4$var$concurrentQueuesIndex++] = update;
    $d670b54f7076e4a4$var$concurrentQueues[$d670b54f7076e4a4$var$concurrentQueuesIndex++] = lane;
    $d670b54f7076e4a4$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $d670b54f7076e4a4$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $d670b54f7076e4a4$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $d670b54f7076e4a4$var$getRootForUpdatedFiber(fiber);
}
function $d670b54f7076e4a4$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $d670b54f7076e4a4$var$enqueueUpdate$1(fiber, null, null, lane);
    return $d670b54f7076e4a4$var$getRootForUpdatedFiber(fiber);
}
function $d670b54f7076e4a4$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $d670b54f7076e4a4$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $d670b54f7076e4a4$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $d670b54f7076e4a4$var$nestedUpdateCount) throw $d670b54f7076e4a4$var$nestedUpdateCount = 0, $d670b54f7076e4a4$var$rootWithNestedUpdates = null, Error($d670b54f7076e4a4$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $d670b54f7076e4a4$var$emptyContextObject = {};
function $d670b54f7076e4a4$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $d670b54f7076e4a4$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $d670b54f7076e4a4$var$FiberNode(tag, pendingProps, key, mode);
}
function $d670b54f7076e4a4$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $d670b54f7076e4a4$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $d670b54f7076e4a4$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $d670b54f7076e4a4$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $d670b54f7076e4a4$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $d670b54f7076e4a4$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $d670b54f7076e4a4$var$isHostHoistableType(type, pendingProps, $d670b54f7076e4a4$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $d670b54f7076e4a4$var$REACT_ACTIVITY_TYPE:
            return type = $d670b54f7076e4a4$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $d670b54f7076e4a4$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $d670b54f7076e4a4$var$REACT_FRAGMENT_TYPE:
            return $d670b54f7076e4a4$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $d670b54f7076e4a4$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $d670b54f7076e4a4$var$REACT_PROFILER_TYPE:
            return type = $d670b54f7076e4a4$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $d670b54f7076e4a4$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $d670b54f7076e4a4$var$REACT_SUSPENSE_TYPE:
            return type = $d670b54f7076e4a4$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $d670b54f7076e4a4$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $d670b54f7076e4a4$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $d670b54f7076e4a4$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $d670b54f7076e4a4$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $d670b54f7076e4a4$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $d670b54f7076e4a4$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $d670b54f7076e4a4$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $d670b54f7076e4a4$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $d670b54f7076e4a4$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($d670b54f7076e4a4$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $d670b54f7076e4a4$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $d670b54f7076e4a4$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $d670b54f7076e4a4$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $d670b54f7076e4a4$var$createFiberFromText(content, mode, lanes) {
    content = $d670b54f7076e4a4$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $d670b54f7076e4a4$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $d670b54f7076e4a4$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $d670b54f7076e4a4$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $d670b54f7076e4a4$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $d670b54f7076e4a4$var$CapturedStacks = new WeakMap();
function $d670b54f7076e4a4$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $d670b54f7076e4a4$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $d670b54f7076e4a4$var$getStackByFiberInDevAndProd(source)
        };
        $d670b54f7076e4a4$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $d670b54f7076e4a4$var$getStackByFiberInDevAndProd(source)
    };
}
var $d670b54f7076e4a4$var$forkStack = [], $d670b54f7076e4a4$var$forkStackIndex = 0, $d670b54f7076e4a4$var$treeForkProvider = null, $d670b54f7076e4a4$var$treeForkCount = 0, $d670b54f7076e4a4$var$idStack = [], $d670b54f7076e4a4$var$idStackIndex = 0, $d670b54f7076e4a4$var$treeContextProvider = null, $d670b54f7076e4a4$var$treeContextId = 1, $d670b54f7076e4a4$var$treeContextOverflow = "";
function $d670b54f7076e4a4$var$pushTreeFork(workInProgress, totalChildren) {
    $d670b54f7076e4a4$var$forkStack[$d670b54f7076e4a4$var$forkStackIndex++] = $d670b54f7076e4a4$var$treeForkCount;
    $d670b54f7076e4a4$var$forkStack[$d670b54f7076e4a4$var$forkStackIndex++] = $d670b54f7076e4a4$var$treeForkProvider;
    $d670b54f7076e4a4$var$treeForkProvider = workInProgress;
    $d670b54f7076e4a4$var$treeForkCount = totalChildren;
}
function $d670b54f7076e4a4$var$pushTreeId(workInProgress, totalChildren, index) {
    $d670b54f7076e4a4$var$idStack[$d670b54f7076e4a4$var$idStackIndex++] = $d670b54f7076e4a4$var$treeContextId;
    $d670b54f7076e4a4$var$idStack[$d670b54f7076e4a4$var$idStackIndex++] = $d670b54f7076e4a4$var$treeContextOverflow;
    $d670b54f7076e4a4$var$idStack[$d670b54f7076e4a4$var$idStackIndex++] = $d670b54f7076e4a4$var$treeContextProvider;
    $d670b54f7076e4a4$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $d670b54f7076e4a4$var$treeContextId;
    workInProgress = $d670b54f7076e4a4$var$treeContextOverflow;
    var baseLength = 32 - $d670b54f7076e4a4$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $d670b54f7076e4a4$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $d670b54f7076e4a4$var$treeContextId = 1 << 32 - $d670b54f7076e4a4$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $d670b54f7076e4a4$var$treeContextOverflow = length + workInProgress;
    } else $d670b54f7076e4a4$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $d670b54f7076e4a4$var$treeContextOverflow = workInProgress;
}
function $d670b54f7076e4a4$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($d670b54f7076e4a4$var$pushTreeFork(workInProgress, 1), $d670b54f7076e4a4$var$pushTreeId(workInProgress, 1, 0));
}
function $d670b54f7076e4a4$var$popTreeContext(workInProgress) {
    for(; workInProgress === $d670b54f7076e4a4$var$treeForkProvider;)$d670b54f7076e4a4$var$treeForkProvider = $d670b54f7076e4a4$var$forkStack[--$d670b54f7076e4a4$var$forkStackIndex], $d670b54f7076e4a4$var$forkStack[$d670b54f7076e4a4$var$forkStackIndex] = null, $d670b54f7076e4a4$var$treeForkCount = $d670b54f7076e4a4$var$forkStack[--$d670b54f7076e4a4$var$forkStackIndex], $d670b54f7076e4a4$var$forkStack[$d670b54f7076e4a4$var$forkStackIndex] = null;
    for(; workInProgress === $d670b54f7076e4a4$var$treeContextProvider;)$d670b54f7076e4a4$var$treeContextProvider = $d670b54f7076e4a4$var$idStack[--$d670b54f7076e4a4$var$idStackIndex], $d670b54f7076e4a4$var$idStack[$d670b54f7076e4a4$var$idStackIndex] = null, $d670b54f7076e4a4$var$treeContextOverflow = $d670b54f7076e4a4$var$idStack[--$d670b54f7076e4a4$var$idStackIndex], $d670b54f7076e4a4$var$idStack[$d670b54f7076e4a4$var$idStackIndex] = null, $d670b54f7076e4a4$var$treeContextId = $d670b54f7076e4a4$var$idStack[--$d670b54f7076e4a4$var$idStackIndex], $d670b54f7076e4a4$var$idStack[$d670b54f7076e4a4$var$idStackIndex] = null;
}
function $d670b54f7076e4a4$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $d670b54f7076e4a4$var$idStack[$d670b54f7076e4a4$var$idStackIndex++] = $d670b54f7076e4a4$var$treeContextId;
    $d670b54f7076e4a4$var$idStack[$d670b54f7076e4a4$var$idStackIndex++] = $d670b54f7076e4a4$var$treeContextOverflow;
    $d670b54f7076e4a4$var$idStack[$d670b54f7076e4a4$var$idStackIndex++] = $d670b54f7076e4a4$var$treeContextProvider;
    $d670b54f7076e4a4$var$treeContextId = suspendedContext.id;
    $d670b54f7076e4a4$var$treeContextOverflow = suspendedContext.overflow;
    $d670b54f7076e4a4$var$treeContextProvider = workInProgress;
}
var $d670b54f7076e4a4$var$hydrationParentFiber = null, $d670b54f7076e4a4$var$nextHydratableInstance = null, $d670b54f7076e4a4$var$isHydrating = !1, $d670b54f7076e4a4$var$hydrationErrors = null, $d670b54f7076e4a4$var$rootOrSingletonContext = !1, $d670b54f7076e4a4$var$HydrationMismatchException = Error($d670b54f7076e4a4$var$formatProdErrorMessage(519));
function $d670b54f7076e4a4$var$throwOnHydrationMismatch(fiber) {
    var error = Error($d670b54f7076e4a4$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $d670b54f7076e4a4$var$queueHydrationError($d670b54f7076e4a4$var$createCapturedValueAtFiber(error, fiber));
    throw $d670b54f7076e4a4$var$HydrationMismatchException;
}
function $d670b54f7076e4a4$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$d670b54f7076e4a4$var$internalInstanceKey] = fiber;
    instance[$d670b54f7076e4a4$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("cancel", instance);
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $d670b54f7076e4a4$var$mediaEventTypes.length; type++)$d670b54f7076e4a4$var$listenToNonDelegatedEvent($d670b54f7076e4a4$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("error", instance);
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("invalid", instance);
            $d670b54f7076e4a4$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("invalid", instance), $d670b54f7076e4a4$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $d670b54f7076e4a4$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($d670b54f7076e4a4$var$listenToNonDelegatedEvent("beforetoggle", instance), $d670b54f7076e4a4$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $d670b54f7076e4a4$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $d670b54f7076e4a4$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $d670b54f7076e4a4$var$noop$1), instance = !0) : instance = !1;
    instance || $d670b54f7076e4a4$var$throwOnHydrationMismatch(fiber, !0);
}
function $d670b54f7076e4a4$var$popToNextHostParent(fiber) {
    for($d670b54f7076e4a4$var$hydrationParentFiber = fiber.return; $d670b54f7076e4a4$var$hydrationParentFiber;)switch($d670b54f7076e4a4$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $d670b54f7076e4a4$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $d670b54f7076e4a4$var$rootOrSingletonContext = !0;
            return;
        default:
            $d670b54f7076e4a4$var$hydrationParentFiber = $d670b54f7076e4a4$var$hydrationParentFiber.return;
    }
}
function $d670b54f7076e4a4$var$popHydrationState(fiber) {
    if (fiber !== $d670b54f7076e4a4$var$hydrationParentFiber) return !1;
    if (!$d670b54f7076e4a4$var$isHydrating) return $d670b54f7076e4a4$var$popToNextHostParent(fiber), $d670b54f7076e4a4$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $d670b54f7076e4a4$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $d670b54f7076e4a4$var$nextHydratableInstance && $d670b54f7076e4a4$var$throwOnHydrationMismatch(fiber);
    $d670b54f7076e4a4$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(317));
        $d670b54f7076e4a4$var$nextHydratableInstance = $d670b54f7076e4a4$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(317));
        $d670b54f7076e4a4$var$nextHydratableInstance = $d670b54f7076e4a4$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $d670b54f7076e4a4$var$nextHydratableInstance, $d670b54f7076e4a4$var$isSingletonScope(fiber.type) ? (fiber = $d670b54f7076e4a4$var$previousHydratableOnEnteringScopedSingleton, $d670b54f7076e4a4$var$previousHydratableOnEnteringScopedSingleton = null, $d670b54f7076e4a4$var$nextHydratableInstance = fiber) : $d670b54f7076e4a4$var$nextHydratableInstance = tag) : $d670b54f7076e4a4$var$nextHydratableInstance = $d670b54f7076e4a4$var$hydrationParentFiber ? $d670b54f7076e4a4$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $d670b54f7076e4a4$var$resetHydrationState() {
    $d670b54f7076e4a4$var$nextHydratableInstance = $d670b54f7076e4a4$var$hydrationParentFiber = null;
    $d670b54f7076e4a4$var$isHydrating = !1;
}
function $d670b54f7076e4a4$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $d670b54f7076e4a4$var$hydrationErrors;
    null !== queuedErrors && (null === $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors ? $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors = queuedErrors : $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors.push.apply($d670b54f7076e4a4$var$workInProgressRootRecoverableErrors, queuedErrors), $d670b54f7076e4a4$var$hydrationErrors = null);
    return queuedErrors;
}
function $d670b54f7076e4a4$var$queueHydrationError(error) {
    null === $d670b54f7076e4a4$var$hydrationErrors ? $d670b54f7076e4a4$var$hydrationErrors = [
        error
    ] : $d670b54f7076e4a4$var$hydrationErrors.push(error);
}
var $d670b54f7076e4a4$var$valueCursor = $d670b54f7076e4a4$var$createCursor(null), $d670b54f7076e4a4$var$currentlyRenderingFiber$1 = null, $d670b54f7076e4a4$var$lastContextDependency = null;
function $d670b54f7076e4a4$var$pushProvider(providerFiber, context, nextValue) {
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $d670b54f7076e4a4$var$popProvider(context) {
    context._currentValue = $d670b54f7076e4a4$var$valueCursor.current;
    $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$valueCursor);
}
function $d670b54f7076e4a4$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $d670b54f7076e4a4$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $d670b54f7076e4a4$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $d670b54f7076e4a4$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $d670b54f7076e4a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $d670b54f7076e4a4$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $d670b54f7076e4a4$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($d670b54f7076e4a4$var$HostTransitionContext) : current = [
                $d670b54f7076e4a4$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $d670b54f7076e4a4$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $d670b54f7076e4a4$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$d670b54f7076e4a4$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $d670b54f7076e4a4$var$prepareToReadContext(workInProgress) {
    $d670b54f7076e4a4$var$currentlyRenderingFiber$1 = workInProgress;
    $d670b54f7076e4a4$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $d670b54f7076e4a4$var$readContext(context) {
    return $d670b54f7076e4a4$var$readContextForConsumer($d670b54f7076e4a4$var$currentlyRenderingFiber$1, context);
}
function $d670b54f7076e4a4$var$readContextDuringReconciliation(consumer, context) {
    null === $d670b54f7076e4a4$var$currentlyRenderingFiber$1 && $d670b54f7076e4a4$var$prepareToReadContext(consumer);
    return $d670b54f7076e4a4$var$readContextForConsumer(consumer, context);
}
function $d670b54f7076e4a4$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $d670b54f7076e4a4$var$lastContextDependency) {
        if (null === consumer) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(308));
        $d670b54f7076e4a4$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $d670b54f7076e4a4$var$lastContextDependency = $d670b54f7076e4a4$var$lastContextDependency.next = context;
    return value;
}
var $d670b54f7076e4a4$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $d670b54f7076e4a4$var$scheduleCallback$2 = $jztx6.unstable_scheduleCallback, $d670b54f7076e4a4$var$NormalPriority = $jztx6.unstable_NormalPriority, $d670b54f7076e4a4$var$CacheContext = {
    $$typeof: $d670b54f7076e4a4$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $d670b54f7076e4a4$var$createCache() {
    return {
        controller: new $d670b54f7076e4a4$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $d670b54f7076e4a4$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $d670b54f7076e4a4$var$scheduleCallback$2($d670b54f7076e4a4$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $d670b54f7076e4a4$var$currentEntangledListeners = null, $d670b54f7076e4a4$var$currentEntangledPendingCount = 0, $d670b54f7076e4a4$var$currentEntangledLane = 0, $d670b54f7076e4a4$var$currentEntangledActionThenable = null;
function $d670b54f7076e4a4$var$entangleAsyncAction(transition, thenable) {
    if (null === $d670b54f7076e4a4$var$currentEntangledListeners) {
        var entangledListeners = $d670b54f7076e4a4$var$currentEntangledListeners = [];
        $d670b54f7076e4a4$var$currentEntangledPendingCount = 0;
        $d670b54f7076e4a4$var$currentEntangledLane = $d670b54f7076e4a4$var$requestTransitionLane();
        $d670b54f7076e4a4$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $d670b54f7076e4a4$var$currentEntangledPendingCount++;
    thenable.then($d670b54f7076e4a4$var$pingEngtangledActionScope, $d670b54f7076e4a4$var$pingEngtangledActionScope);
    return thenable;
}
function $d670b54f7076e4a4$var$pingEngtangledActionScope() {
    if (0 === --$d670b54f7076e4a4$var$currentEntangledPendingCount && null !== $d670b54f7076e4a4$var$currentEntangledListeners) {
        null !== $d670b54f7076e4a4$var$currentEntangledActionThenable && ($d670b54f7076e4a4$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $d670b54f7076e4a4$var$currentEntangledListeners;
        $d670b54f7076e4a4$var$currentEntangledListeners = null;
        $d670b54f7076e4a4$var$currentEntangledLane = 0;
        $d670b54f7076e4a4$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $d670b54f7076e4a4$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $d670b54f7076e4a4$var$prevOnStartTransitionFinish = $d670b54f7076e4a4$var$ReactSharedInternals.S;
$d670b54f7076e4a4$var$ReactSharedInternals.S = function(transition, returnValue) {
    $d670b54f7076e4a4$var$globalMostRecentTransitionTime = $d670b54f7076e4a4$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $d670b54f7076e4a4$var$entangleAsyncAction(transition, returnValue);
    null !== $d670b54f7076e4a4$var$prevOnStartTransitionFinish && $d670b54f7076e4a4$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $d670b54f7076e4a4$var$resumedCache = $d670b54f7076e4a4$var$createCursor(null);
function $d670b54f7076e4a4$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $d670b54f7076e4a4$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $d670b54f7076e4a4$var$workInProgressRoot.pooledCache;
}
function $d670b54f7076e4a4$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$resumedCache, $d670b54f7076e4a4$var$resumedCache.current) : $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$resumedCache, prevCachePool.pool);
}
function $d670b54f7076e4a4$var$getSuspendedCache() {
    var cacheFromPool = $d670b54f7076e4a4$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $d670b54f7076e4a4$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $d670b54f7076e4a4$var$SuspenseException = Error($d670b54f7076e4a4$var$formatProdErrorMessage(460)), $d670b54f7076e4a4$var$SuspenseyCommitException = Error($d670b54f7076e4a4$var$formatProdErrorMessage(474)), $d670b54f7076e4a4$var$SuspenseActionException = Error($d670b54f7076e4a4$var$formatProdErrorMessage(542)), $d670b54f7076e4a4$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $d670b54f7076e4a4$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $d670b54f7076e4a4$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($d670b54f7076e4a4$var$noop$1, $d670b54f7076e4a4$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $d670b54f7076e4a4$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($d670b54f7076e4a4$var$noop$1, $d670b54f7076e4a4$var$noop$1);
            else {
                thenableState = $d670b54f7076e4a4$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $d670b54f7076e4a4$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $d670b54f7076e4a4$var$suspendedThenable = thenable;
            throw $d670b54f7076e4a4$var$SuspenseException;
    }
}
function $d670b54f7076e4a4$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $d670b54f7076e4a4$var$suspendedThenable = x, $d670b54f7076e4a4$var$SuspenseException;
        throw x;
    }
}
var $d670b54f7076e4a4$var$suspendedThenable = null;
function $d670b54f7076e4a4$var$getSuspendedThenable() {
    if (null === $d670b54f7076e4a4$var$suspendedThenable) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(459));
    var thenable = $d670b54f7076e4a4$var$suspendedThenable;
    $d670b54f7076e4a4$var$suspendedThenable = null;
    return thenable;
}
function $d670b54f7076e4a4$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $d670b54f7076e4a4$var$SuspenseException || rejectedReason === $d670b54f7076e4a4$var$SuspenseActionException) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(483));
}
var $d670b54f7076e4a4$var$thenableState$1 = null, $d670b54f7076e4a4$var$thenableIndexCounter$1 = 0;
function $d670b54f7076e4a4$var$unwrapThenable(thenable) {
    var index = $d670b54f7076e4a4$var$thenableIndexCounter$1;
    $d670b54f7076e4a4$var$thenableIndexCounter$1 += 1;
    null === $d670b54f7076e4a4$var$thenableState$1 && ($d670b54f7076e4a4$var$thenableState$1 = []);
    return $d670b54f7076e4a4$var$trackUsedThenable($d670b54f7076e4a4$var$thenableState$1, thenable, index);
}
function $d670b54f7076e4a4$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $d670b54f7076e4a4$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $d670b54f7076e4a4$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $d670b54f7076e4a4$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $d670b54f7076e4a4$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $d670b54f7076e4a4$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $d670b54f7076e4a4$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $d670b54f7076e4a4$var$REACT_LAZY_TYPE && $d670b54f7076e4a4$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $d670b54f7076e4a4$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $d670b54f7076e4a4$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $d670b54f7076e4a4$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $d670b54f7076e4a4$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $d670b54f7076e4a4$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $d670b54f7076e4a4$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d670b54f7076e4a4$var$REACT_ELEMENT_TYPE:
                    return lanes = $d670b54f7076e4a4$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $d670b54f7076e4a4$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $d670b54f7076e4a4$var$REACT_PORTAL_TYPE:
                    return newChild = $d670b54f7076e4a4$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $d670b54f7076e4a4$var$REACT_LAZY_TYPE:
                    return newChild = $d670b54f7076e4a4$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($d670b54f7076e4a4$var$isArrayImpl(newChild) || $d670b54f7076e4a4$var$getIteratorFn(newChild)) return newChild = $d670b54f7076e4a4$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $d670b54f7076e4a4$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d670b54f7076e4a4$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $d670b54f7076e4a4$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d670b54f7076e4a4$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d670b54f7076e4a4$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $d670b54f7076e4a4$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $d670b54f7076e4a4$var$REACT_LAZY_TYPE:
                    return newChild = $d670b54f7076e4a4$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($d670b54f7076e4a4$var$isArrayImpl(newChild) || $d670b54f7076e4a4$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $d670b54f7076e4a4$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d670b54f7076e4a4$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $d670b54f7076e4a4$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d670b54f7076e4a4$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d670b54f7076e4a4$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $d670b54f7076e4a4$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $d670b54f7076e4a4$var$REACT_LAZY_TYPE:
                    return newChild = $d670b54f7076e4a4$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($d670b54f7076e4a4$var$isArrayImpl(newChild) || $d670b54f7076e4a4$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $d670b54f7076e4a4$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d670b54f7076e4a4$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $d670b54f7076e4a4$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d670b54f7076e4a4$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $d670b54f7076e4a4$var$isHydrating && $d670b54f7076e4a4$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $d670b54f7076e4a4$var$isHydrating && $d670b54f7076e4a4$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $d670b54f7076e4a4$var$isHydrating && $d670b54f7076e4a4$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $d670b54f7076e4a4$var$isHydrating && $d670b54f7076e4a4$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $d670b54f7076e4a4$var$isHydrating && $d670b54f7076e4a4$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $d670b54f7076e4a4$var$isHydrating && $d670b54f7076e4a4$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $d670b54f7076e4a4$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d670b54f7076e4a4$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $d670b54f7076e4a4$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $d670b54f7076e4a4$var$REACT_LAZY_TYPE && $d670b54f7076e4a4$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $d670b54f7076e4a4$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $d670b54f7076e4a4$var$REACT_FRAGMENT_TYPE ? (lanes = $d670b54f7076e4a4$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $d670b54f7076e4a4$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $d670b54f7076e4a4$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $d670b54f7076e4a4$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $d670b54f7076e4a4$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $d670b54f7076e4a4$var$REACT_LAZY_TYPE:
                    return newChild = $d670b54f7076e4a4$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($d670b54f7076e4a4$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($d670b54f7076e4a4$var$getIteratorFn(newChild)) {
                key = $d670b54f7076e4a4$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $d670b54f7076e4a4$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d670b54f7076e4a4$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $d670b54f7076e4a4$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d670b54f7076e4a4$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $d670b54f7076e4a4$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $d670b54f7076e4a4$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $d670b54f7076e4a4$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $d670b54f7076e4a4$var$SuspenseException || x === $d670b54f7076e4a4$var$SuspenseActionException) throw x;
            var fiber = $d670b54f7076e4a4$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $d670b54f7076e4a4$var$reconcileChildFibers = $d670b54f7076e4a4$var$createChildReconciler(!0), $d670b54f7076e4a4$var$mountChildFibers = $d670b54f7076e4a4$var$createChildReconciler(!1), $d670b54f7076e4a4$var$hasForceUpdate = !1;
function $d670b54f7076e4a4$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $d670b54f7076e4a4$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $d670b54f7076e4a4$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $d670b54f7076e4a4$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($d670b54f7076e4a4$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $d670b54f7076e4a4$var$getRootForUpdatedFiber(fiber);
        $d670b54f7076e4a4$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $d670b54f7076e4a4$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $d670b54f7076e4a4$var$getRootForUpdatedFiber(fiber);
}
function $d670b54f7076e4a4$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $d670b54f7076e4a4$var$markRootEntangled(root, lane);
    }
}
function $d670b54f7076e4a4$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $d670b54f7076e4a4$var$didReadFromEntangledAsyncAction = !1;
function $d670b54f7076e4a4$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($d670b54f7076e4a4$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $d670b54f7076e4a4$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $d670b54f7076e4a4$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $d670b54f7076e4a4$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $d670b54f7076e4a4$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $d670b54f7076e4a4$var$currentEntangledLane && ($d670b54f7076e4a4$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $d670b54f7076e4a4$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $d670b54f7076e4a4$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $d670b54f7076e4a4$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $d670b54f7076e4a4$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $d670b54f7076e4a4$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$d670b54f7076e4a4$var$callCallback(callbacks[updateQueue], context);
}
var $d670b54f7076e4a4$var$currentTreeHiddenStackCursor = $d670b54f7076e4a4$var$createCursor(null), $d670b54f7076e4a4$var$prevEntangledRenderLanesCursor = $d670b54f7076e4a4$var$createCursor(0);
function $d670b54f7076e4a4$var$pushHiddenContext(fiber, context) {
    fiber = $d670b54f7076e4a4$var$entangledRenderLanes;
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$prevEntangledRenderLanesCursor, fiber);
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$currentTreeHiddenStackCursor, context);
    $d670b54f7076e4a4$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $d670b54f7076e4a4$var$reuseHiddenContextOnStack() {
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$prevEntangledRenderLanesCursor, $d670b54f7076e4a4$var$entangledRenderLanes);
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$currentTreeHiddenStackCursor, $d670b54f7076e4a4$var$currentTreeHiddenStackCursor.current);
}
function $d670b54f7076e4a4$var$popHiddenContext() {
    $d670b54f7076e4a4$var$entangledRenderLanes = $d670b54f7076e4a4$var$prevEntangledRenderLanesCursor.current;
    $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$currentTreeHiddenStackCursor);
    $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$prevEntangledRenderLanesCursor);
}
var $d670b54f7076e4a4$var$suspenseHandlerStackCursor = $d670b54f7076e4a4$var$createCursor(null), $d670b54f7076e4a4$var$shellBoundary = null;
function $d670b54f7076e4a4$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseStackCursor, $d670b54f7076e4a4$var$suspenseStackCursor.current & 1);
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseHandlerStackCursor, handler);
    null === $d670b54f7076e4a4$var$shellBoundary && (null === current || null !== $d670b54f7076e4a4$var$currentTreeHiddenStackCursor.current ? $d670b54f7076e4a4$var$shellBoundary = handler : null !== current.memoizedState && ($d670b54f7076e4a4$var$shellBoundary = handler));
}
function $d670b54f7076e4a4$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseStackCursor, $d670b54f7076e4a4$var$suspenseStackCursor.current);
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseHandlerStackCursor, fiber);
    null === $d670b54f7076e4a4$var$shellBoundary && ($d670b54f7076e4a4$var$shellBoundary = fiber);
}
function $d670b54f7076e4a4$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseStackCursor, $d670b54f7076e4a4$var$suspenseStackCursor.current), $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseHandlerStackCursor, fiber), null === $d670b54f7076e4a4$var$shellBoundary && ($d670b54f7076e4a4$var$shellBoundary = fiber)) : $d670b54f7076e4a4$var$reuseSuspenseHandlerOnStack(fiber);
}
function $d670b54f7076e4a4$var$reuseSuspenseHandlerOnStack() {
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseStackCursor, $d670b54f7076e4a4$var$suspenseStackCursor.current);
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseHandlerStackCursor, $d670b54f7076e4a4$var$suspenseHandlerStackCursor.current);
}
function $d670b54f7076e4a4$var$popSuspenseHandler(fiber) {
    $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$suspenseHandlerStackCursor);
    $d670b54f7076e4a4$var$shellBoundary === fiber && ($d670b54f7076e4a4$var$shellBoundary = null);
    $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$suspenseStackCursor);
}
var $d670b54f7076e4a4$var$suspenseStackCursor = $d670b54f7076e4a4$var$createCursor(0);
function $d670b54f7076e4a4$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $d670b54f7076e4a4$var$isSuspenseInstancePending(state) || $d670b54f7076e4a4$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $d670b54f7076e4a4$var$renderLanes = 0, $d670b54f7076e4a4$var$currentlyRenderingFiber = null, $d670b54f7076e4a4$var$currentHook = null, $d670b54f7076e4a4$var$workInProgressHook = null, $d670b54f7076e4a4$var$didScheduleRenderPhaseUpdate = !1, $d670b54f7076e4a4$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $d670b54f7076e4a4$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $d670b54f7076e4a4$var$localIdCounter = 0, $d670b54f7076e4a4$var$thenableIndexCounter = 0, $d670b54f7076e4a4$var$thenableState = null, $d670b54f7076e4a4$var$globalClientIdCounter = 0;
function $d670b54f7076e4a4$var$throwInvalidHookError() {
    throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(321));
}
function $d670b54f7076e4a4$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$d670b54f7076e4a4$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $d670b54f7076e4a4$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $d670b54f7076e4a4$var$renderLanes = nextRenderLanes;
    $d670b54f7076e4a4$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $d670b54f7076e4a4$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $d670b54f7076e4a4$var$HooksDispatcherOnMount : $d670b54f7076e4a4$var$HooksDispatcherOnUpdate;
    $d670b54f7076e4a4$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $d670b54f7076e4a4$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $d670b54f7076e4a4$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $d670b54f7076e4a4$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $d670b54f7076e4a4$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $d670b54f7076e4a4$var$finishRenderingHooks(current) {
    $d670b54f7076e4a4$var$ReactSharedInternals.H = $d670b54f7076e4a4$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $d670b54f7076e4a4$var$currentHook && null !== $d670b54f7076e4a4$var$currentHook.next;
    $d670b54f7076e4a4$var$renderLanes = 0;
    $d670b54f7076e4a4$var$workInProgressHook = $d670b54f7076e4a4$var$currentHook = $d670b54f7076e4a4$var$currentlyRenderingFiber = null;
    $d670b54f7076e4a4$var$didScheduleRenderPhaseUpdate = !1;
    $d670b54f7076e4a4$var$thenableIndexCounter = 0;
    $d670b54f7076e4a4$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(300));
    null === current || $d670b54f7076e4a4$var$didReceiveUpdate || (current = current.dependencies, null !== current && $d670b54f7076e4a4$var$checkIfContextChanged(current) && ($d670b54f7076e4a4$var$didReceiveUpdate = !0));
}
function $d670b54f7076e4a4$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $d670b54f7076e4a4$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $d670b54f7076e4a4$var$didScheduleRenderPhaseUpdateDuringThisPass && ($d670b54f7076e4a4$var$thenableState = null);
        $d670b54f7076e4a4$var$thenableIndexCounter = 0;
        $d670b54f7076e4a4$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $d670b54f7076e4a4$var$workInProgressHook = $d670b54f7076e4a4$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $d670b54f7076e4a4$var$ReactSharedInternals.H = $d670b54f7076e4a4$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($d670b54f7076e4a4$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $d670b54f7076e4a4$var$TransitionAwareHostComponent() {
    var dispatcher = $d670b54f7076e4a4$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $d670b54f7076e4a4$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $d670b54f7076e4a4$var$currentHook ? $d670b54f7076e4a4$var$currentHook.memoizedState : null) !== dispatcher && ($d670b54f7076e4a4$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $d670b54f7076e4a4$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $d670b54f7076e4a4$var$localIdCounter;
    $d670b54f7076e4a4$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $d670b54f7076e4a4$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $d670b54f7076e4a4$var$resetHooksOnUnwind(workInProgress) {
    if ($d670b54f7076e4a4$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $d670b54f7076e4a4$var$didScheduleRenderPhaseUpdate = !1;
    }
    $d670b54f7076e4a4$var$renderLanes = 0;
    $d670b54f7076e4a4$var$workInProgressHook = $d670b54f7076e4a4$var$currentHook = $d670b54f7076e4a4$var$currentlyRenderingFiber = null;
    $d670b54f7076e4a4$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $d670b54f7076e4a4$var$thenableIndexCounter = $d670b54f7076e4a4$var$localIdCounter = 0;
    $d670b54f7076e4a4$var$thenableState = null;
}
function $d670b54f7076e4a4$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $d670b54f7076e4a4$var$workInProgressHook ? $d670b54f7076e4a4$var$currentlyRenderingFiber.memoizedState = $d670b54f7076e4a4$var$workInProgressHook = hook : $d670b54f7076e4a4$var$workInProgressHook = $d670b54f7076e4a4$var$workInProgressHook.next = hook;
    return $d670b54f7076e4a4$var$workInProgressHook;
}
function $d670b54f7076e4a4$var$updateWorkInProgressHook() {
    if (null === $d670b54f7076e4a4$var$currentHook) {
        var nextCurrentHook = $d670b54f7076e4a4$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $d670b54f7076e4a4$var$currentHook.next;
    var nextWorkInProgressHook = null === $d670b54f7076e4a4$var$workInProgressHook ? $d670b54f7076e4a4$var$currentlyRenderingFiber.memoizedState : $d670b54f7076e4a4$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $d670b54f7076e4a4$var$workInProgressHook = nextWorkInProgressHook, $d670b54f7076e4a4$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $d670b54f7076e4a4$var$currentlyRenderingFiber.alternate) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(467));
            throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(310));
        }
        $d670b54f7076e4a4$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $d670b54f7076e4a4$var$currentHook.memoizedState,
            baseState: $d670b54f7076e4a4$var$currentHook.baseState,
            baseQueue: $d670b54f7076e4a4$var$currentHook.baseQueue,
            queue: $d670b54f7076e4a4$var$currentHook.queue,
            next: null
        };
        null === $d670b54f7076e4a4$var$workInProgressHook ? $d670b54f7076e4a4$var$currentlyRenderingFiber.memoizedState = $d670b54f7076e4a4$var$workInProgressHook = nextCurrentHook : $d670b54f7076e4a4$var$workInProgressHook = $d670b54f7076e4a4$var$workInProgressHook.next = nextCurrentHook;
    }
    return $d670b54f7076e4a4$var$workInProgressHook;
}
function $d670b54f7076e4a4$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $d670b54f7076e4a4$var$useThenable(thenable) {
    var index = $d670b54f7076e4a4$var$thenableIndexCounter;
    $d670b54f7076e4a4$var$thenableIndexCounter += 1;
    null === $d670b54f7076e4a4$var$thenableState && ($d670b54f7076e4a4$var$thenableState = []);
    thenable = $d670b54f7076e4a4$var$trackUsedThenable($d670b54f7076e4a4$var$thenableState, thenable, index);
    index = $d670b54f7076e4a4$var$currentlyRenderingFiber;
    null === (null === $d670b54f7076e4a4$var$workInProgressHook ? index.memoizedState : $d670b54f7076e4a4$var$workInProgressHook.next) && (index = index.alternate, $d670b54f7076e4a4$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $d670b54f7076e4a4$var$HooksDispatcherOnMount : $d670b54f7076e4a4$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $d670b54f7076e4a4$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $d670b54f7076e4a4$var$useThenable(usable);
        if (usable.$$typeof === $d670b54f7076e4a4$var$REACT_CONTEXT_TYPE) return $d670b54f7076e4a4$var$readContext(usable);
    }
    throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(438, String(usable)));
}
function $d670b54f7076e4a4$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $d670b54f7076e4a4$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $d670b54f7076e4a4$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $d670b54f7076e4a4$var$createFunctionComponentUpdateQueue(), $d670b54f7076e4a4$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $d670b54f7076e4a4$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $d670b54f7076e4a4$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $d670b54f7076e4a4$var$updateReducer(reducer) {
    var hook = $d670b54f7076e4a4$var$updateWorkInProgressHook();
    return $d670b54f7076e4a4$var$updateReducerImpl(hook, $d670b54f7076e4a4$var$currentHook, reducer);
}
function $d670b54f7076e4a4$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($d670b54f7076e4a4$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $d670b54f7076e4a4$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($d670b54f7076e4a4$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $d670b54f7076e4a4$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $d670b54f7076e4a4$var$currentlyRenderingFiber.lanes |= revertLane, $d670b54f7076e4a4$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $d670b54f7076e4a4$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $d670b54f7076e4a4$var$currentlyRenderingFiber.lanes |= updateLane, $d670b54f7076e4a4$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$d670b54f7076e4a4$var$objectIs(pendingQueue, hook.memoizedState) && ($d670b54f7076e4a4$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $d670b54f7076e4a4$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $d670b54f7076e4a4$var$rerenderReducer(reducer) {
    var hook = $d670b54f7076e4a4$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $d670b54f7076e4a4$var$objectIs(newState, hook.memoizedState) || ($d670b54f7076e4a4$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $d670b54f7076e4a4$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $d670b54f7076e4a4$var$currentlyRenderingFiber, hook = $d670b54f7076e4a4$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $d670b54f7076e4a4$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$d670b54f7076e4a4$var$objectIs(($d670b54f7076e4a4$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $d670b54f7076e4a4$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $d670b54f7076e4a4$var$updateEffect($d670b54f7076e4a4$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $d670b54f7076e4a4$var$workInProgressHook && $d670b54f7076e4a4$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $d670b54f7076e4a4$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $d670b54f7076e4a4$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $d670b54f7076e4a4$var$workInProgressRoot) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($d670b54f7076e4a4$var$renderLanes & 127) || $d670b54f7076e4a4$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $d670b54f7076e4a4$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $d670b54f7076e4a4$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $d670b54f7076e4a4$var$createFunctionComponentUpdateQueue(), $d670b54f7076e4a4$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $d670b54f7076e4a4$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $d670b54f7076e4a4$var$checkIfSnapshotChanged(inst) && $d670b54f7076e4a4$var$forceStoreRerender(fiber);
}
function $d670b54f7076e4a4$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $d670b54f7076e4a4$var$checkIfSnapshotChanged(inst) && $d670b54f7076e4a4$var$forceStoreRerender(fiber);
    });
}
function $d670b54f7076e4a4$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$d670b54f7076e4a4$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $d670b54f7076e4a4$var$forceStoreRerender(fiber) {
    var root = $d670b54f7076e4a4$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $d670b54f7076e4a4$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $d670b54f7076e4a4$var$mountStateImpl(initialState) {
    var hook = $d670b54f7076e4a4$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($d670b54f7076e4a4$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $d670b54f7076e4a4$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $d670b54f7076e4a4$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d670b54f7076e4a4$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $d670b54f7076e4a4$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $d670b54f7076e4a4$var$updateReducerImpl(hook, $d670b54f7076e4a4$var$currentHook, "function" === typeof reducer ? reducer : $d670b54f7076e4a4$var$basicStateReducer);
}
function $d670b54f7076e4a4$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($d670b54f7076e4a4$var$isRenderPhaseUpdate(fiber)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $d670b54f7076e4a4$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $d670b54f7076e4a4$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $d670b54f7076e4a4$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $d670b54f7076e4a4$var$ReactSharedInternals.T, currentTransition = {};
        $d670b54f7076e4a4$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $d670b54f7076e4a4$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $d670b54f7076e4a4$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $d670b54f7076e4a4$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $d670b54f7076e4a4$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $d670b54f7076e4a4$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $d670b54f7076e4a4$var$onActionError(actionQueue, node, error$66);
    }
}
function $d670b54f7076e4a4$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $d670b54f7076e4a4$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $d670b54f7076e4a4$var$onActionError(actionQueue, node, error);
    }) : $d670b54f7076e4a4$var$onActionSuccess(actionQueue, node, returnValue);
}
function $d670b54f7076e4a4$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $d670b54f7076e4a4$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $d670b54f7076e4a4$var$runActionStateAction(actionQueue, nextState)));
}
function $d670b54f7076e4a4$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $d670b54f7076e4a4$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $d670b54f7076e4a4$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $d670b54f7076e4a4$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $d670b54f7076e4a4$var$mountActionState(action, initialStateProp) {
    if ($d670b54f7076e4a4$var$isHydrating) {
        var ssrFormState = $d670b54f7076e4a4$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $d670b54f7076e4a4$var$currentlyRenderingFiber;
                if ($d670b54f7076e4a4$var$isHydrating) {
                    if ($d670b54f7076e4a4$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $d670b54f7076e4a4$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $d670b54f7076e4a4$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $d670b54f7076e4a4$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $d670b54f7076e4a4$var$nextHydratableInstance = $d670b54f7076e4a4$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $d670b54f7076e4a4$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $d670b54f7076e4a4$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d670b54f7076e4a4$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $d670b54f7076e4a4$var$dispatchSetState.bind(null, $d670b54f7076e4a4$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $d670b54f7076e4a4$var$mountStateImpl(!1);
    inRootOrSingleton = $d670b54f7076e4a4$var$dispatchOptimisticSetState.bind(null, $d670b54f7076e4a4$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $d670b54f7076e4a4$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $d670b54f7076e4a4$var$dispatchActionState.bind(null, $d670b54f7076e4a4$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $d670b54f7076e4a4$var$updateActionState(action) {
    var stateHook = $d670b54f7076e4a4$var$updateWorkInProgressHook();
    return $d670b54f7076e4a4$var$updateActionStateImpl(stateHook, $d670b54f7076e4a4$var$currentHook, action);
}
function $d670b54f7076e4a4$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $d670b54f7076e4a4$var$updateReducerImpl(stateHook, currentStateHook, $d670b54f7076e4a4$var$actionStateReducer)[0];
    stateHook = $d670b54f7076e4a4$var$updateReducer($d670b54f7076e4a4$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $d670b54f7076e4a4$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $d670b54f7076e4a4$var$SuspenseException) throw $d670b54f7076e4a4$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $d670b54f7076e4a4$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($d670b54f7076e4a4$var$currentlyRenderingFiber.flags |= 2048, $d670b54f7076e4a4$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $d670b54f7076e4a4$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $d670b54f7076e4a4$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $d670b54f7076e4a4$var$rerenderActionState(action) {
    var stateHook = $d670b54f7076e4a4$var$updateWorkInProgressHook(), currentStateHook = $d670b54f7076e4a4$var$currentHook;
    if (null !== currentStateHook) return $d670b54f7076e4a4$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $d670b54f7076e4a4$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $d670b54f7076e4a4$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $d670b54f7076e4a4$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $d670b54f7076e4a4$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $d670b54f7076e4a4$var$createFunctionComponentUpdateQueue(), $d670b54f7076e4a4$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $d670b54f7076e4a4$var$updateRef() {
    return $d670b54f7076e4a4$var$updateWorkInProgressHook().memoizedState;
}
function $d670b54f7076e4a4$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $d670b54f7076e4a4$var$mountWorkInProgressHook();
    $d670b54f7076e4a4$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $d670b54f7076e4a4$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $d670b54f7076e4a4$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $d670b54f7076e4a4$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $d670b54f7076e4a4$var$currentHook && null !== deps && $d670b54f7076e4a4$var$areHookInputsEqual(deps, $d670b54f7076e4a4$var$currentHook.memoizedState.deps) ? hook.memoizedState = $d670b54f7076e4a4$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($d670b54f7076e4a4$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $d670b54f7076e4a4$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $d670b54f7076e4a4$var$mountEffect(create, deps) {
    $d670b54f7076e4a4$var$mountEffectImpl(8390656, 8, create, deps);
}
function $d670b54f7076e4a4$var$updateEffect(create, deps) {
    $d670b54f7076e4a4$var$updateEffectImpl(2048, 8, create, deps);
}
function $d670b54f7076e4a4$var$useEffectEventImpl(payload) {
    $d670b54f7076e4a4$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $d670b54f7076e4a4$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $d670b54f7076e4a4$var$createFunctionComponentUpdateQueue(), $d670b54f7076e4a4$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $d670b54f7076e4a4$var$updateEvent(callback) {
    var ref = $d670b54f7076e4a4$var$updateWorkInProgressHook().memoizedState;
    $d670b54f7076e4a4$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($d670b54f7076e4a4$var$executionContext & 2)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $d670b54f7076e4a4$var$updateInsertionEffect(create, deps) {
    return $d670b54f7076e4a4$var$updateEffectImpl(4, 2, create, deps);
}
function $d670b54f7076e4a4$var$updateLayoutEffect(create, deps) {
    return $d670b54f7076e4a4$var$updateEffectImpl(4, 4, create, deps);
}
function $d670b54f7076e4a4$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $d670b54f7076e4a4$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $d670b54f7076e4a4$var$updateEffectImpl(4, 4, $d670b54f7076e4a4$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $d670b54f7076e4a4$var$mountDebugValue() {}
function $d670b54f7076e4a4$var$updateCallback(callback, deps) {
    var hook = $d670b54f7076e4a4$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $d670b54f7076e4a4$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $d670b54f7076e4a4$var$updateMemo(nextCreate, deps) {
    var hook = $d670b54f7076e4a4$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $d670b54f7076e4a4$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($d670b54f7076e4a4$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $d670b54f7076e4a4$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $d670b54f7076e4a4$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $d670b54f7076e4a4$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($d670b54f7076e4a4$var$renderLanes & 1073741824) && 0 === ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $d670b54f7076e4a4$var$requestDeferredLane();
    $d670b54f7076e4a4$var$currentlyRenderingFiber.lanes |= hook;
    $d670b54f7076e4a4$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $d670b54f7076e4a4$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($d670b54f7076e4a4$var$objectIs(value, prevValue)) return value;
    if (null !== $d670b54f7076e4a4$var$currentTreeHiddenStackCursor.current) return hook = $d670b54f7076e4a4$var$mountDeferredValueImpl(hook, value, initialValue), $d670b54f7076e4a4$var$objectIs(hook, prevValue) || ($d670b54f7076e4a4$var$didReceiveUpdate = !0), hook;
    if (0 === ($d670b54f7076e4a4$var$renderLanes & 42) || 0 !== ($d670b54f7076e4a4$var$renderLanes & 1073741824) && 0 === ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & 261930)) return $d670b54f7076e4a4$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $d670b54f7076e4a4$var$requestDeferredLane();
    $d670b54f7076e4a4$var$currentlyRenderingFiber.lanes |= hook;
    $d670b54f7076e4a4$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $d670b54f7076e4a4$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $d670b54f7076e4a4$var$ReactDOMSharedInternals.p;
    $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $d670b54f7076e4a4$var$ReactSharedInternals.T, currentTransition = {};
    $d670b54f7076e4a4$var$ReactSharedInternals.T = currentTransition;
    $d670b54f7076e4a4$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $d670b54f7076e4a4$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $d670b54f7076e4a4$var$chainThenableValue(returnValue, finishedState);
            $d670b54f7076e4a4$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $d670b54f7076e4a4$var$requestUpdateLane(fiber));
        } else $d670b54f7076e4a4$var$dispatchSetStateInternal(fiber, queue, finishedState, $d670b54f7076e4a4$var$requestUpdateLane(fiber));
    } catch (error) {
        $d670b54f7076e4a4$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $d670b54f7076e4a4$var$requestUpdateLane());
    } finally{
        $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $d670b54f7076e4a4$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d670b54f7076e4a4$var$noop() {}
function $d670b54f7076e4a4$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(476));
    var queue = $d670b54f7076e4a4$var$ensureFormComponentIsStateful(formFiber).queue;
    $d670b54f7076e4a4$var$startTransition(formFiber, queue, pendingState, $d670b54f7076e4a4$var$sharedNotPendingObject, null === action ? $d670b54f7076e4a4$var$noop : function() {
        $d670b54f7076e4a4$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $d670b54f7076e4a4$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $d670b54f7076e4a4$var$sharedNotPendingObject,
        baseState: $d670b54f7076e4a4$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $d670b54f7076e4a4$var$basicStateReducer,
            lastRenderedState: $d670b54f7076e4a4$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $d670b54f7076e4a4$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $d670b54f7076e4a4$var$requestFormReset$1(formFiber) {
    var stateHook = $d670b54f7076e4a4$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $d670b54f7076e4a4$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $d670b54f7076e4a4$var$requestUpdateLane());
}
function $d670b54f7076e4a4$var$useHostTransitionStatus() {
    return $d670b54f7076e4a4$var$readContext($d670b54f7076e4a4$var$HostTransitionContext);
}
function $d670b54f7076e4a4$var$updateId() {
    return $d670b54f7076e4a4$var$updateWorkInProgressHook().memoizedState;
}
function $d670b54f7076e4a4$var$updateRefresh() {
    return $d670b54f7076e4a4$var$updateWorkInProgressHook().memoizedState;
}
function $d670b54f7076e4a4$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $d670b54f7076e4a4$var$requestUpdateLane();
                fiber = $d670b54f7076e4a4$var$createUpdate(lane);
                var root$69 = $d670b54f7076e4a4$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($d670b54f7076e4a4$var$scheduleUpdateOnFiber(root$69, provider, lane), $d670b54f7076e4a4$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $d670b54f7076e4a4$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $d670b54f7076e4a4$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $d670b54f7076e4a4$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $d670b54f7076e4a4$var$isRenderPhaseUpdate(fiber) ? $d670b54f7076e4a4$var$enqueueRenderPhaseUpdate(queue, action) : (action = $d670b54f7076e4a4$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($d670b54f7076e4a4$var$scheduleUpdateOnFiber(action, fiber, lane), $d670b54f7076e4a4$var$entangleTransitionUpdate(action, queue, lane)));
}
function $d670b54f7076e4a4$var$dispatchSetState(fiber, queue, action) {
    var lane = $d670b54f7076e4a4$var$requestUpdateLane();
    $d670b54f7076e4a4$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $d670b54f7076e4a4$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d670b54f7076e4a4$var$isRenderPhaseUpdate(fiber)) $d670b54f7076e4a4$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($d670b54f7076e4a4$var$objectIs(eagerState, currentState)) return $d670b54f7076e4a4$var$enqueueUpdate$1(fiber, queue, update, 0), null === $d670b54f7076e4a4$var$workInProgressRoot && $d670b54f7076e4a4$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $d670b54f7076e4a4$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $d670b54f7076e4a4$var$scheduleUpdateOnFiber(action, fiber, lane), $d670b54f7076e4a4$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $d670b54f7076e4a4$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $d670b54f7076e4a4$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d670b54f7076e4a4$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $d670b54f7076e4a4$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $d670b54f7076e4a4$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $d670b54f7076e4a4$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $d670b54f7076e4a4$var$currentlyRenderingFiber || null !== alternate && alternate === $d670b54f7076e4a4$var$currentlyRenderingFiber;
}
function $d670b54f7076e4a4$var$enqueueRenderPhaseUpdate(queue, update) {
    $d670b54f7076e4a4$var$didScheduleRenderPhaseUpdateDuringThisPass = $d670b54f7076e4a4$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $d670b54f7076e4a4$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $d670b54f7076e4a4$var$markRootEntangled(root, lane);
    }
}
var $d670b54f7076e4a4$var$ContextOnlyDispatcher = {
    readContext: $d670b54f7076e4a4$var$readContext,
    use: $d670b54f7076e4a4$var$use,
    useCallback: $d670b54f7076e4a4$var$throwInvalidHookError,
    useContext: $d670b54f7076e4a4$var$throwInvalidHookError,
    useEffect: $d670b54f7076e4a4$var$throwInvalidHookError,
    useImperativeHandle: $d670b54f7076e4a4$var$throwInvalidHookError,
    useLayoutEffect: $d670b54f7076e4a4$var$throwInvalidHookError,
    useInsertionEffect: $d670b54f7076e4a4$var$throwInvalidHookError,
    useMemo: $d670b54f7076e4a4$var$throwInvalidHookError,
    useReducer: $d670b54f7076e4a4$var$throwInvalidHookError,
    useRef: $d670b54f7076e4a4$var$throwInvalidHookError,
    useState: $d670b54f7076e4a4$var$throwInvalidHookError,
    useDebugValue: $d670b54f7076e4a4$var$throwInvalidHookError,
    useDeferredValue: $d670b54f7076e4a4$var$throwInvalidHookError,
    useTransition: $d670b54f7076e4a4$var$throwInvalidHookError,
    useSyncExternalStore: $d670b54f7076e4a4$var$throwInvalidHookError,
    useId: $d670b54f7076e4a4$var$throwInvalidHookError,
    useHostTransitionStatus: $d670b54f7076e4a4$var$throwInvalidHookError,
    useFormState: $d670b54f7076e4a4$var$throwInvalidHookError,
    useActionState: $d670b54f7076e4a4$var$throwInvalidHookError,
    useOptimistic: $d670b54f7076e4a4$var$throwInvalidHookError,
    useMemoCache: $d670b54f7076e4a4$var$throwInvalidHookError,
    useCacheRefresh: $d670b54f7076e4a4$var$throwInvalidHookError
};
$d670b54f7076e4a4$var$ContextOnlyDispatcher.useEffectEvent = $d670b54f7076e4a4$var$throwInvalidHookError;
var $d670b54f7076e4a4$var$HooksDispatcherOnMount = {
    readContext: $d670b54f7076e4a4$var$readContext,
    use: $d670b54f7076e4a4$var$use,
    useCallback: function(callback, deps) {
        $d670b54f7076e4a4$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $d670b54f7076e4a4$var$readContext,
    useEffect: $d670b54f7076e4a4$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $d670b54f7076e4a4$var$mountEffectImpl(4194308, 4, $d670b54f7076e4a4$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $d670b54f7076e4a4$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $d670b54f7076e4a4$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $d670b54f7076e4a4$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($d670b54f7076e4a4$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $d670b54f7076e4a4$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $d670b54f7076e4a4$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $d670b54f7076e4a4$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($d670b54f7076e4a4$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $d670b54f7076e4a4$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $d670b54f7076e4a4$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $d670b54f7076e4a4$var$dispatchReducerAction.bind(null, $d670b54f7076e4a4$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $d670b54f7076e4a4$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $d670b54f7076e4a4$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $d670b54f7076e4a4$var$dispatchSetState.bind(null, $d670b54f7076e4a4$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $d670b54f7076e4a4$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d670b54f7076e4a4$var$mountWorkInProgressHook();
        return $d670b54f7076e4a4$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $d670b54f7076e4a4$var$mountStateImpl(!1);
        stateHook = $d670b54f7076e4a4$var$startTransition.bind(null, $d670b54f7076e4a4$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $d670b54f7076e4a4$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $d670b54f7076e4a4$var$currentlyRenderingFiber, hook = $d670b54f7076e4a4$var$mountWorkInProgressHook();
        if ($d670b54f7076e4a4$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $d670b54f7076e4a4$var$workInProgressRoot) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(349));
            0 !== ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & 127) || $d670b54f7076e4a4$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $d670b54f7076e4a4$var$mountEffect($d670b54f7076e4a4$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $d670b54f7076e4a4$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $d670b54f7076e4a4$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $d670b54f7076e4a4$var$mountWorkInProgressHook(), identifierPrefix = $d670b54f7076e4a4$var$workInProgressRoot.identifierPrefix;
        if ($d670b54f7076e4a4$var$isHydrating) {
            var JSCompiler_inline_result = $d670b54f7076e4a4$var$treeContextOverflow;
            var idWithLeadingBit = $d670b54f7076e4a4$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $d670b54f7076e4a4$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $d670b54f7076e4a4$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $d670b54f7076e4a4$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $d670b54f7076e4a4$var$useHostTransitionStatus,
    useFormState: $d670b54f7076e4a4$var$mountActionState,
    useActionState: $d670b54f7076e4a4$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $d670b54f7076e4a4$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $d670b54f7076e4a4$var$dispatchOptimisticSetState.bind(null, $d670b54f7076e4a4$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $d670b54f7076e4a4$var$useMemoCache,
    useCacheRefresh: function() {
        return $d670b54f7076e4a4$var$mountWorkInProgressHook().memoizedState = $d670b54f7076e4a4$var$refreshCache.bind(null, $d670b54f7076e4a4$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $d670b54f7076e4a4$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($d670b54f7076e4a4$var$executionContext & 2)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $d670b54f7076e4a4$var$HooksDispatcherOnUpdate = {
    readContext: $d670b54f7076e4a4$var$readContext,
    use: $d670b54f7076e4a4$var$use,
    useCallback: $d670b54f7076e4a4$var$updateCallback,
    useContext: $d670b54f7076e4a4$var$readContext,
    useEffect: $d670b54f7076e4a4$var$updateEffect,
    useImperativeHandle: $d670b54f7076e4a4$var$updateImperativeHandle,
    useInsertionEffect: $d670b54f7076e4a4$var$updateInsertionEffect,
    useLayoutEffect: $d670b54f7076e4a4$var$updateLayoutEffect,
    useMemo: $d670b54f7076e4a4$var$updateMemo,
    useReducer: $d670b54f7076e4a4$var$updateReducer,
    useRef: $d670b54f7076e4a4$var$updateRef,
    useState: function() {
        return $d670b54f7076e4a4$var$updateReducer($d670b54f7076e4a4$var$basicStateReducer);
    },
    useDebugValue: $d670b54f7076e4a4$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d670b54f7076e4a4$var$updateWorkInProgressHook();
        return $d670b54f7076e4a4$var$updateDeferredValueImpl(hook, $d670b54f7076e4a4$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $d670b54f7076e4a4$var$updateReducer($d670b54f7076e4a4$var$basicStateReducer)[0], start = $d670b54f7076e4a4$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $d670b54f7076e4a4$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $d670b54f7076e4a4$var$updateSyncExternalStore,
    useId: $d670b54f7076e4a4$var$updateId,
    useHostTransitionStatus: $d670b54f7076e4a4$var$useHostTransitionStatus,
    useFormState: $d670b54f7076e4a4$var$updateActionState,
    useActionState: $d670b54f7076e4a4$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $d670b54f7076e4a4$var$updateWorkInProgressHook();
        return $d670b54f7076e4a4$var$updateOptimisticImpl(hook, $d670b54f7076e4a4$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $d670b54f7076e4a4$var$useMemoCache,
    useCacheRefresh: $d670b54f7076e4a4$var$updateRefresh
};
$d670b54f7076e4a4$var$HooksDispatcherOnUpdate.useEffectEvent = $d670b54f7076e4a4$var$updateEvent;
var $d670b54f7076e4a4$var$HooksDispatcherOnRerender = {
    readContext: $d670b54f7076e4a4$var$readContext,
    use: $d670b54f7076e4a4$var$use,
    useCallback: $d670b54f7076e4a4$var$updateCallback,
    useContext: $d670b54f7076e4a4$var$readContext,
    useEffect: $d670b54f7076e4a4$var$updateEffect,
    useImperativeHandle: $d670b54f7076e4a4$var$updateImperativeHandle,
    useInsertionEffect: $d670b54f7076e4a4$var$updateInsertionEffect,
    useLayoutEffect: $d670b54f7076e4a4$var$updateLayoutEffect,
    useMemo: $d670b54f7076e4a4$var$updateMemo,
    useReducer: $d670b54f7076e4a4$var$rerenderReducer,
    useRef: $d670b54f7076e4a4$var$updateRef,
    useState: function() {
        return $d670b54f7076e4a4$var$rerenderReducer($d670b54f7076e4a4$var$basicStateReducer);
    },
    useDebugValue: $d670b54f7076e4a4$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d670b54f7076e4a4$var$updateWorkInProgressHook();
        return null === $d670b54f7076e4a4$var$currentHook ? $d670b54f7076e4a4$var$mountDeferredValueImpl(hook, value, initialValue) : $d670b54f7076e4a4$var$updateDeferredValueImpl(hook, $d670b54f7076e4a4$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $d670b54f7076e4a4$var$rerenderReducer($d670b54f7076e4a4$var$basicStateReducer)[0], start = $d670b54f7076e4a4$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $d670b54f7076e4a4$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $d670b54f7076e4a4$var$updateSyncExternalStore,
    useId: $d670b54f7076e4a4$var$updateId,
    useHostTransitionStatus: $d670b54f7076e4a4$var$useHostTransitionStatus,
    useFormState: $d670b54f7076e4a4$var$rerenderActionState,
    useActionState: $d670b54f7076e4a4$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $d670b54f7076e4a4$var$updateWorkInProgressHook();
        if (null !== $d670b54f7076e4a4$var$currentHook) return $d670b54f7076e4a4$var$updateOptimisticImpl(hook, $d670b54f7076e4a4$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $d670b54f7076e4a4$var$useMemoCache,
    useCacheRefresh: $d670b54f7076e4a4$var$updateRefresh
};
$d670b54f7076e4a4$var$HooksDispatcherOnRerender.useEffectEvent = $d670b54f7076e4a4$var$updateEvent;
function $d670b54f7076e4a4$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $d670b54f7076e4a4$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $d670b54f7076e4a4$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $d670b54f7076e4a4$var$requestUpdateLane(), update = $d670b54f7076e4a4$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $d670b54f7076e4a4$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($d670b54f7076e4a4$var$scheduleUpdateOnFiber(payload, inst, lane), $d670b54f7076e4a4$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $d670b54f7076e4a4$var$requestUpdateLane(), update = $d670b54f7076e4a4$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $d670b54f7076e4a4$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($d670b54f7076e4a4$var$scheduleUpdateOnFiber(payload, inst, lane), $d670b54f7076e4a4$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $d670b54f7076e4a4$var$requestUpdateLane(), update = $d670b54f7076e4a4$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $d670b54f7076e4a4$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($d670b54f7076e4a4$var$scheduleUpdateOnFiber(callback, inst, lane), $d670b54f7076e4a4$var$entangleTransitions(callback, inst, lane));
    }
};
function $d670b54f7076e4a4$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$d670b54f7076e4a4$var$shallowEqual(oldProps, newProps) || !$d670b54f7076e4a4$var$shallowEqual(oldState, newState) : !0;
}
function $d670b54f7076e4a4$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $d670b54f7076e4a4$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $d670b54f7076e4a4$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $d670b54f7076e4a4$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $d670b54f7076e4a4$var$defaultOnUncaughtError(error) {
    $d670b54f7076e4a4$var$reportGlobalError(error);
}
function $d670b54f7076e4a4$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $d670b54f7076e4a4$var$defaultOnRecoverableError(error) {
    $d670b54f7076e4a4$var$reportGlobalError(error);
}
function $d670b54f7076e4a4$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $d670b54f7076e4a4$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $d670b54f7076e4a4$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $d670b54f7076e4a4$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $d670b54f7076e4a4$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $d670b54f7076e4a4$var$createClassErrorUpdate(lane) {
    lane = $d670b54f7076e4a4$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $d670b54f7076e4a4$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $d670b54f7076e4a4$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $d670b54f7076e4a4$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $d670b54f7076e4a4$var$legacyErrorBoundariesThatAlreadyFailed ? $d670b54f7076e4a4$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $d670b54f7076e4a4$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $d670b54f7076e4a4$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $d670b54f7076e4a4$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $d670b54f7076e4a4$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $d670b54f7076e4a4$var$shellBoundary ? $d670b54f7076e4a4$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $d670b54f7076e4a4$var$workInProgressRootExitStatus && ($d670b54f7076e4a4$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $d670b54f7076e4a4$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $d670b54f7076e4a4$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $d670b54f7076e4a4$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $d670b54f7076e4a4$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $d670b54f7076e4a4$var$attachPingListener(root, value, rootRenderLanes);
        $d670b54f7076e4a4$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($d670b54f7076e4a4$var$isHydrating) return returnFiber = $d670b54f7076e4a4$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $d670b54f7076e4a4$var$HydrationMismatchException && (root = Error($d670b54f7076e4a4$var$formatProdErrorMessage(422), {
        cause: value
    }), $d670b54f7076e4a4$var$queueHydrationError($d670b54f7076e4a4$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $d670b54f7076e4a4$var$HydrationMismatchException && (returnFiber = Error($d670b54f7076e4a4$var$formatProdErrorMessage(423), {
        cause: value
    }), $d670b54f7076e4a4$var$queueHydrationError($d670b54f7076e4a4$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $d670b54f7076e4a4$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $d670b54f7076e4a4$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $d670b54f7076e4a4$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $d670b54f7076e4a4$var$workInProgressRootExitStatus && ($d670b54f7076e4a4$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($d670b54f7076e4a4$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $d670b54f7076e4a4$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $d670b54f7076e4a4$var$workInProgressRootConcurrentErrors ? $d670b54f7076e4a4$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $d670b54f7076e4a4$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $d670b54f7076e4a4$var$workInProgressRootExitStatus && ($d670b54f7076e4a4$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $d670b54f7076e4a4$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $d670b54f7076e4a4$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $d670b54f7076e4a4$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $d670b54f7076e4a4$var$legacyErrorBoundariesThatAlreadyFailed || !$d670b54f7076e4a4$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $d670b54f7076e4a4$var$createClassErrorUpdate(rootRenderLanes), $d670b54f7076e4a4$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $d670b54f7076e4a4$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $d670b54f7076e4a4$var$SelectiveHydrationException = Error($d670b54f7076e4a4$var$formatProdErrorMessage(461)), $d670b54f7076e4a4$var$didReceiveUpdate = !1;
function $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $d670b54f7076e4a4$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $d670b54f7076e4a4$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $d670b54f7076e4a4$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $d670b54f7076e4a4$var$prepareToReadContext(workInProgress);
    nextProps = $d670b54f7076e4a4$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $d670b54f7076e4a4$var$checkDidRenderIdHook();
    if (null !== current && !$d670b54f7076e4a4$var$didReceiveUpdate) return $d670b54f7076e4a4$var$bailoutHooks(current, workInProgress, renderLanes), $d670b54f7076e4a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d670b54f7076e4a4$var$isHydrating && key && $d670b54f7076e4a4$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $d670b54f7076e4a4$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$d670b54f7076e4a4$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $d670b54f7076e4a4$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $d670b54f7076e4a4$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$d670b54f7076e4a4$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $d670b54f7076e4a4$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $d670b54f7076e4a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $d670b54f7076e4a4$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $d670b54f7076e4a4$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($d670b54f7076e4a4$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($d670b54f7076e4a4$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $d670b54f7076e4a4$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($d670b54f7076e4a4$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $d670b54f7076e4a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $d670b54f7076e4a4$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $d670b54f7076e4a4$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $d670b54f7076e4a4$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $d670b54f7076e4a4$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $d670b54f7076e4a4$var$pushHiddenContext(workInProgress, prevState) : $d670b54f7076e4a4$var$reuseHiddenContextOnStack(), $d670b54f7076e4a4$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $d670b54f7076e4a4$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($d670b54f7076e4a4$var$pushTransition(workInProgress, prevState.cachePool), $d670b54f7076e4a4$var$pushHiddenContext(workInProgress, prevState), $d670b54f7076e4a4$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $d670b54f7076e4a4$var$pushTransition(workInProgress, null), $d670b54f7076e4a4$var$reuseHiddenContextOnStack(), $d670b54f7076e4a4$var$reuseSuspenseHandlerOnStack(workInProgress));
    $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $d670b54f7076e4a4$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $d670b54f7076e4a4$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $d670b54f7076e4a4$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $d670b54f7076e4a4$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $d670b54f7076e4a4$var$pushTransition(workInProgress, null);
    $d670b54f7076e4a4$var$reuseHiddenContextOnStack();
    $d670b54f7076e4a4$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $d670b54f7076e4a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $d670b54f7076e4a4$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $d670b54f7076e4a4$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $d670b54f7076e4a4$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $d670b54f7076e4a4$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $d670b54f7076e4a4$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $d670b54f7076e4a4$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $d670b54f7076e4a4$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($d670b54f7076e4a4$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $d670b54f7076e4a4$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $d670b54f7076e4a4$var$bailoutOffscreenComponent(null, current);
            $d670b54f7076e4a4$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $d670b54f7076e4a4$var$nextHydratableInstance) ? (current = $d670b54f7076e4a4$var$canHydrateHydrationBoundary(current, $d670b54f7076e4a4$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $d670b54f7076e4a4$var$treeContextProvider ? {
                    id: $d670b54f7076e4a4$var$treeContextId,
                    overflow: $d670b54f7076e4a4$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $d670b54f7076e4a4$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $d670b54f7076e4a4$var$hydrationParentFiber = workInProgress, $d670b54f7076e4a4$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $d670b54f7076e4a4$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $d670b54f7076e4a4$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $d670b54f7076e4a4$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $d670b54f7076e4a4$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(558));
        } else if ($d670b54f7076e4a4$var$didReceiveUpdate || $d670b54f7076e4a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $d670b54f7076e4a4$var$didReceiveUpdate || didSuspend) {
            nextProps = $d670b54f7076e4a4$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $d670b54f7076e4a4$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $d670b54f7076e4a4$var$enqueueConcurrentRenderForLane(current, dehydrated), $d670b54f7076e4a4$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $d670b54f7076e4a4$var$SelectiveHydrationException;
            $d670b54f7076e4a4$var$renderDidSuspendDelayIfPossible();
            workInProgress = $d670b54f7076e4a4$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $d670b54f7076e4a4$var$nextHydratableInstance = $d670b54f7076e4a4$var$getNextHydratable(dehydrated.nextSibling), $d670b54f7076e4a4$var$hydrationParentFiber = workInProgress, $d670b54f7076e4a4$var$isHydrating = !0, $d670b54f7076e4a4$var$hydrationErrors = null, $d670b54f7076e4a4$var$rootOrSingletonContext = !1, null !== current && $d670b54f7076e4a4$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $d670b54f7076e4a4$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $d670b54f7076e4a4$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $d670b54f7076e4a4$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $d670b54f7076e4a4$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $d670b54f7076e4a4$var$prepareToReadContext(workInProgress);
    Component = $d670b54f7076e4a4$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $d670b54f7076e4a4$var$checkDidRenderIdHook();
    if (null !== current && !$d670b54f7076e4a4$var$didReceiveUpdate) return $d670b54f7076e4a4$var$bailoutHooks(current, workInProgress, renderLanes), $d670b54f7076e4a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d670b54f7076e4a4$var$isHydrating && nextProps && $d670b54f7076e4a4$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $d670b54f7076e4a4$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $d670b54f7076e4a4$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $d670b54f7076e4a4$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $d670b54f7076e4a4$var$finishRenderingHooks(current);
    Component = $d670b54f7076e4a4$var$checkDidRenderIdHook();
    if (null !== current && !$d670b54f7076e4a4$var$didReceiveUpdate) return $d670b54f7076e4a4$var$bailoutHooks(current, workInProgress, renderLanes), $d670b54f7076e4a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d670b54f7076e4a4$var$isHydrating && Component && $d670b54f7076e4a4$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $d670b54f7076e4a4$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $d670b54f7076e4a4$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $d670b54f7076e4a4$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $d670b54f7076e4a4$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $d670b54f7076e4a4$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $d670b54f7076e4a4$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $d670b54f7076e4a4$var$readContext(contextType) : $d670b54f7076e4a4$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($d670b54f7076e4a4$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $d670b54f7076e4a4$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $d670b54f7076e4a4$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $d670b54f7076e4a4$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $d670b54f7076e4a4$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $d670b54f7076e4a4$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $d670b54f7076e4a4$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $d670b54f7076e4a4$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $d670b54f7076e4a4$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $d670b54f7076e4a4$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $d670b54f7076e4a4$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $d670b54f7076e4a4$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($d670b54f7076e4a4$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $d670b54f7076e4a4$var$hasForceUpdate || $d670b54f7076e4a4$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $d670b54f7076e4a4$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $d670b54f7076e4a4$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $d670b54f7076e4a4$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $d670b54f7076e4a4$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $d670b54f7076e4a4$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $d670b54f7076e4a4$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $d670b54f7076e4a4$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $d670b54f7076e4a4$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $d670b54f7076e4a4$var$hasForceUpdate || null !== current && null !== current.dependencies && $d670b54f7076e4a4$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($d670b54f7076e4a4$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $d670b54f7076e4a4$var$hasForceUpdate || $d670b54f7076e4a4$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $d670b54f7076e4a4$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $d670b54f7076e4a4$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $d670b54f7076e4a4$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $d670b54f7076e4a4$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $d670b54f7076e4a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $d670b54f7076e4a4$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $d670b54f7076e4a4$var$resetHydrationState();
    workInProgress.flags |= 256;
    $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $d670b54f7076e4a4$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $d670b54f7076e4a4$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $d670b54f7076e4a4$var$getSuspendedCache()
    };
}
function $d670b54f7076e4a4$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $d670b54f7076e4a4$var$workInProgressDeferredLane);
    return current;
}
function $d670b54f7076e4a4$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($d670b54f7076e4a4$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($d670b54f7076e4a4$var$isHydrating) {
            showFallback ? $d670b54f7076e4a4$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $d670b54f7076e4a4$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $d670b54f7076e4a4$var$nextHydratableInstance) ? (current = $d670b54f7076e4a4$var$canHydrateHydrationBoundary(current, $d670b54f7076e4a4$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $d670b54f7076e4a4$var$treeContextProvider ? {
                    id: $d670b54f7076e4a4$var$treeContextId,
                    overflow: $d670b54f7076e4a4$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $d670b54f7076e4a4$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $d670b54f7076e4a4$var$hydrationParentFiber = workInProgress, $d670b54f7076e4a4$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $d670b54f7076e4a4$var$throwOnHydrationMismatch(workInProgress);
            $d670b54f7076e4a4$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $d670b54f7076e4a4$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $d670b54f7076e4a4$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $d670b54f7076e4a4$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $d670b54f7076e4a4$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $d670b54f7076e4a4$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d670b54f7076e4a4$var$SUSPENDED_MARKER, $d670b54f7076e4a4$var$bailoutOffscreenComponent(null, nextProps);
        $d670b54f7076e4a4$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $d670b54f7076e4a4$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($d670b54f7076e4a4$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $d670b54f7076e4a4$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($d670b54f7076e4a4$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($d670b54f7076e4a4$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $d670b54f7076e4a4$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $d670b54f7076e4a4$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $d670b54f7076e4a4$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $d670b54f7076e4a4$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $d670b54f7076e4a4$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d670b54f7076e4a4$var$SUSPENDED_MARKER, workInProgress = $d670b54f7076e4a4$var$bailoutOffscreenComponent(null, nextProps));
        else if ($d670b54f7076e4a4$var$pushPrimaryTreeSuspenseHandler(workInProgress), $d670b54f7076e4a4$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($d670b54f7076e4a4$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $d670b54f7076e4a4$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $d670b54f7076e4a4$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($d670b54f7076e4a4$var$didReceiveUpdate || $d670b54f7076e4a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $d670b54f7076e4a4$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $d670b54f7076e4a4$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $d670b54f7076e4a4$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $d670b54f7076e4a4$var$enqueueConcurrentRenderForLane(current, nextProps), $d670b54f7076e4a4$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $d670b54f7076e4a4$var$SelectiveHydrationException;
            $d670b54f7076e4a4$var$isSuspenseInstancePending(nextPrimaryChildren) || $d670b54f7076e4a4$var$renderDidSuspendDelayIfPossible();
            workInProgress = $d670b54f7076e4a4$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $d670b54f7076e4a4$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $d670b54f7076e4a4$var$nextHydratableInstance = $d670b54f7076e4a4$var$getNextHydratable(nextPrimaryChildren.nextSibling), $d670b54f7076e4a4$var$hydrationParentFiber = workInProgress, $d670b54f7076e4a4$var$isHydrating = !0, $d670b54f7076e4a4$var$hydrationErrors = null, $d670b54f7076e4a4$var$rootOrSingletonContext = !1, null !== current && $d670b54f7076e4a4$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $d670b54f7076e4a4$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $d670b54f7076e4a4$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $d670b54f7076e4a4$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $d670b54f7076e4a4$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $d670b54f7076e4a4$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $d670b54f7076e4a4$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $d670b54f7076e4a4$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $d670b54f7076e4a4$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $d670b54f7076e4a4$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $d670b54f7076e4a4$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d670b54f7076e4a4$var$SUSPENDED_MARKER, $d670b54f7076e4a4$var$bailoutOffscreenComponent(current.child, nextProps);
    $d670b54f7076e4a4$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $d670b54f7076e4a4$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $d670b54f7076e4a4$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $d670b54f7076e4a4$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $d670b54f7076e4a4$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $d670b54f7076e4a4$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $d670b54f7076e4a4$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $d670b54f7076e4a4$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $d670b54f7076e4a4$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $d670b54f7076e4a4$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $d670b54f7076e4a4$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $d670b54f7076e4a4$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $d670b54f7076e4a4$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $d670b54f7076e4a4$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseStackCursor, suspenseContext);
    $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $d670b54f7076e4a4$var$isHydrating ? $d670b54f7076e4a4$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $d670b54f7076e4a4$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $d670b54f7076e4a4$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $d670b54f7076e4a4$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $d670b54f7076e4a4$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $d670b54f7076e4a4$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $d670b54f7076e4a4$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $d670b54f7076e4a4$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $d670b54f7076e4a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $d670b54f7076e4a4$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($d670b54f7076e4a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $d670b54f7076e4a4$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $d670b54f7076e4a4$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $d670b54f7076e4a4$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $d670b54f7076e4a4$var$checkIfContextChanged(current) ? !0 : !1;
}
function $d670b54f7076e4a4$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $d670b54f7076e4a4$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $d670b54f7076e4a4$var$pushProvider(workInProgress, $d670b54f7076e4a4$var$CacheContext, current.memoizedState.cache);
            $d670b54f7076e4a4$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $d670b54f7076e4a4$var$pushHostContext(workInProgress);
            break;
        case 4:
            $d670b54f7076e4a4$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $d670b54f7076e4a4$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $d670b54f7076e4a4$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $d670b54f7076e4a4$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $d670b54f7076e4a4$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $d670b54f7076e4a4$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $d670b54f7076e4a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $d670b54f7076e4a4$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($d670b54f7076e4a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $d670b54f7076e4a4$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseStackCursor, $d670b54f7076e4a4$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $d670b54f7076e4a4$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $d670b54f7076e4a4$var$pushProvider(workInProgress, $d670b54f7076e4a4$var$CacheContext, current.memoizedState.cache);
    }
    return $d670b54f7076e4a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $d670b54f7076e4a4$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $d670b54f7076e4a4$var$didReceiveUpdate = !0;
        else {
            if (!$d670b54f7076e4a4$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $d670b54f7076e4a4$var$didReceiveUpdate = !1, $d670b54f7076e4a4$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $d670b54f7076e4a4$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $d670b54f7076e4a4$var$didReceiveUpdate = !1, $d670b54f7076e4a4$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $d670b54f7076e4a4$var$pushTreeId(workInProgress, $d670b54f7076e4a4$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $d670b54f7076e4a4$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $d670b54f7076e4a4$var$shouldConstruct(current) ? (props = $d670b54f7076e4a4$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $d670b54f7076e4a4$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $d670b54f7076e4a4$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $d670b54f7076e4a4$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $d670b54f7076e4a4$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $d670b54f7076e4a4$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $d670b54f7076e4a4$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $d670b54f7076e4a4$var$getComponentNameFromType(current) || current;
                    throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $d670b54f7076e4a4$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $d670b54f7076e4a4$var$resolveClassComponentProps(props, workInProgress.pendingProps), $d670b54f7076e4a4$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $d670b54f7076e4a4$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $d670b54f7076e4a4$var$cloneUpdateQueue(current, workInProgress);
                $d670b54f7076e4a4$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $d670b54f7076e4a4$var$pushProvider(workInProgress, $d670b54f7076e4a4$var$CacheContext, props);
                props !== prevState.cache && $d670b54f7076e4a4$var$propagateContextChanges(workInProgress, [
                    $d670b54f7076e4a4$var$CacheContext
                ], renderLanes, !0);
                $d670b54f7076e4a4$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $d670b54f7076e4a4$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $d670b54f7076e4a4$var$createCapturedValueAtFiber(Error($d670b54f7076e4a4$var$formatProdErrorMessage(424)), workInProgress);
                        $d670b54f7076e4a4$var$queueHydrationError($$typeof);
                        workInProgress = $d670b54f7076e4a4$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $d670b54f7076e4a4$var$nextHydratableInstance = $d670b54f7076e4a4$var$getNextHydratable(current.firstChild);
                        $d670b54f7076e4a4$var$hydrationParentFiber = workInProgress;
                        $d670b54f7076e4a4$var$isHydrating = !0;
                        $d670b54f7076e4a4$var$hydrationErrors = null;
                        $d670b54f7076e4a4$var$rootOrSingletonContext = !0;
                        renderLanes = $d670b54f7076e4a4$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $d670b54f7076e4a4$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $d670b54f7076e4a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $d670b54f7076e4a4$var$markRef(current, workInProgress), null === current ? (renderLanes = $d670b54f7076e4a4$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $d670b54f7076e4a4$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $d670b54f7076e4a4$var$getOwnerDocumentFromRootContainer($d670b54f7076e4a4$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$d670b54f7076e4a4$var$internalInstanceKey] = workInProgress, props[$d670b54f7076e4a4$var$internalPropsKey] = current, $d670b54f7076e4a4$var$setInitialProperties(props, renderLanes, current), $d670b54f7076e4a4$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $d670b54f7076e4a4$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $d670b54f7076e4a4$var$pushHostContext(workInProgress), null === current && $d670b54f7076e4a4$var$isHydrating && (props = workInProgress.stateNode = $d670b54f7076e4a4$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $d670b54f7076e4a4$var$rootInstanceStackCursor.current), $d670b54f7076e4a4$var$hydrationParentFiber = workInProgress, $d670b54f7076e4a4$var$rootOrSingletonContext = !0, $$typeof = $d670b54f7076e4a4$var$nextHydratableInstance, $d670b54f7076e4a4$var$isSingletonScope(workInProgress.type) ? ($d670b54f7076e4a4$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $d670b54f7076e4a4$var$nextHydratableInstance = $d670b54f7076e4a4$var$getNextHydratable(props.firstChild)) : $d670b54f7076e4a4$var$nextHydratableInstance = $$typeof), $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $d670b54f7076e4a4$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $d670b54f7076e4a4$var$isHydrating) {
                if ($$typeof = props = $d670b54f7076e4a4$var$nextHydratableInstance) props = $d670b54f7076e4a4$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $d670b54f7076e4a4$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $d670b54f7076e4a4$var$hydrationParentFiber = workInProgress, $d670b54f7076e4a4$var$nextHydratableInstance = $d670b54f7076e4a4$var$getNextHydratable(props.firstChild), $d670b54f7076e4a4$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $d670b54f7076e4a4$var$throwOnHydrationMismatch(workInProgress);
            }
            $d670b54f7076e4a4$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $d670b54f7076e4a4$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $d670b54f7076e4a4$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $d670b54f7076e4a4$var$renderWithHooks(current, workInProgress, $d670b54f7076e4a4$var$TransitionAwareHostComponent, null, null, renderLanes), $d670b54f7076e4a4$var$HostTransitionContext._currentValue = $$typeof);
            $d670b54f7076e4a4$var$markRef(current, workInProgress);
            $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $d670b54f7076e4a4$var$isHydrating) {
                if (current = renderLanes = $d670b54f7076e4a4$var$nextHydratableInstance) renderLanes = $d670b54f7076e4a4$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $d670b54f7076e4a4$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $d670b54f7076e4a4$var$hydrationParentFiber = workInProgress, $d670b54f7076e4a4$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $d670b54f7076e4a4$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $d670b54f7076e4a4$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $d670b54f7076e4a4$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $d670b54f7076e4a4$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $d670b54f7076e4a4$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $d670b54f7076e4a4$var$pushProvider(workInProgress, workInProgress.type, props.value), $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $d670b54f7076e4a4$var$prepareToReadContext(workInProgress), $$typeof = $d670b54f7076e4a4$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $d670b54f7076e4a4$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $d670b54f7076e4a4$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $d670b54f7076e4a4$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $d670b54f7076e4a4$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $d670b54f7076e4a4$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $d670b54f7076e4a4$var$prepareToReadContext(workInProgress), props = $d670b54f7076e4a4$var$readContext($d670b54f7076e4a4$var$CacheContext), null === current ? ($$typeof = $d670b54f7076e4a4$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $d670b54f7076e4a4$var$workInProgressRoot, prevState = $d670b54f7076e4a4$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $d670b54f7076e4a4$var$initializeUpdateQueue(workInProgress), $d670b54f7076e4a4$var$pushProvider(workInProgress, $d670b54f7076e4a4$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($d670b54f7076e4a4$var$cloneUpdateQueue(current, workInProgress), $d670b54f7076e4a4$var$processUpdateQueue(workInProgress, null, null, renderLanes), $d670b54f7076e4a4$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $d670b54f7076e4a4$var$pushProvider(workInProgress, $d670b54f7076e4a4$var$CacheContext, props)) : (props = prevState.cache, $d670b54f7076e4a4$var$pushProvider(workInProgress, $d670b54f7076e4a4$var$CacheContext, props), props !== $$typeof.cache && $d670b54f7076e4a4$var$propagateContextChanges(workInProgress, [
                $d670b54f7076e4a4$var$CacheContext
            ], renderLanes, !0))), $d670b54f7076e4a4$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $d670b54f7076e4a4$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $d670b54f7076e4a4$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($d670b54f7076e4a4$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $d670b54f7076e4a4$var$suspendedThenable = $d670b54f7076e4a4$var$noopSuspenseyCommitThenable, $d670b54f7076e4a4$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $d670b54f7076e4a4$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$d670b54f7076e4a4$var$preloadResource(resource)) {
        if ($d670b54f7076e4a4$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $d670b54f7076e4a4$var$suspendedThenable = $d670b54f7076e4a4$var$noopSuspenseyCommitThenable, $d670b54f7076e4a4$var$SuspenseyCommitException;
    }
}
function $d670b54f7076e4a4$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $d670b54f7076e4a4$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $d670b54f7076e4a4$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $d670b54f7076e4a4$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$d670b54f7076e4a4$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $d670b54f7076e4a4$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $d670b54f7076e4a4$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $d670b54f7076e4a4$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $d670b54f7076e4a4$var$bubbleProperties(workInProgress), null;
        case 1:
            return $d670b54f7076e4a4$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $d670b54f7076e4a4$var$popProvider($d670b54f7076e4a4$var$CacheContext);
            $d670b54f7076e4a4$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $d670b54f7076e4a4$var$popHydrationState(workInProgress) ? $d670b54f7076e4a4$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $d670b54f7076e4a4$var$upgradeHydrationErrorsToRecoverable());
            $d670b54f7076e4a4$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($d670b54f7076e4a4$var$markUpdate(workInProgress), null !== nextResource ? ($d670b54f7076e4a4$var$bubbleProperties(workInProgress), $d670b54f7076e4a4$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($d670b54f7076e4a4$var$bubbleProperties(workInProgress), $d670b54f7076e4a4$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($d670b54f7076e4a4$var$markUpdate(workInProgress), $d670b54f7076e4a4$var$bubbleProperties(workInProgress), $d670b54f7076e4a4$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($d670b54f7076e4a4$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $d670b54f7076e4a4$var$markUpdate(workInProgress), $d670b54f7076e4a4$var$bubbleProperties(workInProgress), $d670b54f7076e4a4$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $d670b54f7076e4a4$var$popHostContext(workInProgress);
            renderLanes = $d670b54f7076e4a4$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d670b54f7076e4a4$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(166));
                    $d670b54f7076e4a4$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $d670b54f7076e4a4$var$contextStackCursor.current;
                $d670b54f7076e4a4$var$popHydrationState(workInProgress) ? $d670b54f7076e4a4$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $d670b54f7076e4a4$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $d670b54f7076e4a4$var$markUpdate(workInProgress));
            }
            $d670b54f7076e4a4$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $d670b54f7076e4a4$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d670b54f7076e4a4$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(166));
                    $d670b54f7076e4a4$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $d670b54f7076e4a4$var$contextStackCursor.current;
                if ($d670b54f7076e4a4$var$popHydrationState(workInProgress)) $d670b54f7076e4a4$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $d670b54f7076e4a4$var$getOwnerDocumentFromRootContainer($d670b54f7076e4a4$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$d670b54f7076e4a4$var$internalInstanceKey] = workInProgress;
                    nextResource[$d670b54f7076e4a4$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($d670b54f7076e4a4$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $d670b54f7076e4a4$var$markUpdate(workInProgress);
                }
            }
            $d670b54f7076e4a4$var$bubbleProperties(workInProgress);
            $d670b54f7076e4a4$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d670b54f7076e4a4$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(166));
                current = $d670b54f7076e4a4$var$rootInstanceStackCursor.current;
                if ($d670b54f7076e4a4$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $d670b54f7076e4a4$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$d670b54f7076e4a4$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $d670b54f7076e4a4$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $d670b54f7076e4a4$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $d670b54f7076e4a4$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$d670b54f7076e4a4$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $d670b54f7076e4a4$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $d670b54f7076e4a4$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(557));
                        current[$d670b54f7076e4a4$var$internalInstanceKey] = workInProgress;
                    } else $d670b54f7076e4a4$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $d670b54f7076e4a4$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $d670b54f7076e4a4$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $d670b54f7076e4a4$var$popSuspenseHandler(workInProgress), workInProgress;
                    $d670b54f7076e4a4$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(558));
            }
            $d670b54f7076e4a4$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $d670b54f7076e4a4$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(317));
                        type[$d670b54f7076e4a4$var$internalInstanceKey] = workInProgress;
                    } else $d670b54f7076e4a4$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $d670b54f7076e4a4$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $d670b54f7076e4a4$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $d670b54f7076e4a4$var$popSuspenseHandler(workInProgress), workInProgress;
                    $d670b54f7076e4a4$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $d670b54f7076e4a4$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $d670b54f7076e4a4$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $d670b54f7076e4a4$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $d670b54f7076e4a4$var$popHostContainer(), null === current && $d670b54f7076e4a4$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $d670b54f7076e4a4$var$bubbleProperties(workInProgress), null;
        case 10:
            return $d670b54f7076e4a4$var$popProvider(workInProgress.type), $d670b54f7076e4a4$var$bubbleProperties(workInProgress), null;
        case 19:
            $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $d670b54f7076e4a4$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $d670b54f7076e4a4$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $d670b54f7076e4a4$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $d670b54f7076e4a4$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $d670b54f7076e4a4$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $d670b54f7076e4a4$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$d670b54f7076e4a4$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseStackCursor, $d670b54f7076e4a4$var$suspenseStackCursor.current & 1 | 2);
                            $d670b54f7076e4a4$var$isHydrating && $d670b54f7076e4a4$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $d670b54f7076e4a4$var$now() > $d670b54f7076e4a4$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $d670b54f7076e4a4$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $d670b54f7076e4a4$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $d670b54f7076e4a4$var$scheduleRetryEffect(workInProgress, current), $d670b54f7076e4a4$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$d670b54f7076e4a4$var$isHydrating) return $d670b54f7076e4a4$var$bubbleProperties(workInProgress), null;
                    } else 2 * $d670b54f7076e4a4$var$now() - newProps.renderingStartTime > $d670b54f7076e4a4$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $d670b54f7076e4a4$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $d670b54f7076e4a4$var$now(), current.sibling = null, renderLanes = $d670b54f7076e4a4$var$suspenseStackCursor.current, $d670b54f7076e4a4$var$push($d670b54f7076e4a4$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $d670b54f7076e4a4$var$isHydrating && $d670b54f7076e4a4$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $d670b54f7076e4a4$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $d670b54f7076e4a4$var$popSuspenseHandler(workInProgress), $d670b54f7076e4a4$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($d670b54f7076e4a4$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $d670b54f7076e4a4$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $d670b54f7076e4a4$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $d670b54f7076e4a4$var$popProvider($d670b54f7076e4a4$var$CacheContext), $d670b54f7076e4a4$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $d670b54f7076e4a4$var$unwindWork(current, workInProgress) {
    $d670b54f7076e4a4$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $d670b54f7076e4a4$var$popProvider($d670b54f7076e4a4$var$CacheContext), $d670b54f7076e4a4$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $d670b54f7076e4a4$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $d670b54f7076e4a4$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(340));
                $d670b54f7076e4a4$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $d670b54f7076e4a4$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(340));
                $d670b54f7076e4a4$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$suspenseStackCursor), null;
        case 4:
            return $d670b54f7076e4a4$var$popHostContainer(), null;
        case 10:
            return $d670b54f7076e4a4$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $d670b54f7076e4a4$var$popSuspenseHandler(workInProgress), $d670b54f7076e4a4$var$popHiddenContext(), null !== current && $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $d670b54f7076e4a4$var$popProvider($d670b54f7076e4a4$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $d670b54f7076e4a4$var$unwindInterruptedWork(current, interruptedWork) {
    $d670b54f7076e4a4$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $d670b54f7076e4a4$var$popProvider($d670b54f7076e4a4$var$CacheContext);
            $d670b54f7076e4a4$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $d670b54f7076e4a4$var$popHostContext(interruptedWork);
            break;
        case 4:
            $d670b54f7076e4a4$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $d670b54f7076e4a4$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $d670b54f7076e4a4$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$suspenseStackCursor);
            break;
        case 10:
            $d670b54f7076e4a4$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $d670b54f7076e4a4$var$popSuspenseHandler(interruptedWork);
            $d670b54f7076e4a4$var$popHiddenContext();
            null !== current && $d670b54f7076e4a4$var$pop($d670b54f7076e4a4$var$resumedCache);
            break;
        case 24:
            $d670b54f7076e4a4$var$popProvider($d670b54f7076e4a4$var$CacheContext);
    }
}
function $d670b54f7076e4a4$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d670b54f7076e4a4$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $d670b54f7076e4a4$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d670b54f7076e4a4$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $d670b54f7076e4a4$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $d670b54f7076e4a4$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $d670b54f7076e4a4$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $d670b54f7076e4a4$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $d670b54f7076e4a4$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $d670b54f7076e4a4$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $d670b54f7076e4a4$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $d670b54f7076e4a4$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $d670b54f7076e4a4$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $d670b54f7076e4a4$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d670b54f7076e4a4$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $d670b54f7076e4a4$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$d670b54f7076e4a4$var$internalPropsKey] = newProps;
    } catch (error) {
        $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d670b54f7076e4a4$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $d670b54f7076e4a4$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $d670b54f7076e4a4$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $d670b54f7076e4a4$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $d670b54f7076e4a4$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $d670b54f7076e4a4$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $d670b54f7076e4a4$var$noop$1));
    else if (4 !== tag && (27 === tag && $d670b54f7076e4a4$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($d670b54f7076e4a4$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$d670b54f7076e4a4$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $d670b54f7076e4a4$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $d670b54f7076e4a4$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($d670b54f7076e4a4$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$d670b54f7076e4a4$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $d670b54f7076e4a4$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $d670b54f7076e4a4$var$setInitialProperties(singleton, type, props);
        singleton[$d670b54f7076e4a4$var$internalInstanceKey] = finishedWork;
        singleton[$d670b54f7076e4a4$var$internalPropsKey] = props;
    } catch (error) {
        $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $d670b54f7076e4a4$var$offscreenSubtreeIsHidden = !1, $d670b54f7076e4a4$var$offscreenSubtreeWasHidden = !1, $d670b54f7076e4a4$var$needsFormReset = !1, $d670b54f7076e4a4$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $d670b54f7076e4a4$var$nextEffect = null;
function $d670b54f7076e4a4$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $d670b54f7076e4a4$var$eventsEnabled = $d670b54f7076e4a4$var$_enabled;
    root = $d670b54f7076e4a4$var$getActiveElementDeep(root);
    if ($d670b54f7076e4a4$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $d670b54f7076e4a4$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $d670b54f7076e4a4$var$_enabled = !1;
    for($d670b54f7076e4a4$var$nextEffect = firstChild; null !== $d670b54f7076e4a4$var$nextEffect;)if (firstChild = $d670b54f7076e4a4$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $d670b54f7076e4a4$var$nextEffect = root;
    else for(; null !== $d670b54f7076e4a4$var$nextEffect;){
        firstChild = $d670b54f7076e4a4$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $d670b54f7076e4a4$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $d670b54f7076e4a4$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $d670b54f7076e4a4$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $d670b54f7076e4a4$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $d670b54f7076e4a4$var$nextEffect = root;
            break;
        }
        $d670b54f7076e4a4$var$nextEffect = firstChild.return;
    }
}
function $d670b54f7076e4a4$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d670b54f7076e4a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $d670b54f7076e4a4$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $d670b54f7076e4a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $d670b54f7076e4a4$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $d670b54f7076e4a4$var$commitClassCallbacks(finishedWork);
            flags & 512 && $d670b54f7076e4a4$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $d670b54f7076e4a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $d670b54f7076e4a4$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $d670b54f7076e4a4$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $d670b54f7076e4a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $d670b54f7076e4a4$var$commitHostMount(finishedWork);
            flags & 512 && $d670b54f7076e4a4$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $d670b54f7076e4a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $d670b54f7076e4a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $d670b54f7076e4a4$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $d670b54f7076e4a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $d670b54f7076e4a4$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $d670b54f7076e4a4$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $d670b54f7076e4a4$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $d670b54f7076e4a4$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $d670b54f7076e4a4$var$offscreenSubtreeWasHidden;
                prevProps = $d670b54f7076e4a4$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $d670b54f7076e4a4$var$offscreenSubtreeWasHidden;
                $d670b54f7076e4a4$var$offscreenSubtreeIsHidden = flags;
                ($d670b54f7076e4a4$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $d670b54f7076e4a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $d670b54f7076e4a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $d670b54f7076e4a4$var$offscreenSubtreeIsHidden = prevProps;
                $d670b54f7076e4a4$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $d670b54f7076e4a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $d670b54f7076e4a4$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $d670b54f7076e4a4$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $d670b54f7076e4a4$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $d670b54f7076e4a4$var$hostParent = null, $d670b54f7076e4a4$var$hostParentIsContainer = !1;
function $d670b54f7076e4a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$d670b54f7076e4a4$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $d670b54f7076e4a4$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($d670b54f7076e4a4$var$injectedHook && "function" === typeof $d670b54f7076e4a4$var$injectedHook.onCommitFiberUnmount) try {
        $d670b54f7076e4a4$var$injectedHook.onCommitFiberUnmount($d670b54f7076e4a4$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $d670b54f7076e4a4$var$offscreenSubtreeWasHidden || $d670b54f7076e4a4$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $d670b54f7076e4a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $d670b54f7076e4a4$var$offscreenSubtreeWasHidden || $d670b54f7076e4a4$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $d670b54f7076e4a4$var$hostParent, prevHostParentIsContainer = $d670b54f7076e4a4$var$hostParentIsContainer;
            $d670b54f7076e4a4$var$isSingletonScope(deletedFiber.type) && ($d670b54f7076e4a4$var$hostParent = deletedFiber.stateNode, $d670b54f7076e4a4$var$hostParentIsContainer = !1);
            $d670b54f7076e4a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d670b54f7076e4a4$var$releaseSingletonInstance(deletedFiber.stateNode);
            $d670b54f7076e4a4$var$hostParent = prevHostParent;
            $d670b54f7076e4a4$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $d670b54f7076e4a4$var$offscreenSubtreeWasHidden || $d670b54f7076e4a4$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $d670b54f7076e4a4$var$hostParent;
            prevHostParentIsContainer = $d670b54f7076e4a4$var$hostParentIsContainer;
            $d670b54f7076e4a4$var$hostParent = null;
            $d670b54f7076e4a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d670b54f7076e4a4$var$hostParent = prevHostParent;
            $d670b54f7076e4a4$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $d670b54f7076e4a4$var$hostParent) {
                if ($d670b54f7076e4a4$var$hostParentIsContainer) try {
                    (9 === $d670b54f7076e4a4$var$hostParent.nodeType ? $d670b54f7076e4a4$var$hostParent.body : "HTML" === $d670b54f7076e4a4$var$hostParent.nodeName ? $d670b54f7076e4a4$var$hostParent.ownerDocument.body : $d670b54f7076e4a4$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $d670b54f7076e4a4$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $d670b54f7076e4a4$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $d670b54f7076e4a4$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $d670b54f7076e4a4$var$hostParent && ($d670b54f7076e4a4$var$hostParentIsContainer ? (finishedRoot = $d670b54f7076e4a4$var$hostParent, $d670b54f7076e4a4$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $d670b54f7076e4a4$var$retryIfBlockedOn(finishedRoot)) : $d670b54f7076e4a4$var$clearHydrationBoundary($d670b54f7076e4a4$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $d670b54f7076e4a4$var$hostParent;
            prevHostParentIsContainer = $d670b54f7076e4a4$var$hostParentIsContainer;
            $d670b54f7076e4a4$var$hostParent = deletedFiber.stateNode.containerInfo;
            $d670b54f7076e4a4$var$hostParentIsContainer = !0;
            $d670b54f7076e4a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d670b54f7076e4a4$var$hostParent = prevHostParent;
            $d670b54f7076e4a4$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $d670b54f7076e4a4$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $d670b54f7076e4a4$var$offscreenSubtreeWasHidden || $d670b54f7076e4a4$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $d670b54f7076e4a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $d670b54f7076e4a4$var$offscreenSubtreeWasHidden || ($d670b54f7076e4a4$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $d670b54f7076e4a4$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $d670b54f7076e4a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $d670b54f7076e4a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $d670b54f7076e4a4$var$offscreenSubtreeWasHidden = (prevHostParent = $d670b54f7076e4a4$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $d670b54f7076e4a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d670b54f7076e4a4$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $d670b54f7076e4a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $d670b54f7076e4a4$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $d670b54f7076e4a4$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $d670b54f7076e4a4$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $d670b54f7076e4a4$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d670b54f7076e4a4$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $d670b54f7076e4a4$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $d670b54f7076e4a4$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $d670b54f7076e4a4$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $d670b54f7076e4a4$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $d670b54f7076e4a4$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($d670b54f7076e4a4$var$isSingletonScope(parent.type)) {
                        $d670b54f7076e4a4$var$hostParent = parent.stateNode;
                        $d670b54f7076e4a4$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $d670b54f7076e4a4$var$hostParent = parent.stateNode;
                    $d670b54f7076e4a4$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $d670b54f7076e4a4$var$hostParent = parent.stateNode.containerInfo;
                    $d670b54f7076e4a4$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $d670b54f7076e4a4$var$hostParent) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(160));
        $d670b54f7076e4a4$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $d670b54f7076e4a4$var$hostParent = null;
        $d670b54f7076e4a4$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$d670b54f7076e4a4$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $d670b54f7076e4a4$var$currentHoistableRoot = null;
function $d670b54f7076e4a4$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($d670b54f7076e4a4$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $d670b54f7076e4a4$var$commitHookEffectListMount(3, finishedWork), $d670b54f7076e4a4$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d670b54f7076e4a4$var$offscreenSubtreeWasHidden || null === current || $d670b54f7076e4a4$var$safelyDetachRef(current, current.return));
            flags & 64 && $d670b54f7076e4a4$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $d670b54f7076e4a4$var$currentHoistableRoot;
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d670b54f7076e4a4$var$offscreenSubtreeWasHidden || null === current || $d670b54f7076e4a4$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$d670b54f7076e4a4$var$internalHoistableMarker] || currentResource[$d670b54f7076e4a4$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $d670b54f7076e4a4$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$d670b54f7076e4a4$var$internalInstanceKey] = finishedWork;
                                        $d670b54f7076e4a4$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $d670b54f7076e4a4$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $d670b54f7076e4a4$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $d670b54f7076e4a4$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $d670b54f7076e4a4$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$d670b54f7076e4a4$var$internalInstanceKey] = finishedWork;
                                $d670b54f7076e4a4$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $d670b54f7076e4a4$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $d670b54f7076e4a4$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $d670b54f7076e4a4$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $d670b54f7076e4a4$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $d670b54f7076e4a4$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d670b54f7076e4a4$var$offscreenSubtreeWasHidden || null === current || $d670b54f7076e4a4$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $d670b54f7076e4a4$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d670b54f7076e4a4$var$offscreenSubtreeWasHidden || null === current || $d670b54f7076e4a4$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $d670b54f7076e4a4$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $d670b54f7076e4a4$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($d670b54f7076e4a4$var$needsFormReset = !0);
            break;
        case 6:
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $d670b54f7076e4a4$var$tagCaches = null;
            hoistableRoot = $d670b54f7076e4a4$var$currentHoistableRoot;
            $d670b54f7076e4a4$var$currentHoistableRoot = $d670b54f7076e4a4$var$getHoistableRoot(root.containerInfo);
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$currentHoistableRoot = hoistableRoot;
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $d670b54f7076e4a4$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $d670b54f7076e4a4$var$needsFormReset && ($d670b54f7076e4a4$var$needsFormReset = !1, $d670b54f7076e4a4$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $d670b54f7076e4a4$var$currentHoistableRoot;
            $d670b54f7076e4a4$var$currentHoistableRoot = $d670b54f7076e4a4$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            $d670b54f7076e4a4$var$currentHoistableRoot = flags;
            break;
        case 12:
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $d670b54f7076e4a4$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($d670b54f7076e4a4$var$globalMostRecentFallbackTime = $d670b54f7076e4a4$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $d670b54f7076e4a4$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $d670b54f7076e4a4$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $d670b54f7076e4a4$var$offscreenSubtreeWasHidden;
            $d670b54f7076e4a4$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $d670b54f7076e4a4$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $d670b54f7076e4a4$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $d670b54f7076e4a4$var$offscreenSubtreeIsHidden || $d670b54f7076e4a4$var$offscreenSubtreeWasHidden || $d670b54f7076e4a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $d670b54f7076e4a4$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $d670b54f7076e4a4$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $d670b54f7076e4a4$var$hideOrUnhideDehydratedBoundary(instance, !0) : $d670b54f7076e4a4$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $d670b54f7076e4a4$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $d670b54f7076e4a4$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $d670b54f7076e4a4$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $d670b54f7076e4a4$var$recursivelyTraverseMutationEffects(root, finishedWork), $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork);
    }
}
function $d670b54f7076e4a4$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($d670b54f7076e4a4$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $d670b54f7076e4a4$var$getHostSibling(finishedWork);
                    $d670b54f7076e4a4$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($d670b54f7076e4a4$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $d670b54f7076e4a4$var$getHostSibling(finishedWork);
                    $d670b54f7076e4a4$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $d670b54f7076e4a4$var$getHostSibling(finishedWork);
                    $d670b54f7076e4a4$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $d670b54f7076e4a4$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $d670b54f7076e4a4$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $d670b54f7076e4a4$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$d670b54f7076e4a4$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $d670b54f7076e4a4$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $d670b54f7076e4a4$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $d670b54f7076e4a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $d670b54f7076e4a4$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $d670b54f7076e4a4$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $d670b54f7076e4a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $d670b54f7076e4a4$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $d670b54f7076e4a4$var$safelyDetachRef(finishedWork, finishedWork.return);
                $d670b54f7076e4a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $d670b54f7076e4a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $d670b54f7076e4a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $d670b54f7076e4a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d670b54f7076e4a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $d670b54f7076e4a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $d670b54f7076e4a4$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $d670b54f7076e4a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $d670b54f7076e4a4$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$d670b54f7076e4a4$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $d670b54f7076e4a4$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $d670b54f7076e4a4$var$commitClassCallbacks(finishedWork);
                $d670b54f7076e4a4$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $d670b54f7076e4a4$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $d670b54f7076e4a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $d670b54f7076e4a4$var$commitHostMount(finishedWork);
                $d670b54f7076e4a4$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $d670b54f7076e4a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $d670b54f7076e4a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $d670b54f7076e4a4$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $d670b54f7076e4a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $d670b54f7076e4a4$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $d670b54f7076e4a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $d670b54f7076e4a4$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $d670b54f7076e4a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d670b54f7076e4a4$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $d670b54f7076e4a4$var$releaseCache(previousCache));
}
function $d670b54f7076e4a4$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $d670b54f7076e4a4$var$releaseCache(current));
}
function $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$d670b54f7076e4a4$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $d670b54f7076e4a4$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $d670b54f7076e4a4$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $d670b54f7076e4a4$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $d670b54f7076e4a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $d670b54f7076e4a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $d670b54f7076e4a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $d670b54f7076e4a4$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $d670b54f7076e4a4$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $d670b54f7076e4a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $d670b54f7076e4a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $d670b54f7076e4a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $d670b54f7076e4a4$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $d670b54f7076e4a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $d670b54f7076e4a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $d670b54f7076e4a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $d670b54f7076e4a4$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $d670b54f7076e4a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $d670b54f7076e4a4$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $d670b54f7076e4a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d670b54f7076e4a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $d670b54f7076e4a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $d670b54f7076e4a4$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $d670b54f7076e4a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $d670b54f7076e4a4$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $d670b54f7076e4a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $d670b54f7076e4a4$var$suspenseyCommitFlag = 8192;
function $d670b54f7076e4a4$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $d670b54f7076e4a4$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$d670b54f7076e4a4$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $d670b54f7076e4a4$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $d670b54f7076e4a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $d670b54f7076e4a4$var$suspenseyCommitFlag && null !== fiber.memoizedState && $d670b54f7076e4a4$var$suspendResource(suspendedState, $d670b54f7076e4a4$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $d670b54f7076e4a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $d670b54f7076e4a4$var$currentHoistableRoot;
            $d670b54f7076e4a4$var$currentHoistableRoot = $d670b54f7076e4a4$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $d670b54f7076e4a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $d670b54f7076e4a4$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $d670b54f7076e4a4$var$suspenseyCommitFlag, $d670b54f7076e4a4$var$suspenseyCommitFlag = 16777216, $d670b54f7076e4a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $d670b54f7076e4a4$var$suspenseyCommitFlag = previousHoistableRoot) : $d670b54f7076e4a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $d670b54f7076e4a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $d670b54f7076e4a4$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $d670b54f7076e4a4$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $d670b54f7076e4a4$var$nextEffect = childToDelete;
            $d670b54f7076e4a4$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $d670b54f7076e4a4$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$d670b54f7076e4a4$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $d670b54f7076e4a4$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d670b54f7076e4a4$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $d670b54f7076e4a4$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $d670b54f7076e4a4$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $d670b54f7076e4a4$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $d670b54f7076e4a4$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $d670b54f7076e4a4$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $d670b54f7076e4a4$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $d670b54f7076e4a4$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $d670b54f7076e4a4$var$nextEffect = childToDelete;
            $d670b54f7076e4a4$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $d670b54f7076e4a4$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $d670b54f7076e4a4$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $d670b54f7076e4a4$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $d670b54f7076e4a4$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $d670b54f7076e4a4$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d670b54f7076e4a4$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $d670b54f7076e4a4$var$nextEffect;){
        var fiber = $d670b54f7076e4a4$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $d670b54f7076e4a4$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $d670b54f7076e4a4$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $d670b54f7076e4a4$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $d670b54f7076e4a4$var$nextEffect;){
            cache = $d670b54f7076e4a4$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $d670b54f7076e4a4$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $d670b54f7076e4a4$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $d670b54f7076e4a4$var$nextEffect = sibling;
                break a;
            }
            $d670b54f7076e4a4$var$nextEffect = returnFiber;
        }
    }
}
var $d670b54f7076e4a4$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $d670b54f7076e4a4$var$readContext($d670b54f7076e4a4$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $d670b54f7076e4a4$var$readContext($d670b54f7076e4a4$var$CacheContext).controller.signal;
    }
}, $d670b54f7076e4a4$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $d670b54f7076e4a4$var$executionContext = 0, $d670b54f7076e4a4$var$workInProgressRoot = null, $d670b54f7076e4a4$var$workInProgress = null, $d670b54f7076e4a4$var$workInProgressRootRenderLanes = 0, $d670b54f7076e4a4$var$workInProgressSuspendedReason = 0, $d670b54f7076e4a4$var$workInProgressThrownValue = null, $d670b54f7076e4a4$var$workInProgressRootDidSkipSuspendedSiblings = !1, $d670b54f7076e4a4$var$workInProgressRootIsPrerendering = !1, $d670b54f7076e4a4$var$workInProgressRootDidAttachPingListener = !1, $d670b54f7076e4a4$var$entangledRenderLanes = 0, $d670b54f7076e4a4$var$workInProgressRootExitStatus = 0, $d670b54f7076e4a4$var$workInProgressRootSkippedLanes = 0, $d670b54f7076e4a4$var$workInProgressRootInterleavedUpdatedLanes = 0, $d670b54f7076e4a4$var$workInProgressRootPingedLanes = 0, $d670b54f7076e4a4$var$workInProgressDeferredLane = 0, $d670b54f7076e4a4$var$workInProgressSuspendedRetryLanes = 0, $d670b54f7076e4a4$var$workInProgressRootConcurrentErrors = null, $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors = null, $d670b54f7076e4a4$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $d670b54f7076e4a4$var$globalMostRecentFallbackTime = 0, $d670b54f7076e4a4$var$globalMostRecentTransitionTime = 0, $d670b54f7076e4a4$var$workInProgressRootRenderTargetTime = Infinity, $d670b54f7076e4a4$var$workInProgressTransitions = null, $d670b54f7076e4a4$var$legacyErrorBoundariesThatAlreadyFailed = null, $d670b54f7076e4a4$var$pendingEffectsStatus = 0, $d670b54f7076e4a4$var$pendingEffectsRoot = null, $d670b54f7076e4a4$var$pendingFinishedWork = null, $d670b54f7076e4a4$var$pendingEffectsLanes = 0, $d670b54f7076e4a4$var$pendingEffectsRemainingLanes = 0, $d670b54f7076e4a4$var$pendingPassiveTransitions = null, $d670b54f7076e4a4$var$pendingRecoverableErrors = null, $d670b54f7076e4a4$var$nestedUpdateCount = 0, $d670b54f7076e4a4$var$rootWithNestedUpdates = null;
function $d670b54f7076e4a4$var$requestUpdateLane() {
    return 0 !== ($d670b54f7076e4a4$var$executionContext & 2) && 0 !== $d670b54f7076e4a4$var$workInProgressRootRenderLanes ? $d670b54f7076e4a4$var$workInProgressRootRenderLanes & -$d670b54f7076e4a4$var$workInProgressRootRenderLanes : null !== $d670b54f7076e4a4$var$ReactSharedInternals.T ? $d670b54f7076e4a4$var$requestTransitionLane() : $d670b54f7076e4a4$var$resolveUpdatePriority();
}
function $d670b54f7076e4a4$var$requestDeferredLane() {
    if (0 === $d670b54f7076e4a4$var$workInProgressDeferredLane) {
        if (0 === ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & 536870912) || $d670b54f7076e4a4$var$isHydrating) {
            var lane = $d670b54f7076e4a4$var$nextTransitionDeferredLane;
            $d670b54f7076e4a4$var$nextTransitionDeferredLane <<= 1;
            0 === ($d670b54f7076e4a4$var$nextTransitionDeferredLane & 3932160) && ($d670b54f7076e4a4$var$nextTransitionDeferredLane = 262144);
            $d670b54f7076e4a4$var$workInProgressDeferredLane = lane;
        } else $d670b54f7076e4a4$var$workInProgressDeferredLane = 536870912;
    }
    lane = $d670b54f7076e4a4$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $d670b54f7076e4a4$var$workInProgressDeferredLane;
}
function $d670b54f7076e4a4$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $d670b54f7076e4a4$var$workInProgressRoot && (2 === $d670b54f7076e4a4$var$workInProgressSuspendedReason || 9 === $d670b54f7076e4a4$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $d670b54f7076e4a4$var$prepareFreshStack(root, 0), $d670b54f7076e4a4$var$markRootSuspended(root, $d670b54f7076e4a4$var$workInProgressRootRenderLanes, $d670b54f7076e4a4$var$workInProgressDeferredLane, !1);
    $d670b54f7076e4a4$var$markRootUpdated$1(root, lane);
    if (0 === ($d670b54f7076e4a4$var$executionContext & 2) || root !== $d670b54f7076e4a4$var$workInProgressRoot) root === $d670b54f7076e4a4$var$workInProgressRoot && (0 === ($d670b54f7076e4a4$var$executionContext & 2) && ($d670b54f7076e4a4$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $d670b54f7076e4a4$var$workInProgressRootExitStatus && $d670b54f7076e4a4$var$markRootSuspended(root, $d670b54f7076e4a4$var$workInProgressRootRenderLanes, $d670b54f7076e4a4$var$workInProgressDeferredLane, !1)), $d670b54f7076e4a4$var$ensureRootIsScheduled(root);
}
function $d670b54f7076e4a4$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($d670b54f7076e4a4$var$executionContext & 6)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $d670b54f7076e4a4$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $d670b54f7076e4a4$var$renderRootConcurrent(root$jscomp$0, lanes) : $d670b54f7076e4a4$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $d670b54f7076e4a4$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $d670b54f7076e4a4$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$d670b54f7076e4a4$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $d670b54f7076e4a4$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $d670b54f7076e4a4$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($d670b54f7076e4a4$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $d670b54f7076e4a4$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($d670b54f7076e4a4$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $d670b54f7076e4a4$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors;
                            $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors ? $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors.push.apply($d670b54f7076e4a4$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $d670b54f7076e4a4$var$prepareFreshStack(root$jscomp$0, 0);
                $d670b54f7076e4a4$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $d670b54f7076e4a4$var$markRootSuspended(shouldTimeSlice, lanes, $d670b54f7076e4a4$var$workInProgressDeferredLane, !$d670b54f7076e4a4$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $d670b54f7076e4a4$var$globalMostRecentFallbackTime + 300 - $d670b54f7076e4a4$var$now(), 10 < exitStatus)) {
                    $d670b54f7076e4a4$var$markRootSuspended(shouldTimeSlice, lanes, $d670b54f7076e4a4$var$workInProgressDeferredLane, !$d670b54f7076e4a4$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $d670b54f7076e4a4$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $d670b54f7076e4a4$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $d670b54f7076e4a4$var$scheduleTimeout($d670b54f7076e4a4$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors, $d670b54f7076e4a4$var$workInProgressTransitions, $d670b54f7076e4a4$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $d670b54f7076e4a4$var$workInProgressDeferredLane, $d670b54f7076e4a4$var$workInProgressRootInterleavedUpdatedLanes, $d670b54f7076e4a4$var$workInProgressSuspendedRetryLanes, $d670b54f7076e4a4$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $d670b54f7076e4a4$var$commitRootWhenReady(shouldTimeSlice, forceSync, $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors, $d670b54f7076e4a4$var$workInProgressTransitions, $d670b54f7076e4a4$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $d670b54f7076e4a4$var$workInProgressDeferredLane, $d670b54f7076e4a4$var$workInProgressRootInterleavedUpdatedLanes, $d670b54f7076e4a4$var$workInProgressSuspendedRetryLanes, $d670b54f7076e4a4$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $d670b54f7076e4a4$var$ensureRootIsScheduled(root$jscomp$0);
}
function $d670b54f7076e4a4$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $d670b54f7076e4a4$var$noop$1
        };
        $d670b54f7076e4a4$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $d670b54f7076e4a4$var$globalMostRecentFallbackTime - $d670b54f7076e4a4$var$now() : (lanes & 4194048) === lanes ? $d670b54f7076e4a4$var$globalMostRecentTransitionTime - $d670b54f7076e4a4$var$now() : 0;
        timeoutOffset = $d670b54f7076e4a4$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $d670b54f7076e4a4$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($d670b54f7076e4a4$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $d670b54f7076e4a4$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $d670b54f7076e4a4$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $d670b54f7076e4a4$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$d670b54f7076e4a4$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $d670b54f7076e4a4$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$d670b54f7076e4a4$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$d670b54f7076e4a4$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $d670b54f7076e4a4$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $d670b54f7076e4a4$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $d670b54f7076e4a4$var$flushSyncWork$1() {
    return 0 === ($d670b54f7076e4a4$var$executionContext & 6) ? ($d670b54f7076e4a4$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $d670b54f7076e4a4$var$resetWorkInProgressStack() {
    if (null !== $d670b54f7076e4a4$var$workInProgress) {
        if (0 === $d670b54f7076e4a4$var$workInProgressSuspendedReason) var interruptedWork = $d670b54f7076e4a4$var$workInProgress.return;
        else interruptedWork = $d670b54f7076e4a4$var$workInProgress, $d670b54f7076e4a4$var$lastContextDependency = $d670b54f7076e4a4$var$currentlyRenderingFiber$1 = null, $d670b54f7076e4a4$var$resetHooksOnUnwind(interruptedWork), $d670b54f7076e4a4$var$thenableState$1 = null, $d670b54f7076e4a4$var$thenableIndexCounter$1 = 0, interruptedWork = $d670b54f7076e4a4$var$workInProgress;
        for(; null !== interruptedWork;)$d670b54f7076e4a4$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $d670b54f7076e4a4$var$workInProgress = null;
    }
}
function $d670b54f7076e4a4$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $d670b54f7076e4a4$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $d670b54f7076e4a4$var$pendingEffectsLanes = 0;
    $d670b54f7076e4a4$var$resetWorkInProgressStack();
    $d670b54f7076e4a4$var$workInProgressRoot = root;
    $d670b54f7076e4a4$var$workInProgress = timeoutHandle = $d670b54f7076e4a4$var$createWorkInProgress(root.current, null);
    $d670b54f7076e4a4$var$workInProgressRootRenderLanes = lanes;
    $d670b54f7076e4a4$var$workInProgressSuspendedReason = 0;
    $d670b54f7076e4a4$var$workInProgressThrownValue = null;
    $d670b54f7076e4a4$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $d670b54f7076e4a4$var$workInProgressRootIsPrerendering = $d670b54f7076e4a4$var$checkIfRootIsPrerendering(root, lanes);
    $d670b54f7076e4a4$var$workInProgressRootDidAttachPingListener = !1;
    $d670b54f7076e4a4$var$workInProgressSuspendedRetryLanes = $d670b54f7076e4a4$var$workInProgressDeferredLane = $d670b54f7076e4a4$var$workInProgressRootPingedLanes = $d670b54f7076e4a4$var$workInProgressRootInterleavedUpdatedLanes = $d670b54f7076e4a4$var$workInProgressRootSkippedLanes = $d670b54f7076e4a4$var$workInProgressRootExitStatus = 0;
    $d670b54f7076e4a4$var$workInProgressRootRecoverableErrors = $d670b54f7076e4a4$var$workInProgressRootConcurrentErrors = null;
    $d670b54f7076e4a4$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $d670b54f7076e4a4$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $d670b54f7076e4a4$var$entangledRenderLanes = lanes;
    $d670b54f7076e4a4$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $d670b54f7076e4a4$var$handleThrow(root, thrownValue) {
    $d670b54f7076e4a4$var$currentlyRenderingFiber = null;
    $d670b54f7076e4a4$var$ReactSharedInternals.H = $d670b54f7076e4a4$var$ContextOnlyDispatcher;
    thrownValue === $d670b54f7076e4a4$var$SuspenseException || thrownValue === $d670b54f7076e4a4$var$SuspenseActionException ? (thrownValue = $d670b54f7076e4a4$var$getSuspendedThenable(), $d670b54f7076e4a4$var$workInProgressSuspendedReason = 3) : thrownValue === $d670b54f7076e4a4$var$SuspenseyCommitException ? (thrownValue = $d670b54f7076e4a4$var$getSuspendedThenable(), $d670b54f7076e4a4$var$workInProgressSuspendedReason = 4) : $d670b54f7076e4a4$var$workInProgressSuspendedReason = thrownValue === $d670b54f7076e4a4$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $d670b54f7076e4a4$var$workInProgressThrownValue = thrownValue;
    null === $d670b54f7076e4a4$var$workInProgress && ($d670b54f7076e4a4$var$workInProgressRootExitStatus = 1, $d670b54f7076e4a4$var$logUncaughtError(root, $d670b54f7076e4a4$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $d670b54f7076e4a4$var$shouldRemainOnPreviousScreen() {
    var handler = $d670b54f7076e4a4$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & 4194048) === $d670b54f7076e4a4$var$workInProgressRootRenderLanes ? null === $d670b54f7076e4a4$var$shellBoundary ? !0 : !1 : ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & 62914560) === $d670b54f7076e4a4$var$workInProgressRootRenderLanes || 0 !== ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & 536870912) ? handler === $d670b54f7076e4a4$var$shellBoundary : !1;
}
function $d670b54f7076e4a4$var$pushDispatcher() {
    var prevDispatcher = $d670b54f7076e4a4$var$ReactSharedInternals.H;
    $d670b54f7076e4a4$var$ReactSharedInternals.H = $d670b54f7076e4a4$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $d670b54f7076e4a4$var$ContextOnlyDispatcher : prevDispatcher;
}
function $d670b54f7076e4a4$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $d670b54f7076e4a4$var$ReactSharedInternals.A;
    $d670b54f7076e4a4$var$ReactSharedInternals.A = $d670b54f7076e4a4$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $d670b54f7076e4a4$var$renderDidSuspendDelayIfPossible() {
    $d670b54f7076e4a4$var$workInProgressRootExitStatus = 4;
    $d670b54f7076e4a4$var$workInProgressRootDidSkipSuspendedSiblings || ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & 4194048) !== $d670b54f7076e4a4$var$workInProgressRootRenderLanes && null !== $d670b54f7076e4a4$var$suspenseHandlerStackCursor.current || ($d670b54f7076e4a4$var$workInProgressRootIsPrerendering = !0);
    0 === ($d670b54f7076e4a4$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($d670b54f7076e4a4$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $d670b54f7076e4a4$var$workInProgressRoot || $d670b54f7076e4a4$var$markRootSuspended($d670b54f7076e4a4$var$workInProgressRoot, $d670b54f7076e4a4$var$workInProgressRootRenderLanes, $d670b54f7076e4a4$var$workInProgressDeferredLane, !1);
}
function $d670b54f7076e4a4$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $d670b54f7076e4a4$var$executionContext;
    $d670b54f7076e4a4$var$executionContext |= 2;
    var prevDispatcher = $d670b54f7076e4a4$var$pushDispatcher(), prevAsyncDispatcher = $d670b54f7076e4a4$var$pushAsyncDispatcher();
    if ($d670b54f7076e4a4$var$workInProgressRoot !== root || $d670b54f7076e4a4$var$workInProgressRootRenderLanes !== lanes) $d670b54f7076e4a4$var$workInProgressTransitions = null, $d670b54f7076e4a4$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $d670b54f7076e4a4$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $d670b54f7076e4a4$var$workInProgressSuspendedReason && null !== $d670b54f7076e4a4$var$workInProgress) {
            var unitOfWork = $d670b54f7076e4a4$var$workInProgress, thrownValue = $d670b54f7076e4a4$var$workInProgressThrownValue;
            switch($d670b54f7076e4a4$var$workInProgressSuspendedReason){
                case 8:
                    $d670b54f7076e4a4$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $d670b54f7076e4a4$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $d670b54f7076e4a4$var$workInProgressSuspendedReason;
                    $d670b54f7076e4a4$var$workInProgressSuspendedReason = 0;
                    $d670b54f7076e4a4$var$workInProgressThrownValue = null;
                    $d670b54f7076e4a4$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $d670b54f7076e4a4$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $d670b54f7076e4a4$var$workInProgressSuspendedReason, $d670b54f7076e4a4$var$workInProgressSuspendedReason = 0, $d670b54f7076e4a4$var$workInProgressThrownValue = null, $d670b54f7076e4a4$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $d670b54f7076e4a4$var$workLoopSync();
        exitStatus = $d670b54f7076e4a4$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $d670b54f7076e4a4$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $d670b54f7076e4a4$var$lastContextDependency = $d670b54f7076e4a4$var$currentlyRenderingFiber$1 = null;
    $d670b54f7076e4a4$var$executionContext = prevExecutionContext;
    $d670b54f7076e4a4$var$ReactSharedInternals.H = prevDispatcher;
    $d670b54f7076e4a4$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $d670b54f7076e4a4$var$workInProgress && ($d670b54f7076e4a4$var$workInProgressRoot = null, $d670b54f7076e4a4$var$workInProgressRootRenderLanes = 0, $d670b54f7076e4a4$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $d670b54f7076e4a4$var$workLoopSync() {
    for(; null !== $d670b54f7076e4a4$var$workInProgress;)$d670b54f7076e4a4$var$performUnitOfWork($d670b54f7076e4a4$var$workInProgress);
}
function $d670b54f7076e4a4$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $d670b54f7076e4a4$var$executionContext;
    $d670b54f7076e4a4$var$executionContext |= 2;
    var prevDispatcher = $d670b54f7076e4a4$var$pushDispatcher(), prevAsyncDispatcher = $d670b54f7076e4a4$var$pushAsyncDispatcher();
    $d670b54f7076e4a4$var$workInProgressRoot !== root || $d670b54f7076e4a4$var$workInProgressRootRenderLanes !== lanes ? ($d670b54f7076e4a4$var$workInProgressTransitions = null, $d670b54f7076e4a4$var$workInProgressRootRenderTargetTime = $d670b54f7076e4a4$var$now() + 500, $d670b54f7076e4a4$var$prepareFreshStack(root, lanes)) : $d670b54f7076e4a4$var$workInProgressRootIsPrerendering = $d670b54f7076e4a4$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $d670b54f7076e4a4$var$workInProgressSuspendedReason && null !== $d670b54f7076e4a4$var$workInProgress) {
            lanes = $d670b54f7076e4a4$var$workInProgress;
            var thrownValue = $d670b54f7076e4a4$var$workInProgressThrownValue;
            b: switch($d670b54f7076e4a4$var$workInProgressSuspendedReason){
                case 1:
                    $d670b54f7076e4a4$var$workInProgressSuspendedReason = 0;
                    $d670b54f7076e4a4$var$workInProgressThrownValue = null;
                    $d670b54f7076e4a4$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($d670b54f7076e4a4$var$isThenableResolved(thrownValue)) {
                        $d670b54f7076e4a4$var$workInProgressSuspendedReason = 0;
                        $d670b54f7076e4a4$var$workInProgressThrownValue = null;
                        $d670b54f7076e4a4$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $d670b54f7076e4a4$var$workInProgressSuspendedReason && 9 !== $d670b54f7076e4a4$var$workInProgressSuspendedReason || $d670b54f7076e4a4$var$workInProgressRoot !== root || ($d670b54f7076e4a4$var$workInProgressSuspendedReason = 7);
                        $d670b54f7076e4a4$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $d670b54f7076e4a4$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $d670b54f7076e4a4$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $d670b54f7076e4a4$var$isThenableResolved(thrownValue) ? ($d670b54f7076e4a4$var$workInProgressSuspendedReason = 0, $d670b54f7076e4a4$var$workInProgressThrownValue = null, $d670b54f7076e4a4$var$replaySuspendedUnitOfWork(lanes)) : ($d670b54f7076e4a4$var$workInProgressSuspendedReason = 0, $d670b54f7076e4a4$var$workInProgressThrownValue = null, $d670b54f7076e4a4$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($d670b54f7076e4a4$var$workInProgress.tag){
                        case 26:
                            resource = $d670b54f7076e4a4$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $d670b54f7076e4a4$var$workInProgress;
                            if (resource ? $d670b54f7076e4a4$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $d670b54f7076e4a4$var$workInProgressSuspendedReason = 0;
                                $d670b54f7076e4a4$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $d670b54f7076e4a4$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($d670b54f7076e4a4$var$workInProgress = returnFiber, $d670b54f7076e4a4$var$completeUnitOfWork(returnFiber)) : $d670b54f7076e4a4$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $d670b54f7076e4a4$var$workInProgressSuspendedReason = 0;
                    $d670b54f7076e4a4$var$workInProgressThrownValue = null;
                    $d670b54f7076e4a4$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $d670b54f7076e4a4$var$workInProgressSuspendedReason = 0;
                    $d670b54f7076e4a4$var$workInProgressThrownValue = null;
                    $d670b54f7076e4a4$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $d670b54f7076e4a4$var$resetWorkInProgressStack();
                    $d670b54f7076e4a4$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(462));
            }
        }
        $d670b54f7076e4a4$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $d670b54f7076e4a4$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $d670b54f7076e4a4$var$lastContextDependency = $d670b54f7076e4a4$var$currentlyRenderingFiber$1 = null;
    $d670b54f7076e4a4$var$ReactSharedInternals.H = prevDispatcher;
    $d670b54f7076e4a4$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $d670b54f7076e4a4$var$executionContext = prevExecutionContext;
    if (null !== $d670b54f7076e4a4$var$workInProgress) return 0;
    $d670b54f7076e4a4$var$workInProgressRoot = null;
    $d670b54f7076e4a4$var$workInProgressRootRenderLanes = 0;
    $d670b54f7076e4a4$var$finishQueueingConcurrentUpdates();
    return $d670b54f7076e4a4$var$workInProgressRootExitStatus;
}
function $d670b54f7076e4a4$var$workLoopConcurrentByScheduler() {
    for(; null !== $d670b54f7076e4a4$var$workInProgress && !$d670b54f7076e4a4$var$shouldYield();)$d670b54f7076e4a4$var$performUnitOfWork($d670b54f7076e4a4$var$workInProgress);
}
function $d670b54f7076e4a4$var$performUnitOfWork(unitOfWork) {
    var next = $d670b54f7076e4a4$var$beginWork(unitOfWork.alternate, unitOfWork, $d670b54f7076e4a4$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $d670b54f7076e4a4$var$completeUnitOfWork(unitOfWork) : $d670b54f7076e4a4$var$workInProgress = next;
}
function $d670b54f7076e4a4$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $d670b54f7076e4a4$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $d670b54f7076e4a4$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $d670b54f7076e4a4$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $d670b54f7076e4a4$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $d670b54f7076e4a4$var$resetHooksOnUnwind(next);
        default:
            $d670b54f7076e4a4$var$unwindInterruptedWork(current, next), next = $d670b54f7076e4a4$var$workInProgress = $d670b54f7076e4a4$var$resetWorkInProgress(next, $d670b54f7076e4a4$var$entangledRenderLanes), next = $d670b54f7076e4a4$var$beginWork(current, next, $d670b54f7076e4a4$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $d670b54f7076e4a4$var$completeUnitOfWork(unitOfWork) : $d670b54f7076e4a4$var$workInProgress = next;
}
function $d670b54f7076e4a4$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $d670b54f7076e4a4$var$lastContextDependency = $d670b54f7076e4a4$var$currentlyRenderingFiber$1 = null;
    $d670b54f7076e4a4$var$resetHooksOnUnwind(unitOfWork);
    $d670b54f7076e4a4$var$thenableState$1 = null;
    $d670b54f7076e4a4$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($d670b54f7076e4a4$var$throwException(root, returnFiber, unitOfWork, thrownValue, $d670b54f7076e4a4$var$workInProgressRootRenderLanes)) {
            $d670b54f7076e4a4$var$workInProgressRootExitStatus = 1;
            $d670b54f7076e4a4$var$logUncaughtError(root, $d670b54f7076e4a4$var$createCapturedValueAtFiber(thrownValue, root.current));
            $d670b54f7076e4a4$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $d670b54f7076e4a4$var$workInProgress = returnFiber, error;
        $d670b54f7076e4a4$var$workInProgressRootExitStatus = 1;
        $d670b54f7076e4a4$var$logUncaughtError(root, $d670b54f7076e4a4$var$createCapturedValueAtFiber(thrownValue, root.current));
        $d670b54f7076e4a4$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($d670b54f7076e4a4$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($d670b54f7076e4a4$var$workInProgressRootIsPrerendering || 0 !== ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($d670b54f7076e4a4$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $d670b54f7076e4a4$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $d670b54f7076e4a4$var$unwindUnitOfWork(unitOfWork, root);
    } else $d670b54f7076e4a4$var$completeUnitOfWork(unitOfWork);
}
function $d670b54f7076e4a4$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $d670b54f7076e4a4$var$unwindUnitOfWork(completedWork, $d670b54f7076e4a4$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $d670b54f7076e4a4$var$completeWork(completedWork.alternate, completedWork, $d670b54f7076e4a4$var$entangledRenderLanes);
        if (null !== next) {
            $d670b54f7076e4a4$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $d670b54f7076e4a4$var$workInProgress = completedWork;
            return;
        }
        $d670b54f7076e4a4$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $d670b54f7076e4a4$var$workInProgressRootExitStatus && ($d670b54f7076e4a4$var$workInProgressRootExitStatus = 5);
}
function $d670b54f7076e4a4$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $d670b54f7076e4a4$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $d670b54f7076e4a4$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $d670b54f7076e4a4$var$workInProgress = unitOfWork;
            return;
        }
        $d670b54f7076e4a4$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $d670b54f7076e4a4$var$workInProgressRootExitStatus = 6;
    $d670b54f7076e4a4$var$workInProgress = null;
}
function $d670b54f7076e4a4$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $d670b54f7076e4a4$var$flushPendingEffects();
    while (0 !== $d670b54f7076e4a4$var$pendingEffectsStatus);
    if (0 !== ($d670b54f7076e4a4$var$executionContext & 6)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $d670b54f7076e4a4$var$concurrentlyUpdatedLanes;
        $d670b54f7076e4a4$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $d670b54f7076e4a4$var$workInProgressRoot && ($d670b54f7076e4a4$var$workInProgress = $d670b54f7076e4a4$var$workInProgressRoot = null, $d670b54f7076e4a4$var$workInProgressRootRenderLanes = 0);
        $d670b54f7076e4a4$var$pendingFinishedWork = finishedWork;
        $d670b54f7076e4a4$var$pendingEffectsRoot = root;
        $d670b54f7076e4a4$var$pendingEffectsLanes = lanes;
        $d670b54f7076e4a4$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $d670b54f7076e4a4$var$pendingPassiveTransitions = transitions;
        $d670b54f7076e4a4$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $d670b54f7076e4a4$var$scheduleCallback$1($d670b54f7076e4a4$var$NormalPriority$1, function() {
            $d670b54f7076e4a4$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $d670b54f7076e4a4$var$ReactSharedInternals.T;
            $d670b54f7076e4a4$var$ReactSharedInternals.T = null;
            transitions = $d670b54f7076e4a4$var$ReactDOMSharedInternals.p;
            $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $d670b54f7076e4a4$var$executionContext;
            $d670b54f7076e4a4$var$executionContext |= 4;
            try {
                $d670b54f7076e4a4$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $d670b54f7076e4a4$var$executionContext = spawnedLane, $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = transitions, $d670b54f7076e4a4$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $d670b54f7076e4a4$var$pendingEffectsStatus = 1;
        $d670b54f7076e4a4$var$flushMutationEffects();
        $d670b54f7076e4a4$var$flushLayoutEffects();
        $d670b54f7076e4a4$var$flushSpawnedWork();
    }
}
function $d670b54f7076e4a4$var$flushMutationEffects() {
    if (1 === $d670b54f7076e4a4$var$pendingEffectsStatus) {
        $d670b54f7076e4a4$var$pendingEffectsStatus = 0;
        var root = $d670b54f7076e4a4$var$pendingEffectsRoot, finishedWork = $d670b54f7076e4a4$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $d670b54f7076e4a4$var$ReactSharedInternals.T;
            $d670b54f7076e4a4$var$ReactSharedInternals.T = null;
            var previousPriority = $d670b54f7076e4a4$var$ReactDOMSharedInternals.p;
            $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $d670b54f7076e4a4$var$executionContext;
            $d670b54f7076e4a4$var$executionContext |= 4;
            try {
                $d670b54f7076e4a4$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $d670b54f7076e4a4$var$selectionInformation, curFocusedElem = $d670b54f7076e4a4$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $d670b54f7076e4a4$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $d670b54f7076e4a4$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $d670b54f7076e4a4$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $d670b54f7076e4a4$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $d670b54f7076e4a4$var$_enabled = !!$d670b54f7076e4a4$var$eventsEnabled;
                $d670b54f7076e4a4$var$selectionInformation = $d670b54f7076e4a4$var$eventsEnabled = null;
            } finally{
                $d670b54f7076e4a4$var$executionContext = prevExecutionContext, $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = previousPriority, $d670b54f7076e4a4$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $d670b54f7076e4a4$var$pendingEffectsStatus = 2;
    }
}
function $d670b54f7076e4a4$var$flushLayoutEffects() {
    if (2 === $d670b54f7076e4a4$var$pendingEffectsStatus) {
        $d670b54f7076e4a4$var$pendingEffectsStatus = 0;
        var root = $d670b54f7076e4a4$var$pendingEffectsRoot, finishedWork = $d670b54f7076e4a4$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $d670b54f7076e4a4$var$ReactSharedInternals.T;
            $d670b54f7076e4a4$var$ReactSharedInternals.T = null;
            var previousPriority = $d670b54f7076e4a4$var$ReactDOMSharedInternals.p;
            $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $d670b54f7076e4a4$var$executionContext;
            $d670b54f7076e4a4$var$executionContext |= 4;
            try {
                $d670b54f7076e4a4$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $d670b54f7076e4a4$var$executionContext = prevExecutionContext, $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = previousPriority, $d670b54f7076e4a4$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $d670b54f7076e4a4$var$pendingEffectsStatus = 3;
    }
}
function $d670b54f7076e4a4$var$flushSpawnedWork() {
    if (4 === $d670b54f7076e4a4$var$pendingEffectsStatus || 3 === $d670b54f7076e4a4$var$pendingEffectsStatus) {
        $d670b54f7076e4a4$var$pendingEffectsStatus = 0;
        $d670b54f7076e4a4$var$requestPaint();
        var root = $d670b54f7076e4a4$var$pendingEffectsRoot, finishedWork = $d670b54f7076e4a4$var$pendingFinishedWork, lanes = $d670b54f7076e4a4$var$pendingEffectsLanes, recoverableErrors = $d670b54f7076e4a4$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $d670b54f7076e4a4$var$pendingEffectsStatus = 5 : ($d670b54f7076e4a4$var$pendingEffectsStatus = 0, $d670b54f7076e4a4$var$pendingFinishedWork = $d670b54f7076e4a4$var$pendingEffectsRoot = null, $d670b54f7076e4a4$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($d670b54f7076e4a4$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $d670b54f7076e4a4$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($d670b54f7076e4a4$var$injectedHook && "function" === typeof $d670b54f7076e4a4$var$injectedHook.onCommitFiberRoot) try {
            $d670b54f7076e4a4$var$injectedHook.onCommitFiberRoot($d670b54f7076e4a4$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $d670b54f7076e4a4$var$ReactSharedInternals.T;
            remainingLanes = $d670b54f7076e4a4$var$ReactDOMSharedInternals.p;
            $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = 2;
            $d670b54f7076e4a4$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $d670b54f7076e4a4$var$ReactSharedInternals.T = finishedWork, $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($d670b54f7076e4a4$var$pendingEffectsLanes & 3) && $d670b54f7076e4a4$var$flushPendingEffects();
        $d670b54f7076e4a4$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $d670b54f7076e4a4$var$rootWithNestedUpdates ? $d670b54f7076e4a4$var$nestedUpdateCount++ : ($d670b54f7076e4a4$var$nestedUpdateCount = 0, $d670b54f7076e4a4$var$rootWithNestedUpdates = root) : $d670b54f7076e4a4$var$nestedUpdateCount = 0;
        $d670b54f7076e4a4$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $d670b54f7076e4a4$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $d670b54f7076e4a4$var$releaseCache(remainingLanes)));
}
function $d670b54f7076e4a4$var$flushPendingEffects() {
    $d670b54f7076e4a4$var$flushMutationEffects();
    $d670b54f7076e4a4$var$flushLayoutEffects();
    $d670b54f7076e4a4$var$flushSpawnedWork();
    return $d670b54f7076e4a4$var$flushPassiveEffects();
}
function $d670b54f7076e4a4$var$flushPassiveEffects() {
    if (5 !== $d670b54f7076e4a4$var$pendingEffectsStatus) return !1;
    var root = $d670b54f7076e4a4$var$pendingEffectsRoot, remainingLanes = $d670b54f7076e4a4$var$pendingEffectsRemainingLanes;
    $d670b54f7076e4a4$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $d670b54f7076e4a4$var$lanesToEventPriority($d670b54f7076e4a4$var$pendingEffectsLanes), prevTransition = $d670b54f7076e4a4$var$ReactSharedInternals.T, previousPriority = $d670b54f7076e4a4$var$ReactDOMSharedInternals.p;
    try {
        $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $d670b54f7076e4a4$var$ReactSharedInternals.T = null;
        renderPriority = $d670b54f7076e4a4$var$pendingPassiveTransitions;
        $d670b54f7076e4a4$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $d670b54f7076e4a4$var$pendingEffectsRoot, lanes = $d670b54f7076e4a4$var$pendingEffectsLanes;
        $d670b54f7076e4a4$var$pendingEffectsStatus = 0;
        $d670b54f7076e4a4$var$pendingFinishedWork = $d670b54f7076e4a4$var$pendingEffectsRoot = null;
        $d670b54f7076e4a4$var$pendingEffectsLanes = 0;
        if (0 !== ($d670b54f7076e4a4$var$executionContext & 6)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(331));
        var prevExecutionContext = $d670b54f7076e4a4$var$executionContext;
        $d670b54f7076e4a4$var$executionContext |= 4;
        $d670b54f7076e4a4$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $d670b54f7076e4a4$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $d670b54f7076e4a4$var$executionContext = prevExecutionContext;
        $d670b54f7076e4a4$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($d670b54f7076e4a4$var$injectedHook && "function" === typeof $d670b54f7076e4a4$var$injectedHook.onPostCommitFiberRoot) try {
            $d670b54f7076e4a4$var$injectedHook.onPostCommitFiberRoot($d670b54f7076e4a4$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = previousPriority, $d670b54f7076e4a4$var$ReactSharedInternals.T = prevTransition, $d670b54f7076e4a4$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $d670b54f7076e4a4$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $d670b54f7076e4a4$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $d670b54f7076e4a4$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $d670b54f7076e4a4$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($d670b54f7076e4a4$var$markRootUpdated$1(rootFiber, 2), $d670b54f7076e4a4$var$ensureRootIsScheduled(rootFiber));
}
function $d670b54f7076e4a4$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $d670b54f7076e4a4$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $d670b54f7076e4a4$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $d670b54f7076e4a4$var$legacyErrorBoundariesThatAlreadyFailed || !$d670b54f7076e4a4$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $d670b54f7076e4a4$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $d670b54f7076e4a4$var$createClassErrorUpdate(2);
                instance = $d670b54f7076e4a4$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($d670b54f7076e4a4$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $d670b54f7076e4a4$var$markRootUpdated$1(instance, 2), $d670b54f7076e4a4$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $d670b54f7076e4a4$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $d670b54f7076e4a4$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($d670b54f7076e4a4$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $d670b54f7076e4a4$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $d670b54f7076e4a4$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $d670b54f7076e4a4$var$workInProgressRoot === root && ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $d670b54f7076e4a4$var$workInProgressRootExitStatus || 3 === $d670b54f7076e4a4$var$workInProgressRootExitStatus && ($d670b54f7076e4a4$var$workInProgressRootRenderLanes & 62914560) === $d670b54f7076e4a4$var$workInProgressRootRenderLanes && 300 > $d670b54f7076e4a4$var$now() - $d670b54f7076e4a4$var$globalMostRecentFallbackTime ? 0 === ($d670b54f7076e4a4$var$executionContext & 2) && $d670b54f7076e4a4$var$prepareFreshStack(root, 0) : $d670b54f7076e4a4$var$workInProgressRootPingedLanes |= pingedLanes, $d670b54f7076e4a4$var$workInProgressSuspendedRetryLanes === $d670b54f7076e4a4$var$workInProgressRootRenderLanes && ($d670b54f7076e4a4$var$workInProgressSuspendedRetryLanes = 0));
    $d670b54f7076e4a4$var$ensureRootIsScheduled(root);
}
function $d670b54f7076e4a4$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $d670b54f7076e4a4$var$claimNextRetryLane());
    boundaryFiber = $d670b54f7076e4a4$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($d670b54f7076e4a4$var$markRootUpdated$1(boundaryFiber, retryLane), $d670b54f7076e4a4$var$ensureRootIsScheduled(boundaryFiber));
}
function $d670b54f7076e4a4$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $d670b54f7076e4a4$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $d670b54f7076e4a4$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $d670b54f7076e4a4$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $d670b54f7076e4a4$var$scheduleCallback$1(priorityLevel, callback) {
    return $d670b54f7076e4a4$var$scheduleCallback$3(priorityLevel, callback);
}
var $d670b54f7076e4a4$var$firstScheduledRoot = null, $d670b54f7076e4a4$var$lastScheduledRoot = null, $d670b54f7076e4a4$var$didScheduleMicrotask = !1, $d670b54f7076e4a4$var$mightHavePendingSyncWork = !1, $d670b54f7076e4a4$var$isFlushingWork = !1, $d670b54f7076e4a4$var$currentEventTransitionLane = 0;
function $d670b54f7076e4a4$var$ensureRootIsScheduled(root) {
    root !== $d670b54f7076e4a4$var$lastScheduledRoot && null === root.next && (null === $d670b54f7076e4a4$var$lastScheduledRoot ? $d670b54f7076e4a4$var$firstScheduledRoot = $d670b54f7076e4a4$var$lastScheduledRoot = root : $d670b54f7076e4a4$var$lastScheduledRoot = $d670b54f7076e4a4$var$lastScheduledRoot.next = root);
    $d670b54f7076e4a4$var$mightHavePendingSyncWork = !0;
    $d670b54f7076e4a4$var$didScheduleMicrotask || ($d670b54f7076e4a4$var$didScheduleMicrotask = !0, $d670b54f7076e4a4$var$scheduleImmediateRootScheduleTask());
}
function $d670b54f7076e4a4$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$d670b54f7076e4a4$var$isFlushingWork && $d670b54f7076e4a4$var$mightHavePendingSyncWork) {
        $d670b54f7076e4a4$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $d670b54f7076e4a4$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $d670b54f7076e4a4$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $d670b54f7076e4a4$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $d670b54f7076e4a4$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $d670b54f7076e4a4$var$getNextLanes(root$170, root$170 === $d670b54f7076e4a4$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $d670b54f7076e4a4$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $d670b54f7076e4a4$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $d670b54f7076e4a4$var$isFlushingWork = !1;
    }
}
function $d670b54f7076e4a4$var$processRootScheduleInImmediateTask() {
    $d670b54f7076e4a4$var$processRootScheduleInMicrotask();
}
function $d670b54f7076e4a4$var$processRootScheduleInMicrotask() {
    $d670b54f7076e4a4$var$mightHavePendingSyncWork = $d670b54f7076e4a4$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $d670b54f7076e4a4$var$currentEventTransitionLane && $d670b54f7076e4a4$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $d670b54f7076e4a4$var$currentEventTransitionLane);
    for(var currentTime = $d670b54f7076e4a4$var$now(), prev = null, root = $d670b54f7076e4a4$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $d670b54f7076e4a4$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $d670b54f7076e4a4$var$firstScheduledRoot = next : prev.next = next, null === next && ($d670b54f7076e4a4$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $d670b54f7076e4a4$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $d670b54f7076e4a4$var$pendingEffectsStatus && 5 !== $d670b54f7076e4a4$var$pendingEffectsStatus || $d670b54f7076e4a4$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $d670b54f7076e4a4$var$currentEventTransitionLane && ($d670b54f7076e4a4$var$currentEventTransitionLane = 0);
}
function $d670b54f7076e4a4$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $d670b54f7076e4a4$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $d670b54f7076e4a4$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $d670b54f7076e4a4$var$workInProgressRoot;
    suspendedLanes = $d670b54f7076e4a4$var$workInProgressRootRenderLanes;
    suspendedLanes = $d670b54f7076e4a4$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $d670b54f7076e4a4$var$workInProgressSuspendedReason || 9 === $d670b54f7076e4a4$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $d670b54f7076e4a4$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $d670b54f7076e4a4$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $d670b54f7076e4a4$var$cancelCallback$1(pingedLanes);
        switch($d670b54f7076e4a4$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $d670b54f7076e4a4$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $d670b54f7076e4a4$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $d670b54f7076e4a4$var$IdlePriority;
                break;
            default:
                suspendedLanes = $d670b54f7076e4a4$var$NormalPriority$1;
        }
        pingedLanes = $d670b54f7076e4a4$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $d670b54f7076e4a4$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $d670b54f7076e4a4$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $d670b54f7076e4a4$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $d670b54f7076e4a4$var$pendingEffectsStatus && 5 !== $d670b54f7076e4a4$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($d670b54f7076e4a4$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $d670b54f7076e4a4$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $d670b54f7076e4a4$var$getNextLanes(root, root === $d670b54f7076e4a4$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $d670b54f7076e4a4$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $d670b54f7076e4a4$var$scheduleTaskForRootDuringMicrotask(root, $d670b54f7076e4a4$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $d670b54f7076e4a4$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $d670b54f7076e4a4$var$performSyncWorkOnRoot(root, lanes) {
    if ($d670b54f7076e4a4$var$flushPendingEffects()) return null;
    $d670b54f7076e4a4$var$performWorkOnRoot(root, lanes, !0);
}
function $d670b54f7076e4a4$var$scheduleImmediateRootScheduleTask() {
    $d670b54f7076e4a4$var$scheduleMicrotask(function() {
        0 !== ($d670b54f7076e4a4$var$executionContext & 6) ? $d670b54f7076e4a4$var$scheduleCallback$3($d670b54f7076e4a4$var$ImmediatePriority, $d670b54f7076e4a4$var$processRootScheduleInImmediateTask) : $d670b54f7076e4a4$var$processRootScheduleInMicrotask();
    });
}
function $d670b54f7076e4a4$var$requestTransitionLane() {
    if (0 === $d670b54f7076e4a4$var$currentEventTransitionLane) {
        var actionScopeLane = $d670b54f7076e4a4$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $d670b54f7076e4a4$var$nextTransitionUpdateLane, $d670b54f7076e4a4$var$nextTransitionUpdateLane <<= 1, 0 === ($d670b54f7076e4a4$var$nextTransitionUpdateLane & 261888) && ($d670b54f7076e4a4$var$nextTransitionUpdateLane = 256));
        $d670b54f7076e4a4$var$currentEventTransitionLane = actionScopeLane;
    }
    return $d670b54f7076e4a4$var$currentEventTransitionLane;
}
function $d670b54f7076e4a4$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $d670b54f7076e4a4$var$sanitizeURL("" + actionProp);
}
function $d670b54f7076e4a4$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $d670b54f7076e4a4$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $d670b54f7076e4a4$var$coerceFormActionProp((nativeEventTarget[$d670b54f7076e4a4$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$d670b54f7076e4a4$var$internalPropsKey] || null) ? $d670b54f7076e4a4$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $d670b54f7076e4a4$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $d670b54f7076e4a4$var$currentEventTransitionLane) {
                                var formData = submitter ? $d670b54f7076e4a4$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $d670b54f7076e4a4$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $d670b54f7076e4a4$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $d670b54f7076e4a4$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $d670b54f7076e4a4$var$i$jscomp$inline_1577 = 0; $d670b54f7076e4a4$var$i$jscomp$inline_1577 < $d670b54f7076e4a4$var$simpleEventPluginEvents.length; $d670b54f7076e4a4$var$i$jscomp$inline_1577++){
    var $d670b54f7076e4a4$var$eventName$jscomp$inline_1578 = $d670b54f7076e4a4$var$simpleEventPluginEvents[$d670b54f7076e4a4$var$i$jscomp$inline_1577], $d670b54f7076e4a4$var$domEventName$jscomp$inline_1579 = $d670b54f7076e4a4$var$eventName$jscomp$inline_1578.toLowerCase(), $d670b54f7076e4a4$var$capitalizedEvent$jscomp$inline_1580 = $d670b54f7076e4a4$var$eventName$jscomp$inline_1578[0].toUpperCase() + $d670b54f7076e4a4$var$eventName$jscomp$inline_1578.slice(1);
    $d670b54f7076e4a4$var$registerSimpleEvent($d670b54f7076e4a4$var$domEventName$jscomp$inline_1579, "on" + $d670b54f7076e4a4$var$capitalizedEvent$jscomp$inline_1580);
}
$d670b54f7076e4a4$var$registerSimpleEvent($d670b54f7076e4a4$var$ANIMATION_END, "onAnimationEnd");
$d670b54f7076e4a4$var$registerSimpleEvent($d670b54f7076e4a4$var$ANIMATION_ITERATION, "onAnimationIteration");
$d670b54f7076e4a4$var$registerSimpleEvent($d670b54f7076e4a4$var$ANIMATION_START, "onAnimationStart");
$d670b54f7076e4a4$var$registerSimpleEvent("dblclick", "onDoubleClick");
$d670b54f7076e4a4$var$registerSimpleEvent("focusin", "onFocus");
$d670b54f7076e4a4$var$registerSimpleEvent("focusout", "onBlur");
$d670b54f7076e4a4$var$registerSimpleEvent($d670b54f7076e4a4$var$TRANSITION_RUN, "onTransitionRun");
$d670b54f7076e4a4$var$registerSimpleEvent($d670b54f7076e4a4$var$TRANSITION_START, "onTransitionStart");
$d670b54f7076e4a4$var$registerSimpleEvent($d670b54f7076e4a4$var$TRANSITION_CANCEL, "onTransitionCancel");
$d670b54f7076e4a4$var$registerSimpleEvent($d670b54f7076e4a4$var$TRANSITION_END, "onTransitionEnd");
$d670b54f7076e4a4$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$d670b54f7076e4a4$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$d670b54f7076e4a4$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$d670b54f7076e4a4$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$d670b54f7076e4a4$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$d670b54f7076e4a4$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$d670b54f7076e4a4$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$d670b54f7076e4a4$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$d670b54f7076e4a4$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$d670b54f7076e4a4$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $d670b54f7076e4a4$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $d670b54f7076e4a4$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($d670b54f7076e4a4$var$mediaEventTypes));
function $d670b54f7076e4a4$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $d670b54f7076e4a4$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $d670b54f7076e4a4$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $d670b54f7076e4a4$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$d670b54f7076e4a4$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$d670b54f7076e4a4$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($d670b54f7076e4a4$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $d670b54f7076e4a4$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $d670b54f7076e4a4$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $d670b54f7076e4a4$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $d670b54f7076e4a4$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$d670b54f7076e4a4$var$listeningMarker]) {
        rootContainerElement[$d670b54f7076e4a4$var$listeningMarker] = !0;
        $d670b54f7076e4a4$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($d670b54f7076e4a4$var$nonDelegatedEvents.has(domEventName) || $d670b54f7076e4a4$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $d670b54f7076e4a4$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$d670b54f7076e4a4$var$listeningMarker] || (ownerDocument[$d670b54f7076e4a4$var$listeningMarker] = !0, $d670b54f7076e4a4$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $d670b54f7076e4a4$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($d670b54f7076e4a4$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $d670b54f7076e4a4$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $d670b54f7076e4a4$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $d670b54f7076e4a4$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$d670b54f7076e4a4$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $d670b54f7076e4a4$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $d670b54f7076e4a4$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $d670b54f7076e4a4$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $d670b54f7076e4a4$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $d670b54f7076e4a4$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $d670b54f7076e4a4$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticTouchEvent;
                        break;
                    case $d670b54f7076e4a4$var$ANIMATION_END:
                    case $d670b54f7076e4a4$var$ANIMATION_ITERATION:
                    case $d670b54f7076e4a4$var$ANIMATION_START:
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticAnimationEvent;
                        break;
                    case $d670b54f7076e4a4$var$TRANSITION_END:
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $d670b54f7076e4a4$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $d670b54f7076e4a4$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($d670b54f7076e4a4$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $d670b54f7076e4a4$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($d670b54f7076e4a4$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$d670b54f7076e4a4$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $d670b54f7076e4a4$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $d670b54f7076e4a4$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $d670b54f7076e4a4$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $d670b54f7076e4a4$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $d670b54f7076e4a4$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $d670b54f7076e4a4$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $d670b54f7076e4a4$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $d670b54f7076e4a4$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $d670b54f7076e4a4$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $d670b54f7076e4a4$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $d670b54f7076e4a4$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $d670b54f7076e4a4$var$getTargetInstForChangeEvent;
                else if ($d670b54f7076e4a4$var$isTextInputElement(reactName)) {
                    if ($d670b54f7076e4a4$var$isInputEventSupported) getTargetInstFunc = $d670b54f7076e4a4$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $d670b54f7076e4a4$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $d670b54f7076e4a4$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $d670b54f7076e4a4$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $d670b54f7076e4a4$var$getTargetInstForChangeEvent) : getTargetInstFunc = $d670b54f7076e4a4$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $d670b54f7076e4a4$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $d670b54f7076e4a4$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $d670b54f7076e4a4$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($d670b54f7076e4a4$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $d670b54f7076e4a4$var$activeElement = handleEventFunc, $d670b54f7076e4a4$var$activeElementInst = targetInst, $d670b54f7076e4a4$var$lastSelection = null;
                    break;
                case "focusout":
                    $d670b54f7076e4a4$var$lastSelection = $d670b54f7076e4a4$var$activeElementInst = $d670b54f7076e4a4$var$activeElement = null;
                    break;
                case "mousedown":
                    $d670b54f7076e4a4$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $d670b54f7076e4a4$var$mouseDown = !1;
                    $d670b54f7076e4a4$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($d670b54f7076e4a4$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $d670b54f7076e4a4$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($d670b54f7076e4a4$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $d670b54f7076e4a4$var$isComposing ? $d670b54f7076e4a4$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($d670b54f7076e4a4$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($d670b54f7076e4a4$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $d670b54f7076e4a4$var$isComposing && (fallbackData = $d670b54f7076e4a4$var$getData()) : ($d670b54f7076e4a4$var$root = nativeEventTarget, $d670b54f7076e4a4$var$startText = "value" in $d670b54f7076e4a4$var$root ? $d670b54f7076e4a4$var$root.value : $d670b54f7076e4a4$var$root.textContent, $d670b54f7076e4a4$var$isComposing = !0)), handleEventFunc = $d670b54f7076e4a4$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $d670b54f7076e4a4$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $d670b54f7076e4a4$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $d670b54f7076e4a4$var$canUseTextInputEvent ? $d670b54f7076e4a4$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $d670b54f7076e4a4$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $d670b54f7076e4a4$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $d670b54f7076e4a4$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $d670b54f7076e4a4$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $d670b54f7076e4a4$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $d670b54f7076e4a4$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $d670b54f7076e4a4$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $d670b54f7076e4a4$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($d670b54f7076e4a4$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $d670b54f7076e4a4$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($d670b54f7076e4a4$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $d670b54f7076e4a4$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $d670b54f7076e4a4$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $d670b54f7076e4a4$var$getListener(target, registrationName), null != stateNode && listeners.unshift($d670b54f7076e4a4$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $d670b54f7076e4a4$var$getListener(target, registrationName), null != stateNode && listeners.push($d670b54f7076e4a4$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $d670b54f7076e4a4$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $d670b54f7076e4a4$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $d670b54f7076e4a4$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($d670b54f7076e4a4$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($d670b54f7076e4a4$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $d670b54f7076e4a4$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $d670b54f7076e4a4$var$normalizeMarkupForTextOrAttribute(clientText);
    return $d670b54f7076e4a4$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $d670b54f7076e4a4$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $d670b54f7076e4a4$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $d670b54f7076e4a4$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $d670b54f7076e4a4$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $d670b54f7076e4a4$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $d670b54f7076e4a4$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $d670b54f7076e4a4$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $d670b54f7076e4a4$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $d670b54f7076e4a4$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $d670b54f7076e4a4$var$setProp(domElement, tag, "name", props.name, props, null), $d670b54f7076e4a4$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $d670b54f7076e4a4$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $d670b54f7076e4a4$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($d670b54f7076e4a4$var$setProp(domElement, tag, "encType", props.encType, props, null), $d670b54f7076e4a4$var$setProp(domElement, tag, "method", props.method, props, null), $d670b54f7076e4a4$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $d670b54f7076e4a4$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $d670b54f7076e4a4$var$noop$1);
            break;
        case "onScroll":
            null != value && $d670b54f7076e4a4$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $d670b54f7076e4a4$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $d670b54f7076e4a4$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("toggle", domElement);
            $d670b54f7076e4a4$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $d670b54f7076e4a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $d670b54f7076e4a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $d670b54f7076e4a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $d670b54f7076e4a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $d670b54f7076e4a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $d670b54f7076e4a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $d670b54f7076e4a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $d670b54f7076e4a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $d670b54f7076e4a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $d670b54f7076e4a4$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $d670b54f7076e4a4$var$aliases.get(key) || key, $d670b54f7076e4a4$var$setValueForAttribute(domElement, key, value);
    }
}
function $d670b54f7076e4a4$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $d670b54f7076e4a4$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $d670b54f7076e4a4$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $d670b54f7076e4a4$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $d670b54f7076e4a4$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $d670b54f7076e4a4$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $d670b54f7076e4a4$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$d670b54f7076e4a4$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$d670b54f7076e4a4$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $d670b54f7076e4a4$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $d670b54f7076e4a4$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("error", domElement);
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(137, tag));
                    default:
                        $d670b54f7076e4a4$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $d670b54f7076e4a4$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $d670b54f7076e4a4$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $d670b54f7076e4a4$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $d670b54f7076e4a4$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $d670b54f7076e4a4$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $d670b54f7076e4a4$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $d670b54f7076e4a4$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(91));
                    break;
                default:
                    $d670b54f7076e4a4$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $d670b54f7076e4a4$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $d670b54f7076e4a4$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("toggle", domElement);
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("cancel", domElement);
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $d670b54f7076e4a4$var$mediaEventTypes.length; hasSrc++)$d670b54f7076e4a4$var$listenToNonDelegatedEvent($d670b54f7076e4a4$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("error", domElement);
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $d670b54f7076e4a4$var$listenToNonDelegatedEvent("error", domElement), $d670b54f7076e4a4$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(137, tag));
                default:
                    $d670b54f7076e4a4$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($d670b54f7076e4a4$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $d670b54f7076e4a4$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $d670b54f7076e4a4$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $d670b54f7076e4a4$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $d670b54f7076e4a4$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $d670b54f7076e4a4$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $d670b54f7076e4a4$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $d670b54f7076e4a4$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $d670b54f7076e4a4$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $d670b54f7076e4a4$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $d670b54f7076e4a4$var$updateOptions(domElement, !!lastProps, tag, !0) : $d670b54f7076e4a4$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $d670b54f7076e4a4$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $d670b54f7076e4a4$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $d670b54f7076e4a4$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $d670b54f7076e4a4$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $d670b54f7076e4a4$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $d670b54f7076e4a4$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $d670b54f7076e4a4$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($d670b54f7076e4a4$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $d670b54f7076e4a4$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $d670b54f7076e4a4$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $d670b54f7076e4a4$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $d670b54f7076e4a4$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $d670b54f7076e4a4$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $d670b54f7076e4a4$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $d670b54f7076e4a4$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $d670b54f7076e4a4$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $d670b54f7076e4a4$var$eventsEnabled = null, $d670b54f7076e4a4$var$selectionInformation = null;
function $d670b54f7076e4a4$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $d670b54f7076e4a4$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $d670b54f7076e4a4$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $d670b54f7076e4a4$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $d670b54f7076e4a4$var$currentPopstateTransitionEvent = null;
function $d670b54f7076e4a4$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $d670b54f7076e4a4$var$currentPopstateTransitionEvent) return !1;
        $d670b54f7076e4a4$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $d670b54f7076e4a4$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $d670b54f7076e4a4$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $d670b54f7076e4a4$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $d670b54f7076e4a4$var$localPromise = "function" === typeof Promise ? Promise : void 0, $d670b54f7076e4a4$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $d670b54f7076e4a4$var$localPromise ? function(callback) {
    return $d670b54f7076e4a4$var$localPromise.resolve(null).then(callback).catch($d670b54f7076e4a4$var$handleErrorInNextTick);
} : $d670b54f7076e4a4$var$scheduleTimeout;
function $d670b54f7076e4a4$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $d670b54f7076e4a4$var$isSingletonScope(type) {
    return "head" === type;
}
function $d670b54f7076e4a4$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $d670b54f7076e4a4$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $d670b54f7076e4a4$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $d670b54f7076e4a4$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$d670b54f7076e4a4$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $d670b54f7076e4a4$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $d670b54f7076e4a4$var$retryIfBlockedOn(hydrationInstance);
}
function $d670b54f7076e4a4$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $d670b54f7076e4a4$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $d670b54f7076e4a4$var$clearContainerSparingly(node);
                $d670b54f7076e4a4$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $d670b54f7076e4a4$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$d670b54f7076e4a4$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $d670b54f7076e4a4$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $d670b54f7076e4a4$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $d670b54f7076e4a4$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $d670b54f7076e4a4$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $d670b54f7076e4a4$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $d670b54f7076e4a4$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $d670b54f7076e4a4$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $d670b54f7076e4a4$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $d670b54f7076e4a4$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $d670b54f7076e4a4$var$previousHydratableOnEnteringScopedSingleton = null;
function $d670b54f7076e4a4$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $d670b54f7076e4a4$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $d670b54f7076e4a4$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $d670b54f7076e4a4$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $d670b54f7076e4a4$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(451));
    }
}
function $d670b54f7076e4a4$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $d670b54f7076e4a4$var$detachDeletedInstance(instance);
}
var $d670b54f7076e4a4$var$preloadPropsMap = new Map(), $d670b54f7076e4a4$var$preconnectsSet = new Set();
function $d670b54f7076e4a4$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $d670b54f7076e4a4$var$previousDispatcher = $d670b54f7076e4a4$var$ReactDOMSharedInternals.d;
$d670b54f7076e4a4$var$ReactDOMSharedInternals.d = {
    f: $d670b54f7076e4a4$var$flushSyncWork,
    r: $d670b54f7076e4a4$var$requestFormReset,
    D: $d670b54f7076e4a4$var$prefetchDNS,
    C: $d670b54f7076e4a4$var$preconnect,
    L: $d670b54f7076e4a4$var$preload,
    m: $d670b54f7076e4a4$var$preloadModule,
    X: $d670b54f7076e4a4$var$preinitScript,
    S: $d670b54f7076e4a4$var$preinitStyle,
    M: $d670b54f7076e4a4$var$preinitModuleScript
};
function $d670b54f7076e4a4$var$flushSyncWork() {
    var previousWasRendering = $d670b54f7076e4a4$var$previousDispatcher.f(), wasRendering = $d670b54f7076e4a4$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $d670b54f7076e4a4$var$requestFormReset(form) {
    var formInst = $d670b54f7076e4a4$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $d670b54f7076e4a4$var$requestFormReset$1(formInst) : $d670b54f7076e4a4$var$previousDispatcher.r(form);
}
var $d670b54f7076e4a4$var$globalDocument = "undefined" === typeof document ? null : document;
function $d670b54f7076e4a4$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $d670b54f7076e4a4$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $d670b54f7076e4a4$var$preconnectsSet.has(limitedEscapedHref) || ($d670b54f7076e4a4$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $d670b54f7076e4a4$var$setInitialProperties(href, "link", rel), $d670b54f7076e4a4$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $d670b54f7076e4a4$var$prefetchDNS(href) {
    $d670b54f7076e4a4$var$previousDispatcher.D(href);
    $d670b54f7076e4a4$var$preconnectAs("dns-prefetch", href, null);
}
function $d670b54f7076e4a4$var$preconnect(href, crossOrigin) {
    $d670b54f7076e4a4$var$previousDispatcher.C(href, crossOrigin);
    $d670b54f7076e4a4$var$preconnectAs("preconnect", href, crossOrigin);
}
function $d670b54f7076e4a4$var$preload(href, as, options) {
    $d670b54f7076e4a4$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $d670b54f7076e4a4$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $d670b54f7076e4a4$var$getStyleKey(href);
                break;
            case "script":
                key = $d670b54f7076e4a4$var$getScriptKey(href);
        }
        $d670b54f7076e4a4$var$preloadPropsMap.has(key) || (href = $d670b54f7076e4a4$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $d670b54f7076e4a4$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($d670b54f7076e4a4$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($d670b54f7076e4a4$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $d670b54f7076e4a4$var$setInitialProperties(as, "link", href), $d670b54f7076e4a4$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $d670b54f7076e4a4$var$preloadModule(href, options) {
    $d670b54f7076e4a4$var$previousDispatcher.m(href, options);
    var ownerDocument = $d670b54f7076e4a4$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $d670b54f7076e4a4$var$getScriptKey(href);
        }
        if (!$d670b54f7076e4a4$var$preloadPropsMap.has(key) && (href = $d670b54f7076e4a4$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $d670b54f7076e4a4$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($d670b54f7076e4a4$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $d670b54f7076e4a4$var$setInitialProperties(as, "link", href);
            $d670b54f7076e4a4$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $d670b54f7076e4a4$var$preinitStyle(href, precedence, options) {
    $d670b54f7076e4a4$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $d670b54f7076e4a4$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $d670b54f7076e4a4$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $d670b54f7076e4a4$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($d670b54f7076e4a4$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $d670b54f7076e4a4$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $d670b54f7076e4a4$var$preloadPropsMap.get(key)) && $d670b54f7076e4a4$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $d670b54f7076e4a4$var$markNodeAsHoistable(link);
                $d670b54f7076e4a4$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $d670b54f7076e4a4$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $d670b54f7076e4a4$var$preinitScript(src, options) {
    $d670b54f7076e4a4$var$previousDispatcher.X(src, options);
    var ownerDocument = $d670b54f7076e4a4$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $d670b54f7076e4a4$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $d670b54f7076e4a4$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($d670b54f7076e4a4$var$getScriptSelectorFromKey(key)), resource || (src = $d670b54f7076e4a4$var$assign({
            src: src,
            async: !0
        }, options), (options = $d670b54f7076e4a4$var$preloadPropsMap.get(key)) && $d670b54f7076e4a4$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $d670b54f7076e4a4$var$markNodeAsHoistable(resource), $d670b54f7076e4a4$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $d670b54f7076e4a4$var$preinitModuleScript(src, options) {
    $d670b54f7076e4a4$var$previousDispatcher.M(src, options);
    var ownerDocument = $d670b54f7076e4a4$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $d670b54f7076e4a4$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $d670b54f7076e4a4$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($d670b54f7076e4a4$var$getScriptSelectorFromKey(key)), resource || (src = $d670b54f7076e4a4$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $d670b54f7076e4a4$var$preloadPropsMap.get(key)) && $d670b54f7076e4a4$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $d670b54f7076e4a4$var$markNodeAsHoistable(resource), $d670b54f7076e4a4$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $d670b54f7076e4a4$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $d670b54f7076e4a4$var$rootInstanceStackCursor.current) ? $d670b54f7076e4a4$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $d670b54f7076e4a4$var$getStyleKey(pendingProps.href), pendingProps = $d670b54f7076e4a4$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $d670b54f7076e4a4$var$getStyleKey(pendingProps.href);
                var styles$243 = $d670b54f7076e4a4$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($d670b54f7076e4a4$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $d670b54f7076e4a4$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $d670b54f7076e4a4$var$preloadPropsMap.set(type, pendingProps), styles$243 || $d670b54f7076e4a4$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $d670b54f7076e4a4$var$getScriptKey(pendingProps), pendingProps = $d670b54f7076e4a4$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(444, type));
    }
}
function $d670b54f7076e4a4$var$getStyleKey(href) {
    return 'href="' + $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $d670b54f7076e4a4$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $d670b54f7076e4a4$var$stylesheetPropsFromRawProps(rawProps) {
    return $d670b54f7076e4a4$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $d670b54f7076e4a4$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $d670b54f7076e4a4$var$setInitialProperties(key, "link", preloadProps), $d670b54f7076e4a4$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $d670b54f7076e4a4$var$getScriptKey(src) {
    return '[src="' + $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $d670b54f7076e4a4$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $d670b54f7076e4a4$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $d670b54f7076e4a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $d670b54f7076e4a4$var$markNodeAsHoistable(instance), instance;
            var styleProps = $d670b54f7076e4a4$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $d670b54f7076e4a4$var$markNodeAsHoistable(instance);
            $d670b54f7076e4a4$var$setInitialProperties(instance, "style", styleProps);
            $d670b54f7076e4a4$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $d670b54f7076e4a4$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($d670b54f7076e4a4$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $d670b54f7076e4a4$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $d670b54f7076e4a4$var$stylesheetPropsFromRawProps(props);
            (styleProps = $d670b54f7076e4a4$var$preloadPropsMap.get(styleProps)) && $d670b54f7076e4a4$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $d670b54f7076e4a4$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $d670b54f7076e4a4$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $d670b54f7076e4a4$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $d670b54f7076e4a4$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($d670b54f7076e4a4$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $d670b54f7076e4a4$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $d670b54f7076e4a4$var$preloadPropsMap.get(instance$249)) instance = $d670b54f7076e4a4$var$assign({}, props), $d670b54f7076e4a4$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $d670b54f7076e4a4$var$markNodeAsHoistable(styleProps);
            $d670b54f7076e4a4$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $d670b54f7076e4a4$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $d670b54f7076e4a4$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $d670b54f7076e4a4$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $d670b54f7076e4a4$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $d670b54f7076e4a4$var$tagCaches = null;
function $d670b54f7076e4a4$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $d670b54f7076e4a4$var$tagCaches) {
        var cache = new Map();
        var caches = $d670b54f7076e4a4$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $d670b54f7076e4a4$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$d670b54f7076e4a4$var$internalHoistableMarker] || node[$d670b54f7076e4a4$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $d670b54f7076e4a4$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $d670b54f7076e4a4$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $d670b54f7076e4a4$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $d670b54f7076e4a4$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $d670b54f7076e4a4$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($d670b54f7076e4a4$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $d670b54f7076e4a4$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $d670b54f7076e4a4$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $d670b54f7076e4a4$var$stylesheetPropsFromRawProps(props);
            (key = $d670b54f7076e4a4$var$preloadPropsMap.get(key)) && $d670b54f7076e4a4$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $d670b54f7076e4a4$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $d670b54f7076e4a4$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $d670b54f7076e4a4$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $d670b54f7076e4a4$var$estimatedBytesWithinLimit = 0;
function $d670b54f7076e4a4$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $d670b54f7076e4a4$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $d670b54f7076e4a4$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $d670b54f7076e4a4$var$estimatedBytesWithinLimit && ($d670b54f7076e4a4$var$estimatedBytesWithinLimit = 62500 * $d670b54f7076e4a4$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $d670b54f7076e4a4$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $d670b54f7076e4a4$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $d670b54f7076e4a4$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $d670b54f7076e4a4$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $d670b54f7076e4a4$var$precedencesByRoot = null;
function $d670b54f7076e4a4$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $d670b54f7076e4a4$var$precedencesByRoot = new Map(), resources.forEach($d670b54f7076e4a4$var$insertStylesheetIntoRoot, state), $d670b54f7076e4a4$var$precedencesByRoot = null, $d670b54f7076e4a4$var$onUnsuspend.call(state));
}
function $d670b54f7076e4a4$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $d670b54f7076e4a4$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $d670b54f7076e4a4$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $d670b54f7076e4a4$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $d670b54f7076e4a4$var$HostTransitionContext = {
    $$typeof: $d670b54f7076e4a4$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $d670b54f7076e4a4$var$sharedNotPendingObject,
    _currentValue2: $d670b54f7076e4a4$var$sharedNotPendingObject,
    _threadCount: 0
};
function $d670b54f7076e4a4$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $d670b54f7076e4a4$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $d670b54f7076e4a4$var$createLaneMap(0);
    this.hiddenUpdates = $d670b54f7076e4a4$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $d670b54f7076e4a4$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $d670b54f7076e4a4$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $d670b54f7076e4a4$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $d670b54f7076e4a4$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $d670b54f7076e4a4$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $d670b54f7076e4a4$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $d670b54f7076e4a4$var$emptyContextObject;
    parentComponent = $d670b54f7076e4a4$var$emptyContextObject;
    return parentComponent;
}
function $d670b54f7076e4a4$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $d670b54f7076e4a4$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $d670b54f7076e4a4$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $d670b54f7076e4a4$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($d670b54f7076e4a4$var$scheduleUpdateOnFiber(element, rootFiber, lane), $d670b54f7076e4a4$var$entangleTransitions(element, rootFiber, lane));
}
function $d670b54f7076e4a4$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $d670b54f7076e4a4$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $d670b54f7076e4a4$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $d670b54f7076e4a4$var$markRetryLaneImpl(fiber, retryLane);
}
function $d670b54f7076e4a4$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $d670b54f7076e4a4$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $d670b54f7076e4a4$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $d670b54f7076e4a4$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $d670b54f7076e4a4$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $d670b54f7076e4a4$var$requestUpdateLane();
        lane = $d670b54f7076e4a4$var$getBumpedLaneForHydrationByLane(lane);
        var root = $d670b54f7076e4a4$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $d670b54f7076e4a4$var$scheduleUpdateOnFiber(root, fiber, lane);
        $d670b54f7076e4a4$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $d670b54f7076e4a4$var$_enabled = !0;
function $d670b54f7076e4a4$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $d670b54f7076e4a4$var$ReactSharedInternals.T;
    $d670b54f7076e4a4$var$ReactSharedInternals.T = null;
    var previousPriority = $d670b54f7076e4a4$var$ReactDOMSharedInternals.p;
    try {
        $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = 2, $d670b54f7076e4a4$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = previousPriority, $d670b54f7076e4a4$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d670b54f7076e4a4$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $d670b54f7076e4a4$var$ReactSharedInternals.T;
    $d670b54f7076e4a4$var$ReactSharedInternals.T = null;
    var previousPriority = $d670b54f7076e4a4$var$ReactDOMSharedInternals.p;
    try {
        $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = 8, $d670b54f7076e4a4$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $d670b54f7076e4a4$var$ReactDOMSharedInternals.p = previousPriority, $d670b54f7076e4a4$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d670b54f7076e4a4$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($d670b54f7076e4a4$var$_enabled) {
        var blockedOn = $d670b54f7076e4a4$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $d670b54f7076e4a4$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $d670b54f7076e4a4$var$return_targetInst, targetContainer), $d670b54f7076e4a4$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($d670b54f7076e4a4$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($d670b54f7076e4a4$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $d670b54f7076e4a4$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $d670b54f7076e4a4$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $d670b54f7076e4a4$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $d670b54f7076e4a4$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $d670b54f7076e4a4$var$ensureRootIsScheduled(fiber);
                                0 === ($d670b54f7076e4a4$var$executionContext & 6) && ($d670b54f7076e4a4$var$workInProgressRootRenderTargetTime = $d670b54f7076e4a4$var$now() + 500, $d670b54f7076e4a4$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $d670b54f7076e4a4$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $d670b54f7076e4a4$var$scheduleUpdateOnFiber(root, fiber, 2), $d670b54f7076e4a4$var$flushSyncWork$1(), $d670b54f7076e4a4$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $d670b54f7076e4a4$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $d670b54f7076e4a4$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $d670b54f7076e4a4$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $d670b54f7076e4a4$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $d670b54f7076e4a4$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $d670b54f7076e4a4$var$getEventTarget(nativeEvent);
    return $d670b54f7076e4a4$var$findInstanceBlockingTarget(nativeEvent);
}
var $d670b54f7076e4a4$var$return_targetInst = null;
function $d670b54f7076e4a4$var$findInstanceBlockingTarget(targetNode) {
    $d670b54f7076e4a4$var$return_targetInst = null;
    targetNode = $d670b54f7076e4a4$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $d670b54f7076e4a4$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $d670b54f7076e4a4$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $d670b54f7076e4a4$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $d670b54f7076e4a4$var$return_targetInst = targetNode;
    return null;
}
function $d670b54f7076e4a4$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($d670b54f7076e4a4$var$getCurrentPriorityLevel()){
                case $d670b54f7076e4a4$var$ImmediatePriority:
                    return 2;
                case $d670b54f7076e4a4$var$UserBlockingPriority:
                    return 8;
                case $d670b54f7076e4a4$var$NormalPriority$1:
                case $d670b54f7076e4a4$var$LowPriority:
                    return 32;
                case $d670b54f7076e4a4$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $d670b54f7076e4a4$var$hasScheduledReplayAttempt = !1, $d670b54f7076e4a4$var$queuedFocus = null, $d670b54f7076e4a4$var$queuedDrag = null, $d670b54f7076e4a4$var$queuedMouse = null, $d670b54f7076e4a4$var$queuedPointers = new Map(), $d670b54f7076e4a4$var$queuedPointerCaptures = new Map(), $d670b54f7076e4a4$var$queuedExplicitHydrationTargets = [], $d670b54f7076e4a4$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $d670b54f7076e4a4$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $d670b54f7076e4a4$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $d670b54f7076e4a4$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $d670b54f7076e4a4$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $d670b54f7076e4a4$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $d670b54f7076e4a4$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $d670b54f7076e4a4$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $d670b54f7076e4a4$var$getInstanceFromNode(blockedOn), null !== blockedOn && $d670b54f7076e4a4$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $d670b54f7076e4a4$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $d670b54f7076e4a4$var$queuedFocus = $d670b54f7076e4a4$var$accumulateOrCreateContinuousQueuedReplayableEvent($d670b54f7076e4a4$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $d670b54f7076e4a4$var$queuedDrag = $d670b54f7076e4a4$var$accumulateOrCreateContinuousQueuedReplayableEvent($d670b54f7076e4a4$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $d670b54f7076e4a4$var$queuedMouse = $d670b54f7076e4a4$var$accumulateOrCreateContinuousQueuedReplayableEvent($d670b54f7076e4a4$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $d670b54f7076e4a4$var$queuedPointers.set(pointerId, $d670b54f7076e4a4$var$accumulateOrCreateContinuousQueuedReplayableEvent($d670b54f7076e4a4$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $d670b54f7076e4a4$var$queuedPointerCaptures.set(pointerId, $d670b54f7076e4a4$var$accumulateOrCreateContinuousQueuedReplayableEvent($d670b54f7076e4a4$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $d670b54f7076e4a4$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $d670b54f7076e4a4$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $d670b54f7076e4a4$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $d670b54f7076e4a4$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $d670b54f7076e4a4$var$runWithPriority(queuedTarget.priority, function() {
                        $d670b54f7076e4a4$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $d670b54f7076e4a4$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $d670b54f7076e4a4$var$runWithPriority(queuedTarget.priority, function() {
                        $d670b54f7076e4a4$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $d670b54f7076e4a4$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $d670b54f7076e4a4$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $d670b54f7076e4a4$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $d670b54f7076e4a4$var$currentReplayingEvent = null;
        } else return targetContainers = $d670b54f7076e4a4$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $d670b54f7076e4a4$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $d670b54f7076e4a4$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $d670b54f7076e4a4$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $d670b54f7076e4a4$var$replayUnblockedEvents() {
    $d670b54f7076e4a4$var$hasScheduledReplayAttempt = !1;
    null !== $d670b54f7076e4a4$var$queuedFocus && $d670b54f7076e4a4$var$attemptReplayContinuousQueuedEvent($d670b54f7076e4a4$var$queuedFocus) && ($d670b54f7076e4a4$var$queuedFocus = null);
    null !== $d670b54f7076e4a4$var$queuedDrag && $d670b54f7076e4a4$var$attemptReplayContinuousQueuedEvent($d670b54f7076e4a4$var$queuedDrag) && ($d670b54f7076e4a4$var$queuedDrag = null);
    null !== $d670b54f7076e4a4$var$queuedMouse && $d670b54f7076e4a4$var$attemptReplayContinuousQueuedEvent($d670b54f7076e4a4$var$queuedMouse) && ($d670b54f7076e4a4$var$queuedMouse = null);
    $d670b54f7076e4a4$var$queuedPointers.forEach($d670b54f7076e4a4$var$attemptReplayContinuousQueuedEventInMap);
    $d670b54f7076e4a4$var$queuedPointerCaptures.forEach($d670b54f7076e4a4$var$attemptReplayContinuousQueuedEventInMap);
}
function $d670b54f7076e4a4$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $d670b54f7076e4a4$var$hasScheduledReplayAttempt || ($d670b54f7076e4a4$var$hasScheduledReplayAttempt = !0, $jztx6.unstable_scheduleCallback($jztx6.unstable_NormalPriority, $d670b54f7076e4a4$var$replayUnblockedEvents)));
}
var $d670b54f7076e4a4$var$lastScheduledReplayQueue = null;
function $d670b54f7076e4a4$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $d670b54f7076e4a4$var$lastScheduledReplayQueue !== formReplayingQueue && ($d670b54f7076e4a4$var$lastScheduledReplayQueue = formReplayingQueue, $jztx6.unstable_scheduleCallback($jztx6.unstable_NormalPriority, function() {
        $d670b54f7076e4a4$var$lastScheduledReplayQueue === formReplayingQueue && ($d670b54f7076e4a4$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $d670b54f7076e4a4$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $d670b54f7076e4a4$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $d670b54f7076e4a4$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $d670b54f7076e4a4$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $d670b54f7076e4a4$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $d670b54f7076e4a4$var$queuedFocus && $d670b54f7076e4a4$var$scheduleCallbackIfUnblocked($d670b54f7076e4a4$var$queuedFocus, unblocked);
    null !== $d670b54f7076e4a4$var$queuedDrag && $d670b54f7076e4a4$var$scheduleCallbackIfUnblocked($d670b54f7076e4a4$var$queuedDrag, unblocked);
    null !== $d670b54f7076e4a4$var$queuedMouse && $d670b54f7076e4a4$var$scheduleCallbackIfUnblocked($d670b54f7076e4a4$var$queuedMouse, unblocked);
    $d670b54f7076e4a4$var$queuedPointers.forEach(unblock);
    $d670b54f7076e4a4$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $d670b54f7076e4a4$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $d670b54f7076e4a4$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $d670b54f7076e4a4$var$queuedExplicitHydrationTargets.length && (i = $d670b54f7076e4a4$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$d670b54f7076e4a4$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $d670b54f7076e4a4$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$d670b54f7076e4a4$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $d670b54f7076e4a4$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$d670b54f7076e4a4$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $d670b54f7076e4a4$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $d670b54f7076e4a4$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $d670b54f7076e4a4$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $d670b54f7076e4a4$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$d670b54f7076e4a4$var$ReactDOMHydrationRoot.prototype.render = $d670b54f7076e4a4$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(409));
    var current = root.current, lane = $d670b54f7076e4a4$var$requestUpdateLane();
    $d670b54f7076e4a4$var$updateContainerImpl(current, lane, children, root, null, null);
};
$d670b54f7076e4a4$var$ReactDOMHydrationRoot.prototype.unmount = $d670b54f7076e4a4$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $d670b54f7076e4a4$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $d670b54f7076e4a4$var$flushSyncWork$1();
        container[$d670b54f7076e4a4$var$internalContainerInstanceKey] = null;
    }
};
function $d670b54f7076e4a4$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$d670b54f7076e4a4$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $d670b54f7076e4a4$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $d670b54f7076e4a4$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $d670b54f7076e4a4$var$queuedExplicitHydrationTargets[i].priority; i++);
        $d670b54f7076e4a4$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $d670b54f7076e4a4$var$attemptExplicitHydrationTarget(target);
    }
};
var $d670b54f7076e4a4$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $3OyDL.version;
if ("19.2.8" !== $d670b54f7076e4a4$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(527, $d670b54f7076e4a4$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$d670b54f7076e4a4$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $d670b54f7076e4a4$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $d670b54f7076e4a4$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $d670b54f7076e4a4$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $d670b54f7076e4a4$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $d670b54f7076e4a4$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$d670b54f7076e4a4$var$hook$jscomp$inline_2348.isDisabled && $d670b54f7076e4a4$var$hook$jscomp$inline_2348.supportsFiber) try {
        $d670b54f7076e4a4$var$rendererID = $d670b54f7076e4a4$var$hook$jscomp$inline_2348.inject($d670b54f7076e4a4$var$internals$jscomp$inline_2347), $d670b54f7076e4a4$var$injectedHook = $d670b54f7076e4a4$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$d670b54f7076e4a4$export$882461b6382ed46c = function(container, options) {
    if (!$d670b54f7076e4a4$var$isValidContainer(container)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $d670b54f7076e4a4$var$defaultOnUncaughtError, onCaughtError = $d670b54f7076e4a4$var$defaultOnCaughtError, onRecoverableError = $d670b54f7076e4a4$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $d670b54f7076e4a4$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $d670b54f7076e4a4$var$defaultOnDefaultTransitionIndicator);
    container[$d670b54f7076e4a4$var$internalContainerInstanceKey] = options.current;
    $d670b54f7076e4a4$var$listenToAllSupportedEvents(container);
    return new $d670b54f7076e4a4$var$ReactDOMRoot(options);
};
$d670b54f7076e4a4$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$d670b54f7076e4a4$var$isValidContainer(container)) throw Error($d670b54f7076e4a4$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $d670b54f7076e4a4$var$defaultOnUncaughtError, onCaughtError = $d670b54f7076e4a4$var$defaultOnCaughtError, onRecoverableError = $d670b54f7076e4a4$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $d670b54f7076e4a4$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $d670b54f7076e4a4$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $d670b54f7076e4a4$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $d670b54f7076e4a4$var$requestUpdateLane();
    isStrictMode = $d670b54f7076e4a4$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $d670b54f7076e4a4$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $d670b54f7076e4a4$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $d670b54f7076e4a4$var$markRootUpdated$1(initialChildren, options);
    $d670b54f7076e4a4$var$ensureRootIsScheduled(initialChildren);
    container[$d670b54f7076e4a4$var$internalContainerInstanceKey] = initialChildren.current;
    $d670b54f7076e4a4$var$listenToAllSupportedEvents(container);
    return new $d670b54f7076e4a4$var$ReactDOMHydrationRoot(initialChildren);
};
$d670b54f7076e4a4$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("jztx6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2f5G1"));

});
parcelRegister("2f5G1", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $1a2162c8674aff4e$export$c4744153514ff05d, (v) => $1a2162c8674aff4e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $1a2162c8674aff4e$export$3e506c1ccc9cc1a7, (v) => $1a2162c8674aff4e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $1a2162c8674aff4e$export$e26fe2ed2fa76875, (v) => $1a2162c8674aff4e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $1a2162c8674aff4e$export$502329bbf4b505b1, (v) => $1a2162c8674aff4e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $1a2162c8674aff4e$export$6e3807111c4874c4, (v) => $1a2162c8674aff4e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $1a2162c8674aff4e$export$c27134553091fb3a, (v) => $1a2162c8674aff4e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $1a2162c8674aff4e$export$33ee1acdc04fd2a2, (v) => $1a2162c8674aff4e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $1a2162c8674aff4e$export$b00a404bbd5edef2, (v) => $1a2162c8674aff4e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $1a2162c8674aff4e$export$d66a1c1c77bd778b, (v) => $1a2162c8674aff4e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $1a2162c8674aff4e$export$d3dfb8e4810cb555, (v) => $1a2162c8674aff4e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $1a2162c8674aff4e$export$72fdf0e06517287b, (v) => $1a2162c8674aff4e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $1a2162c8674aff4e$export$816d2913ae6b83b1, (v) => $1a2162c8674aff4e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $1a2162c8674aff4e$export$61bcfe829111a1d0, (v) => $1a2162c8674aff4e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $1a2162c8674aff4e$export$7ee8c9beb337bc3f, (v) => $1a2162c8674aff4e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $1a2162c8674aff4e$export$b5836b71941fa3ed, (v) => $1a2162c8674aff4e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $1a2162c8674aff4e$export$cf845f2c119da08a, (v) => $1a2162c8674aff4e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1a2162c8674aff4e$export$c4744153514ff05d;
var $1a2162c8674aff4e$export$3e506c1ccc9cc1a7;
var $1a2162c8674aff4e$export$e26fe2ed2fa76875;
var $1a2162c8674aff4e$export$502329bbf4b505b1;
var $1a2162c8674aff4e$export$6e3807111c4874c4;
var $1a2162c8674aff4e$export$c27134553091fb3a;
var $1a2162c8674aff4e$export$33ee1acdc04fd2a2;
var $1a2162c8674aff4e$export$b00a404bbd5edef2;
var $1a2162c8674aff4e$export$d66a1c1c77bd778b;
var $1a2162c8674aff4e$export$d3dfb8e4810cb555;
var $1a2162c8674aff4e$export$72fdf0e06517287b;
var $1a2162c8674aff4e$export$816d2913ae6b83b1;
var $1a2162c8674aff4e$export$61bcfe829111a1d0;
var $1a2162c8674aff4e$export$7ee8c9beb337bc3f;
var $1a2162c8674aff4e$export$b5836b71941fa3ed;
var $1a2162c8674aff4e$export$cf845f2c119da08a;
"use strict";
function $1a2162c8674aff4e$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $1a2162c8674aff4e$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $1a2162c8674aff4e$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $1a2162c8674aff4e$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $1a2162c8674aff4e$var$compare(left, last)) rightIndex < length && 0 > $1a2162c8674aff4e$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $1a2162c8674aff4e$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $1a2162c8674aff4e$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$1a2162c8674aff4e$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1a2162c8674aff4e$var$localPerformance = performance;
    $1a2162c8674aff4e$export$c4744153514ff05d = function() {
        return $1a2162c8674aff4e$var$localPerformance.now();
    };
} else {
    var $1a2162c8674aff4e$var$localDate = Date, $1a2162c8674aff4e$var$initialTime = $1a2162c8674aff4e$var$localDate.now();
    $1a2162c8674aff4e$export$c4744153514ff05d = function() {
        return $1a2162c8674aff4e$var$localDate.now() - $1a2162c8674aff4e$var$initialTime;
    };
}
var $1a2162c8674aff4e$var$taskQueue = [], $1a2162c8674aff4e$var$timerQueue = [], $1a2162c8674aff4e$var$taskIdCounter = 1, $1a2162c8674aff4e$var$currentTask = null, $1a2162c8674aff4e$var$currentPriorityLevel = 3, $1a2162c8674aff4e$var$isPerformingWork = !1, $1a2162c8674aff4e$var$isHostCallbackScheduled = !1, $1a2162c8674aff4e$var$isHostTimeoutScheduled = !1, $1a2162c8674aff4e$var$needsPaint = !1, $1a2162c8674aff4e$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $1a2162c8674aff4e$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $1a2162c8674aff4e$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $1a2162c8674aff4e$var$advanceTimers(currentTime) {
    for(var timer = $1a2162c8674aff4e$var$peek($1a2162c8674aff4e$var$timerQueue); null !== timer;){
        if (null === timer.callback) $1a2162c8674aff4e$var$pop($1a2162c8674aff4e$var$timerQueue);
        else if (timer.startTime <= currentTime) $1a2162c8674aff4e$var$pop($1a2162c8674aff4e$var$timerQueue), timer.sortIndex = timer.expirationTime, $1a2162c8674aff4e$var$push($1a2162c8674aff4e$var$taskQueue, timer);
        else break;
        timer = $1a2162c8674aff4e$var$peek($1a2162c8674aff4e$var$timerQueue);
    }
}
function $1a2162c8674aff4e$var$handleTimeout(currentTime) {
    $1a2162c8674aff4e$var$isHostTimeoutScheduled = !1;
    $1a2162c8674aff4e$var$advanceTimers(currentTime);
    if (!$1a2162c8674aff4e$var$isHostCallbackScheduled) {
        if (null !== $1a2162c8674aff4e$var$peek($1a2162c8674aff4e$var$taskQueue)) $1a2162c8674aff4e$var$isHostCallbackScheduled = !0, $1a2162c8674aff4e$var$isMessageLoopRunning || ($1a2162c8674aff4e$var$isMessageLoopRunning = !0, $1a2162c8674aff4e$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $1a2162c8674aff4e$var$peek($1a2162c8674aff4e$var$timerQueue);
            null !== firstTimer && $1a2162c8674aff4e$var$requestHostTimeout($1a2162c8674aff4e$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $1a2162c8674aff4e$var$isMessageLoopRunning = !1, $1a2162c8674aff4e$var$taskTimeoutID = -1, $1a2162c8674aff4e$var$frameInterval = 5, $1a2162c8674aff4e$var$startTime = -1;
function $1a2162c8674aff4e$var$shouldYieldToHost() {
    return $1a2162c8674aff4e$var$needsPaint ? !0 : $1a2162c8674aff4e$export$c4744153514ff05d() - $1a2162c8674aff4e$var$startTime < $1a2162c8674aff4e$var$frameInterval ? !1 : !0;
}
function $1a2162c8674aff4e$var$performWorkUntilDeadline() {
    $1a2162c8674aff4e$var$needsPaint = !1;
    if ($1a2162c8674aff4e$var$isMessageLoopRunning) {
        var currentTime = $1a2162c8674aff4e$export$c4744153514ff05d();
        $1a2162c8674aff4e$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $1a2162c8674aff4e$var$isHostCallbackScheduled = !1;
                $1a2162c8674aff4e$var$isHostTimeoutScheduled && ($1a2162c8674aff4e$var$isHostTimeoutScheduled = !1, $1a2162c8674aff4e$var$localClearTimeout($1a2162c8674aff4e$var$taskTimeoutID), $1a2162c8674aff4e$var$taskTimeoutID = -1);
                $1a2162c8674aff4e$var$isPerformingWork = !0;
                var previousPriorityLevel = $1a2162c8674aff4e$var$currentPriorityLevel;
                try {
                    b: {
                        $1a2162c8674aff4e$var$advanceTimers(currentTime);
                        for($1a2162c8674aff4e$var$currentTask = $1a2162c8674aff4e$var$peek($1a2162c8674aff4e$var$taskQueue); null !== $1a2162c8674aff4e$var$currentTask && !($1a2162c8674aff4e$var$currentTask.expirationTime > currentTime && $1a2162c8674aff4e$var$shouldYieldToHost());){
                            var callback = $1a2162c8674aff4e$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $1a2162c8674aff4e$var$currentTask.callback = null;
                                $1a2162c8674aff4e$var$currentPriorityLevel = $1a2162c8674aff4e$var$currentTask.priorityLevel;
                                var continuationCallback = callback($1a2162c8674aff4e$var$currentTask.expirationTime <= currentTime);
                                currentTime = $1a2162c8674aff4e$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $1a2162c8674aff4e$var$currentTask.callback = continuationCallback;
                                    $1a2162c8674aff4e$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $1a2162c8674aff4e$var$currentTask === $1a2162c8674aff4e$var$peek($1a2162c8674aff4e$var$taskQueue) && $1a2162c8674aff4e$var$pop($1a2162c8674aff4e$var$taskQueue);
                                $1a2162c8674aff4e$var$advanceTimers(currentTime);
                            } else $1a2162c8674aff4e$var$pop($1a2162c8674aff4e$var$taskQueue);
                            $1a2162c8674aff4e$var$currentTask = $1a2162c8674aff4e$var$peek($1a2162c8674aff4e$var$taskQueue);
                        }
                        if (null !== $1a2162c8674aff4e$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $1a2162c8674aff4e$var$peek($1a2162c8674aff4e$var$timerQueue);
                            null !== firstTimer && $1a2162c8674aff4e$var$requestHostTimeout($1a2162c8674aff4e$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $1a2162c8674aff4e$var$currentTask = null, $1a2162c8674aff4e$var$currentPriorityLevel = previousPriorityLevel, $1a2162c8674aff4e$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $1a2162c8674aff4e$var$schedulePerformWorkUntilDeadline() : $1a2162c8674aff4e$var$isMessageLoopRunning = !1;
        }
    }
}
var $1a2162c8674aff4e$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $1a2162c8674aff4e$var$localSetImmediate) $1a2162c8674aff4e$var$schedulePerformWorkUntilDeadline = function() {
    $1a2162c8674aff4e$var$localSetImmediate($1a2162c8674aff4e$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1a2162c8674aff4e$var$channel = new MessageChannel(), $1a2162c8674aff4e$var$port = $1a2162c8674aff4e$var$channel.port2;
    $1a2162c8674aff4e$var$channel.port1.onmessage = $1a2162c8674aff4e$var$performWorkUntilDeadline;
    $1a2162c8674aff4e$var$schedulePerformWorkUntilDeadline = function() {
        $1a2162c8674aff4e$var$port.postMessage(null);
    };
} else $1a2162c8674aff4e$var$schedulePerformWorkUntilDeadline = function() {
    $1a2162c8674aff4e$var$localSetTimeout($1a2162c8674aff4e$var$performWorkUntilDeadline, 0);
};
function $1a2162c8674aff4e$var$requestHostTimeout(callback, ms) {
    $1a2162c8674aff4e$var$taskTimeoutID = $1a2162c8674aff4e$var$localSetTimeout(function() {
        callback($1a2162c8674aff4e$export$c4744153514ff05d());
    }, ms);
}
$1a2162c8674aff4e$export$3e506c1ccc9cc1a7 = 5;
$1a2162c8674aff4e$export$e26fe2ed2fa76875 = 1;
$1a2162c8674aff4e$export$502329bbf4b505b1 = 4;
$1a2162c8674aff4e$export$6e3807111c4874c4 = 3;
$1a2162c8674aff4e$export$c27134553091fb3a = null;
$1a2162c8674aff4e$export$33ee1acdc04fd2a2 = 2;
$1a2162c8674aff4e$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$1a2162c8674aff4e$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1a2162c8674aff4e$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$1a2162c8674aff4e$export$d3dfb8e4810cb555 = function() {
    return $1a2162c8674aff4e$var$currentPriorityLevel;
};
$1a2162c8674aff4e$export$72fdf0e06517287b = function(eventHandler) {
    switch($1a2162c8674aff4e$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $1a2162c8674aff4e$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $1a2162c8674aff4e$var$currentPriorityLevel;
    $1a2162c8674aff4e$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $1a2162c8674aff4e$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$1a2162c8674aff4e$export$816d2913ae6b83b1 = function() {
    $1a2162c8674aff4e$var$needsPaint = !0;
};
$1a2162c8674aff4e$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $1a2162c8674aff4e$var$currentPriorityLevel;
    $1a2162c8674aff4e$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $1a2162c8674aff4e$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$1a2162c8674aff4e$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $1a2162c8674aff4e$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $1a2162c8674aff4e$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $1a2162c8674aff4e$var$push($1a2162c8674aff4e$var$timerQueue, priorityLevel), null === $1a2162c8674aff4e$var$peek($1a2162c8674aff4e$var$taskQueue) && priorityLevel === $1a2162c8674aff4e$var$peek($1a2162c8674aff4e$var$timerQueue) && ($1a2162c8674aff4e$var$isHostTimeoutScheduled ? ($1a2162c8674aff4e$var$localClearTimeout($1a2162c8674aff4e$var$taskTimeoutID), $1a2162c8674aff4e$var$taskTimeoutID = -1) : $1a2162c8674aff4e$var$isHostTimeoutScheduled = !0, $1a2162c8674aff4e$var$requestHostTimeout($1a2162c8674aff4e$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $1a2162c8674aff4e$var$push($1a2162c8674aff4e$var$taskQueue, priorityLevel), $1a2162c8674aff4e$var$isHostCallbackScheduled || $1a2162c8674aff4e$var$isPerformingWork || ($1a2162c8674aff4e$var$isHostCallbackScheduled = !0, $1a2162c8674aff4e$var$isMessageLoopRunning || ($1a2162c8674aff4e$var$isMessageLoopRunning = !0, $1a2162c8674aff4e$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$1a2162c8674aff4e$export$b5836b71941fa3ed = $1a2162c8674aff4e$var$shouldYieldToHost;
$1a2162c8674aff4e$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $1a2162c8674aff4e$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $1a2162c8674aff4e$var$currentPriorityLevel;
        $1a2162c8674aff4e$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $1a2162c8674aff4e$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("dy6Cj", function(module, exports) {
'use strict';
function $9dd39554da419af9$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9dd39554da419af9$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9dd39554da419af9$var$checkDCE();

module.exports = (parcelRequire("61A5Q"));

});
parcelRegister("61A5Q", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $462ed5744cbd6c4d$export$69ce8ef3fe5cead0, (v) => $462ed5744cbd6c4d$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $462ed5744cbd6c4d$export$d39a5bbd09211389, (v) => $462ed5744cbd6c4d$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $462ed5744cbd6c4d$export$cd75ccfd720a3cd4, (v) => $462ed5744cbd6c4d$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $462ed5744cbd6c4d$export$a0816fa17a9e79be, (v) => $462ed5744cbd6c4d$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $462ed5744cbd6c4d$export$7292efcadded39f3, (v) => $462ed5744cbd6c4d$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $462ed5744cbd6c4d$export$da407abadb9b8f86, (v) => $462ed5744cbd6c4d$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $462ed5744cbd6c4d$export$314cfea32580671c, (v) => $462ed5744cbd6c4d$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $462ed5744cbd6c4d$export$513ccb98c53b8039, (v) => $462ed5744cbd6c4d$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $462ed5744cbd6c4d$export$dbca993bc2d264a, (v) => $462ed5744cbd6c4d$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $462ed5744cbd6c4d$export$4797a8006f0655d0, (v) => $462ed5744cbd6c4d$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $462ed5744cbd6c4d$export$c78a37762a8d58e1, (v) => $462ed5744cbd6c4d$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $462ed5744cbd6c4d$export$606f11b2eb45ecc6, (v) => $462ed5744cbd6c4d$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $462ed5744cbd6c4d$export$f7e8a0bf92324b1e, (v) => $462ed5744cbd6c4d$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $462ed5744cbd6c4d$export$83d89fbfd8236492, (v) => $462ed5744cbd6c4d$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $462ed5744cbd6c4d$export$69ce8ef3fe5cead0;
var $462ed5744cbd6c4d$export$d39a5bbd09211389;
var $462ed5744cbd6c4d$export$cd75ccfd720a3cd4;
var $462ed5744cbd6c4d$export$a0816fa17a9e79be;
var $462ed5744cbd6c4d$export$7292efcadded39f3;
var $462ed5744cbd6c4d$export$da407abadb9b8f86;
var $462ed5744cbd6c4d$export$314cfea32580671c;
var $462ed5744cbd6c4d$export$513ccb98c53b8039;
var $462ed5744cbd6c4d$export$dbca993bc2d264a;
var $462ed5744cbd6c4d$export$4797a8006f0655d0;
var $462ed5744cbd6c4d$export$c78a37762a8d58e1;
var $462ed5744cbd6c4d$export$606f11b2eb45ecc6;
var $462ed5744cbd6c4d$export$f7e8a0bf92324b1e;
var $462ed5744cbd6c4d$export$83d89fbfd8236492;
"use strict";

var $3OyDL = parcelRequire("3OyDL");
function $462ed5744cbd6c4d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $462ed5744cbd6c4d$var$noop() {}
var $462ed5744cbd6c4d$var$Internals = {
    d: {
        f: $462ed5744cbd6c4d$var$noop,
        r: function() {
            throw Error($462ed5744cbd6c4d$var$formatProdErrorMessage(522));
        },
        D: $462ed5744cbd6c4d$var$noop,
        C: $462ed5744cbd6c4d$var$noop,
        L: $462ed5744cbd6c4d$var$noop,
        m: $462ed5744cbd6c4d$var$noop,
        X: $462ed5744cbd6c4d$var$noop,
        S: $462ed5744cbd6c4d$var$noop,
        M: $462ed5744cbd6c4d$var$noop
    },
    p: 0,
    findDOMNode: null
}, $462ed5744cbd6c4d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $462ed5744cbd6c4d$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $462ed5744cbd6c4d$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $462ed5744cbd6c4d$var$ReactSharedInternals = $3OyDL.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $462ed5744cbd6c4d$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$462ed5744cbd6c4d$export$69ce8ef3fe5cead0 = $462ed5744cbd6c4d$var$Internals;
$462ed5744cbd6c4d$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($462ed5744cbd6c4d$var$formatProdErrorMessage(299));
    return $462ed5744cbd6c4d$var$createPortal$1(children, container, null, key);
};
$462ed5744cbd6c4d$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $462ed5744cbd6c4d$var$ReactSharedInternals.T, previousUpdatePriority = $462ed5744cbd6c4d$var$Internals.p;
    try {
        if ($462ed5744cbd6c4d$var$ReactSharedInternals.T = null, $462ed5744cbd6c4d$var$Internals.p = 2, fn) return fn();
    } finally{
        $462ed5744cbd6c4d$var$ReactSharedInternals.T = previousTransition, $462ed5744cbd6c4d$var$Internals.p = previousUpdatePriority, $462ed5744cbd6c4d$var$Internals.d.f();
    }
};
$462ed5744cbd6c4d$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $462ed5744cbd6c4d$var$Internals.d.C(href, options));
};
$462ed5744cbd6c4d$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $462ed5744cbd6c4d$var$Internals.d.D(href);
};
$462ed5744cbd6c4d$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $462ed5744cbd6c4d$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $462ed5744cbd6c4d$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $462ed5744cbd6c4d$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$462ed5744cbd6c4d$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $462ed5744cbd6c4d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $462ed5744cbd6c4d$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $462ed5744cbd6c4d$var$Internals.d.M(href);
    }
};
$462ed5744cbd6c4d$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $462ed5744cbd6c4d$var$getCrossOriginStringAs(as, options.crossOrigin);
        $462ed5744cbd6c4d$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$462ed5744cbd6c4d$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $462ed5744cbd6c4d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $462ed5744cbd6c4d$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $462ed5744cbd6c4d$var$Internals.d.m(href);
    }
};
$462ed5744cbd6c4d$export$4797a8006f0655d0 = function(form) {
    $462ed5744cbd6c4d$var$Internals.d.r(form);
};
$462ed5744cbd6c4d$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$462ed5744cbd6c4d$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $462ed5744cbd6c4d$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$462ed5744cbd6c4d$export$f7e8a0bf92324b1e = function() {
    return $462ed5744cbd6c4d$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$462ed5744cbd6c4d$export$83d89fbfd8236492 = "19.2.8";

});




parcelRegister("8B9Zg", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", () => $642986b03a40c414$export$1f3f55432a00e06d);
$parcel$export(module.exports, "RouterProvider", () => $642986b03a40c414$export$323e4fc2fa4753fb);
$parcel$export(module.exports, "BrowserRouter", () => $642986b03a40c414$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $642986b03a40c414$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "NavLink", () => $642986b03a40c414$export$b0d92dbee9b5b60d);
$parcel$export(module.exports, "useSearchParams", () => $642986b03a40c414$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("ZNHD9")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("ZNHD9")).useNavigate);
/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3OyDL = parcelRequire("3OyDL");

var $dy6Cj = parcelRequire("dy6Cj");

var $jIAfL = parcelRequire("jIAfL");
var $ZNHD9 = parcelRequire("ZNHD9");

var $jIAfL = parcelRequire("jIAfL");
function $642986b03a40c414$var$_extends() {
    return $642986b03a40c414$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $642986b03a40c414$var$_extends.apply(null, arguments);
}
function $642986b03a40c414$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $642986b03a40c414$var$defaultMethod = "get";
const $642986b03a40c414$var$defaultEncType = "application/x-www-form-urlencoded";
function $642986b03a40c414$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $642986b03a40c414$var$isButtonElement(object) {
    return $642986b03a40c414$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $642986b03a40c414$var$isFormElement(object) {
    return $642986b03a40c414$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $642986b03a40c414$var$isInputElement(object) {
    return $642986b03a40c414$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $642986b03a40c414$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $642986b03a40c414$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$642986b03a40c414$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $642986b03a40c414$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $642986b03a40c414$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $642986b03a40c414$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $642986b03a40c414$var$_formDataSupportsSubmitter = null;
function $642986b03a40c414$var$isFormDataSubmitterSupported() {
    if ($642986b03a40c414$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $642986b03a40c414$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $642986b03a40c414$var$_formDataSupportsSubmitter = true;
    }
    return $642986b03a40c414$var$_formDataSupportsSubmitter;
}
const $642986b03a40c414$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $642986b03a40c414$var$getFormEncType(encType) {
    if (encType != null && !$642986b03a40c414$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $642986b03a40c414$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($642986b03a40c414$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $jIAfL.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $642986b03a40c414$var$defaultMethod;
        encType = $642986b03a40c414$var$getFormEncType(target.getAttribute("enctype")) || $642986b03a40c414$var$defaultEncType;
        formData = new FormData(target);
    } else if ($642986b03a40c414$var$isButtonElement(target) || $642986b03a40c414$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $jIAfL.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $642986b03a40c414$var$defaultMethod;
        encType = $642986b03a40c414$var$getFormEncType(target.getAttribute("formenctype")) || $642986b03a40c414$var$getFormEncType(form.getAttribute("enctype")) || $642986b03a40c414$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$642986b03a40c414$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($642986b03a40c414$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $642986b03a40c414$var$defaultMethod;
        action = null;
        encType = $642986b03a40c414$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $642986b03a40c414$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $642986b03a40c414$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $642986b03a40c414$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $642986b03a40c414$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $642986b03a40c414$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $642986b03a40c414$export$1f3f55432a00e06d(routes, opts) {
    return (0, $jIAfL.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $642986b03a40c414$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $jIAfL.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $642986b03a40c414$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $ZNHD9.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $642986b03a40c414$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $jIAfL.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $642986b03a40c414$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $jIAfL.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $642986b03a40c414$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $ZNHD9.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $642986b03a40c414$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $642986b03a40c414$var$_extends({}, state, {
        errors: $642986b03a40c414$var$deserializeErrors(state.errors)
    });
    return state;
}
function $642986b03a40c414$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $jIAfL.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $642986b03a40c414$export$7ad602f0e94e62d1 = /*#__PURE__*/ $3OyDL.createContext({
    isTransitioning: false
});
const $642986b03a40c414$export$148fd98d095596d4 = /*#__PURE__*/ $3OyDL.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $642986b03a40c414$var$START_TRANSITION = "startTransition";
const $642986b03a40c414$var$startTransitionImpl = $3OyDL[$642986b03a40c414$var$START_TRANSITION];
const $642986b03a40c414$var$FLUSH_SYNC = "flushSync";
const $642986b03a40c414$var$flushSyncImpl = $dy6Cj[$642986b03a40c414$var$FLUSH_SYNC];
const $642986b03a40c414$var$USE_ID = "useId";
const $642986b03a40c414$var$useIdImpl = $3OyDL[$642986b03a40c414$var$USE_ID];
function $642986b03a40c414$var$startTransitionSafe(cb) {
    if ($642986b03a40c414$var$startTransitionImpl) $642986b03a40c414$var$startTransitionImpl(cb);
    else cb();
}
function $642986b03a40c414$var$flushSyncSafe(cb) {
    if ($642986b03a40c414$var$flushSyncImpl) $642986b03a40c414$var$flushSyncImpl(cb);
    else cb();
}
class $642986b03a40c414$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $642986b03a40c414$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $3OyDL.useState(router.state);
    let [pendingState, setPendingState] = $3OyDL.useState();
    let [vtContext, setVtContext] = $3OyDL.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $3OyDL.useState();
    let [transition, setTransition] = $3OyDL.useState();
    let [interruption, setInterruption] = $3OyDL.useState();
    let fetcherData = $3OyDL.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $3OyDL.useCallback((cb)=>{
        if (v7_startTransition) $642986b03a40c414$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $3OyDL.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $642986b03a40c414$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $642986b03a40c414$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $642986b03a40c414$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $642986b03a40c414$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $642986b03a40c414$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $3OyDL.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $3OyDL.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $642986b03a40c414$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $3OyDL.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $3OyDL.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $3OyDL.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $3OyDL.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $3OyDL.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $3OyDL.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $3OyDL.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $3OyDL.useEffect(()=>(0, $ZNHD9.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $3OyDL.createElement($3OyDL.Fragment, null, /*#__PURE__*/ $3OyDL.createElement((0, $ZNHD9.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $3OyDL.createElement((0, $ZNHD9.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $3OyDL.createElement($642986b03a40c414$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $3OyDL.createElement($642986b03a40c414$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $3OyDL.createElement((0, $ZNHD9.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $3OyDL.createElement($642986b03a40c414$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $642986b03a40c414$var$MemoizedDataRoutes = /*#__PURE__*/ $3OyDL.memo($642986b03a40c414$var$DataRoutes);
function $642986b03a40c414$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $ZNHD9.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $642986b03a40c414$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $3OyDL.useRef();
    if (historyRef.current == null) historyRef.current = (0, $jIAfL.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3OyDL.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3OyDL.useCallback((newState)=>{
        v7_startTransition && $642986b03a40c414$var$startTransitionImpl ? $642986b03a40c414$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3OyDL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $3OyDL.useEffect(()=>(0, $ZNHD9.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $3OyDL.createElement((0, $ZNHD9.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $642986b03a40c414$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $3OyDL.useRef();
    if (historyRef.current == null) historyRef.current = (0, $jIAfL.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3OyDL.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3OyDL.useCallback((newState)=>{
        v7_startTransition && $642986b03a40c414$var$startTransitionImpl ? $642986b03a40c414$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3OyDL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $3OyDL.useEffect(()=>(0, $ZNHD9.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $3OyDL.createElement((0, $ZNHD9.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $642986b03a40c414$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $3OyDL.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3OyDL.useCallback((newState)=>{
        v7_startTransition && $642986b03a40c414$var$startTransitionImpl ? $642986b03a40c414$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3OyDL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $3OyDL.useEffect(()=>(0, $ZNHD9.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $3OyDL.createElement((0, $ZNHD9.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $642986b03a40c414$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $642986b03a40c414$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $642986b03a40c414$export$a6c7ac8248d6e38a = /*#__PURE__*/ $3OyDL.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $642986b03a40c414$var$_objectWithoutPropertiesLoose(_ref7, $642986b03a40c414$var$_excluded);
    let { basename: basename } = $3OyDL.useContext((0, $ZNHD9.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $642986b03a40c414$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($642986b03a40c414$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $jIAfL.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $ZNHD9.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $642986b03a40c414$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $3OyDL.createElement("a", $642986b03a40c414$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $642986b03a40c414$export$b0d92dbee9b5b60d = /*#__PURE__*/ $3OyDL.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $642986b03a40c414$var$_objectWithoutPropertiesLoose(_ref8, $642986b03a40c414$var$_excluded2);
    let path = (0, $ZNHD9.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $ZNHD9.useLocation)();
    let routerState = $3OyDL.useContext((0, $ZNHD9.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $3OyDL.useContext((0, $ZNHD9.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $642986b03a40c414$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $jIAfL.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $3OyDL.createElement($642986b03a40c414$export$a6c7ac8248d6e38a, $642986b03a40c414$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $642986b03a40c414$export$a7fed597f4b8afd8 = /*#__PURE__*/ $3OyDL.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $642986b03a40c414$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $642986b03a40c414$var$_objectWithoutPropertiesLoose(_ref9, $642986b03a40c414$var$_excluded3);
    let submit = $642986b03a40c414$export$47c85c6e3a081d3();
    let formAction = $642986b03a40c414$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $3OyDL.createElement("form", $642986b03a40c414$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $642986b03a40c414$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $642986b03a40c414$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $642986b03a40c414$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($642986b03a40c414$var$DataRouterHook || ($642986b03a40c414$var$DataRouterHook = {}));
var $642986b03a40c414$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($642986b03a40c414$var$DataRouterStateHook || ($642986b03a40c414$var$DataRouterStateHook = {}));
// Internal hooks
function $642986b03a40c414$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $642986b03a40c414$var$useDataRouterContext(hookName) {
    let ctx = $3OyDL.useContext((0, $ZNHD9.UNSAFE_DataRouterContext));
    !ctx && (0, $jIAfL.UNSAFE_invariant)(false);
    return ctx;
}
function $642986b03a40c414$var$useDataRouterState(hookName) {
    let state = $3OyDL.useContext((0, $ZNHD9.UNSAFE_DataRouterStateContext));
    !state && (0, $jIAfL.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $642986b03a40c414$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $ZNHD9.useNavigate)();
    let location = (0, $ZNHD9.useLocation)();
    let path = (0, $ZNHD9.useResolvedPath)(to, {
        relative: relative
    });
    return $3OyDL.useCallback((event)=>{
        if ($642986b03a40c414$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $jIAfL.createPath)(location) === (0, $jIAfL.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $642986b03a40c414$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $3OyDL.useRef($642986b03a40c414$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $3OyDL.useRef(false);
    let location = (0, $ZNHD9.useLocation)();
    let searchParams = $3OyDL.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $642986b03a40c414$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $ZNHD9.useNavigate)();
    let setSearchParams = $3OyDL.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $642986b03a40c414$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $642986b03a40c414$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $642986b03a40c414$var$fetcherId = 0;
let $642986b03a40c414$var$getUniqueFetcherId = ()=>"__" + String(++$642986b03a40c414$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $642986b03a40c414$export$47c85c6e3a081d3() {
    let { router: router } = $642986b03a40c414$var$useDataRouterContext($642986b03a40c414$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $3OyDL.useContext((0, $ZNHD9.UNSAFE_NavigationContext));
    let currentRouteId = (0, $ZNHD9.UNSAFE_useRouteId)();
    return $3OyDL.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $642986b03a40c414$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $642986b03a40c414$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $642986b03a40c414$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $642986b03a40c414$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $3OyDL.useContext((0, $ZNHD9.UNSAFE_NavigationContext));
    let routeContext = $3OyDL.useContext((0, $ZNHD9.UNSAFE_RouteContext));
    !routeContext && (0, $jIAfL.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $642986b03a40c414$var$_extends({}, (0, $ZNHD9.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $ZNHD9.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $jIAfL.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $jIAfL.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $642986b03a40c414$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $642986b03a40c414$var$useDataRouterContext($642986b03a40c414$var$DataRouterHook.UseFetcher);
    let state = $642986b03a40c414$var$useDataRouterState($642986b03a40c414$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $3OyDL.useContext($642986b03a40c414$export$148fd98d095596d4);
    let route = $3OyDL.useContext((0, $ZNHD9.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $jIAfL.UNSAFE_invariant)(false);
    !route && (0, $jIAfL.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $jIAfL.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $642986b03a40c414$var$useIdImpl ? $642986b03a40c414$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $3OyDL.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($642986b03a40c414$var$getUniqueFetcherId());
    // Registration/cleanup
    $3OyDL.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $3OyDL.useCallback((href, opts)=>{
        !routeId && (0, $jIAfL.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $642986b03a40c414$export$47c85c6e3a081d3();
    let submit = $3OyDL.useCallback((target, opts)=>{
        submitImpl(target, $642986b03a40c414$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $3OyDL.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $3OyDL.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $3OyDL.createElement($642986b03a40c414$export$a7fed597f4b8afd8, $642986b03a40c414$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $jIAfL.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $3OyDL.useMemo(()=>$642986b03a40c414$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $642986b03a40c414$export$fa996778a3a31087() {
    let state = $642986b03a40c414$var$useDataRouterState($642986b03a40c414$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $642986b03a40c414$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $642986b03a40c414$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $642986b03a40c414$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $642986b03a40c414$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $642986b03a40c414$var$useDataRouterContext($642986b03a40c414$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $642986b03a40c414$var$useDataRouterState($642986b03a40c414$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $3OyDL.useContext((0, $ZNHD9.UNSAFE_NavigationContext));
    let location = (0, $ZNHD9.useLocation)();
    let matches = (0, $ZNHD9.useMatches)();
    let navigation = (0, $ZNHD9.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $3OyDL.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $642986b03a40c414$var$usePageHide($3OyDL.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $642986b03a40c414$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $642986b03a40c414$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($642986b03a40c414$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3OyDL.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $642986b03a40c414$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $642986b03a40c414$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3OyDL.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($642986b03a40c414$var$_extends({}, location, {
                    pathname: (0, $jIAfL.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($642986b03a40c414$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3OyDL.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $642986b03a40c414$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $3OyDL.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $642986b03a40c414$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $3OyDL.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $642986b03a40c414$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $ZNHD9.useBlocker)(when);
    $3OyDL.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $3OyDL.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $642986b03a40c414$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $3OyDL.useContext($642986b03a40c414$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $jIAfL.UNSAFE_invariant)(false);
    let { basename: basename } = $642986b03a40c414$var$useDataRouterContext($642986b03a40c414$var$DataRouterHook.useViewTransitionState);
    let path = (0, $ZNHD9.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $jIAfL.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $jIAfL.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $jIAfL.matchPath)(path.pathname, nextPath) != null || (0, $jIAfL.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("jIAfL", function(module, exports) {

$parcel$export(module.exports, "Action", () => $e5ae3f8b7217f137$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $e5ae3f8b7217f137$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $e5ae3f8b7217f137$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $e5ae3f8b7217f137$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $e5ae3f8b7217f137$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $e5ae3f8b7217f137$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $e5ae3f8b7217f137$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $e5ae3f8b7217f137$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $e5ae3f8b7217f137$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $e5ae3f8b7217f137$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $e5ae3f8b7217f137$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $e5ae3f8b7217f137$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $e5ae3f8b7217f137$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $e5ae3f8b7217f137$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $e5ae3f8b7217f137$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $e5ae3f8b7217f137$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $e5ae3f8b7217f137$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $e5ae3f8b7217f137$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $e5ae3f8b7217f137$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $e5ae3f8b7217f137$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $e5ae3f8b7217f137$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $e5ae3f8b7217f137$var$_extends() {
    return $e5ae3f8b7217f137$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e5ae3f8b7217f137$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $e5ae3f8b7217f137$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($e5ae3f8b7217f137$export$e19cd5f9376f8cee || ($e5ae3f8b7217f137$export$e19cd5f9376f8cee = {}));
const $e5ae3f8b7217f137$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $e5ae3f8b7217f137$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $e5ae3f8b7217f137$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $e5ae3f8b7217f137$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $e5ae3f8b7217f137$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $e5ae3f8b7217f137$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $e5ae3f8b7217f137$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $e5ae3f8b7217f137$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $e5ae3f8b7217f137$export$fe53371bee54353d(to);
    }
    return $e5ae3f8b7217f137$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $e5ae3f8b7217f137$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $e5ae3f8b7217f137$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $e5ae3f8b7217f137$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $e5ae3f8b7217f137$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $e5ae3f8b7217f137$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $e5ae3f8b7217f137$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $e5ae3f8b7217f137$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $e5ae3f8b7217f137$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $e5ae3f8b7217f137$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $e5ae3f8b7217f137$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $e5ae3f8b7217f137$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $e5ae3f8b7217f137$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $e5ae3f8b7217f137$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $e5ae3f8b7217f137$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $e5ae3f8b7217f137$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $e5ae3f8b7217f137$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $e5ae3f8b7217f137$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($e5ae3f8b7217f137$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Push;
        let location = $e5ae3f8b7217f137$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $e5ae3f8b7217f137$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Replace;
        let location = $e5ae3f8b7217f137$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $e5ae3f8b7217f137$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $e5ae3f8b7217f137$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $e5ae3f8b7217f137$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($e5ae3f8b7217f137$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($e5ae3f8b7217f137$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $e5ae3f8b7217f137$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($e5ae3f8b7217f137$var$ResultType || ($e5ae3f8b7217f137$var$ResultType = {}));
const $e5ae3f8b7217f137$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $e5ae3f8b7217f137$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $e5ae3f8b7217f137$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $e5ae3f8b7217f137$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $e5ae3f8b7217f137$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($e5ae3f8b7217f137$var$isIndexRoute(route)) {
            let indexRoute = $e5ae3f8b7217f137$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $e5ae3f8b7217f137$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $e5ae3f8b7217f137$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $e5ae3f8b7217f137$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $e5ae3f8b7217f137$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $e5ae3f8b7217f137$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $e5ae3f8b7217f137$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $e5ae3f8b7217f137$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $e5ae3f8b7217f137$var$flattenRoutes(routes);
    $e5ae3f8b7217f137$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $e5ae3f8b7217f137$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $e5ae3f8b7217f137$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $e5ae3f8b7217f137$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $e5ae3f8b7217f137$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $e5ae3f8b7217f137$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $e5ae3f8b7217f137$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $e5ae3f8b7217f137$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $e5ae3f8b7217f137$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $e5ae3f8b7217f137$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $e5ae3f8b7217f137$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $e5ae3f8b7217f137$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $e5ae3f8b7217f137$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $e5ae3f8b7217f137$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $e5ae3f8b7217f137$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $e5ae3f8b7217f137$var$paramRe = /^:[\w-]+$/;
const $e5ae3f8b7217f137$var$dynamicSegmentValue = 3;
const $e5ae3f8b7217f137$var$indexRouteValue = 2;
const $e5ae3f8b7217f137$var$emptySegmentValue = 1;
const $e5ae3f8b7217f137$var$staticSegmentValue = 10;
const $e5ae3f8b7217f137$var$splatPenalty = -2;
const $e5ae3f8b7217f137$var$isSplat = (s)=>s === "*";
function $e5ae3f8b7217f137$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($e5ae3f8b7217f137$var$isSplat)) initialScore += $e5ae3f8b7217f137$var$splatPenalty;
    if (index) initialScore += $e5ae3f8b7217f137$var$indexRouteValue;
    return segments.filter((s)=>!$e5ae3f8b7217f137$var$isSplat(s)).reduce((score, segment)=>score + ($e5ae3f8b7217f137$var$paramRe.test(segment) ? $e5ae3f8b7217f137$var$dynamicSegmentValue : segment === "" ? $e5ae3f8b7217f137$var$emptySegmentValue : $e5ae3f8b7217f137$var$staticSegmentValue), initialScore);
}
function $e5ae3f8b7217f137$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $e5ae3f8b7217f137$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $e5ae3f8b7217f137$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $e5ae3f8b7217f137$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $e5ae3f8b7217f137$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $e5ae3f8b7217f137$export$a5c6d149b50c1d86($e5ae3f8b7217f137$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $e5ae3f8b7217f137$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $e5ae3f8b7217f137$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $e5ae3f8b7217f137$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $e5ae3f8b7217f137$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $e5ae3f8b7217f137$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $e5ae3f8b7217f137$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $e5ae3f8b7217f137$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $e5ae3f8b7217f137$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $e5ae3f8b7217f137$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $e5ae3f8b7217f137$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $e5ae3f8b7217f137$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $e5ae3f8b7217f137$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $e5ae3f8b7217f137$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $e5ae3f8b7217f137$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $e5ae3f8b7217f137$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $e5ae3f8b7217f137$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $e5ae3f8b7217f137$var$normalizeSearch(search),
        hash: $e5ae3f8b7217f137$var$normalizeHash(hash)
    };
}
function $e5ae3f8b7217f137$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $e5ae3f8b7217f137$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $e5ae3f8b7217f137$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $e5ae3f8b7217f137$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $e5ae3f8b7217f137$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $e5ae3f8b7217f137$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $e5ae3f8b7217f137$export$8ccf933b0513f8d0(toArg);
    else {
        to = $e5ae3f8b7217f137$var$_extends({}, toArg);
        $e5ae3f8b7217f137$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $e5ae3f8b7217f137$var$getInvalidPathError("?", "pathname", "search", to));
        $e5ae3f8b7217f137$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $e5ae3f8b7217f137$var$getInvalidPathError("#", "pathname", "hash", to));
        $e5ae3f8b7217f137$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $e5ae3f8b7217f137$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $e5ae3f8b7217f137$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $e5ae3f8b7217f137$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $e5ae3f8b7217f137$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $e5ae3f8b7217f137$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $e5ae3f8b7217f137$export$86d9a7913e44197e = (paths)=>$e5ae3f8b7217f137$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $e5ae3f8b7217f137$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $e5ae3f8b7217f137$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $e5ae3f8b7217f137$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $e5ae3f8b7217f137$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $e5ae3f8b7217f137$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $e5ae3f8b7217f137$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $e5ae3f8b7217f137$export$4051a07651545597(data, init) {
    return new $e5ae3f8b7217f137$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $e5ae3f8b7217f137$export$42a99a7a4bc0e76a extends Error {
}
class $e5ae3f8b7217f137$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $e5ae3f8b7217f137$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $e5ae3f8b7217f137$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $e5ae3f8b7217f137$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $e5ae3f8b7217f137$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $e5ae3f8b7217f137$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $e5ae3f8b7217f137$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $e5ae3f8b7217f137$var$unwrapTrackedPromise(value) {
    if (!$e5ae3f8b7217f137$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $e5ae3f8b7217f137$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $e5ae3f8b7217f137$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e5ae3f8b7217f137$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $e5ae3f8b7217f137$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e5ae3f8b7217f137$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $e5ae3f8b7217f137$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e5ae3f8b7217f137$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $e5ae3f8b7217f137$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $e5ae3f8b7217f137$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $e5ae3f8b7217f137$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $e5ae3f8b7217f137$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $e5ae3f8b7217f137$var$validMutationMethods = new Set($e5ae3f8b7217f137$var$validMutationMethodsArr);
const $e5ae3f8b7217f137$var$validRequestMethodsArr = [
    "get",
    ...$e5ae3f8b7217f137$var$validMutationMethodsArr
];
const $e5ae3f8b7217f137$var$validRequestMethods = new Set($e5ae3f8b7217f137$var$validRequestMethodsArr);
const $e5ae3f8b7217f137$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $e5ae3f8b7217f137$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $e5ae3f8b7217f137$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e5ae3f8b7217f137$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e5ae3f8b7217f137$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $e5ae3f8b7217f137$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e5ae3f8b7217f137$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $e5ae3f8b7217f137$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $e5ae3f8b7217f137$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $e5ae3f8b7217f137$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e5ae3f8b7217f137$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $e5ae3f8b7217f137$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $e5ae3f8b7217f137$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $e5ae3f8b7217f137$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $e5ae3f8b7217f137$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $e5ae3f8b7217f137$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $e5ae3f8b7217f137$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$e5ae3f8b7217f137$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$e5ae3f8b7217f137$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $e5ae3f8b7217f137$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $e5ae3f8b7217f137$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $e5ae3f8b7217f137$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $e5ae3f8b7217f137$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$e5ae3f8b7217f137$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($e5ae3f8b7217f137$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $e5ae3f8b7217f137$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $e5ae3f8b7217f137$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $e5ae3f8b7217f137$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $e5ae3f8b7217f137$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $e5ae3f8b7217f137$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($e5ae3f8b7217f137$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $e5ae3f8b7217f137$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $e5ae3f8b7217f137$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $e5ae3f8b7217f137$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $e5ae3f8b7217f137$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $e5ae3f8b7217f137$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $e5ae3f8b7217f137$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $e5ae3f8b7217f137$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $e5ae3f8b7217f137$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $e5ae3f8b7217f137$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $e5ae3f8b7217f137$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $e5ae3f8b7217f137$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $e5ae3f8b7217f137$var$findNearestBoundary(matches).route.id,
            {
                type: $e5ae3f8b7217f137$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $e5ae3f8b7217f137$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($e5ae3f8b7217f137$var$isErrorResult(result) && $e5ae3f8b7217f137$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $e5ae3f8b7217f137$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $e5ae3f8b7217f137$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $e5ae3f8b7217f137$var$_extends({
            matches: updatedMatches || matches
        }, $e5ae3f8b7217f137$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $e5ae3f8b7217f137$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e5ae3f8b7217f137$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $e5ae3f8b7217f137$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $e5ae3f8b7217f137$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $e5ae3f8b7217f137$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $e5ae3f8b7217f137$var$ResultType.error,
            error: $e5ae3f8b7217f137$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($e5ae3f8b7217f137$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $e5ae3f8b7217f137$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($e5ae3f8b7217f137$var$isDeferredResult(result)) throw $e5ae3f8b7217f137$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($e5ae3f8b7217f137$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $e5ae3f8b7217f137$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $e5ae3f8b7217f137$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $e5ae3f8b7217f137$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($e5ae3f8b7217f137$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e5ae3f8b7217f137$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $e5ae3f8b7217f137$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $e5ae3f8b7217f137$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $e5ae3f8b7217f137$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $e5ae3f8b7217f137$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $e5ae3f8b7217f137$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $e5ae3f8b7217f137$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e5ae3f8b7217f137$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $e5ae3f8b7217f137$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $e5ae3f8b7217f137$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$e5ae3f8b7217f137$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $e5ae3f8b7217f137$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $e5ae3f8b7217f137$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $e5ae3f8b7217f137$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $e5ae3f8b7217f137$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $e5ae3f8b7217f137$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $e5ae3f8b7217f137$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $e5ae3f8b7217f137$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $e5ae3f8b7217f137$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e5ae3f8b7217f137$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e5ae3f8b7217f137$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e5ae3f8b7217f137$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $e5ae3f8b7217f137$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($e5ae3f8b7217f137$var$isRedirectResult(actionResult) || $e5ae3f8b7217f137$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $e5ae3f8b7217f137$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($e5ae3f8b7217f137$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $e5ae3f8b7217f137$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $e5ae3f8b7217f137$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($e5ae3f8b7217f137$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($e5ae3f8b7217f137$var$isDeferredResult(actionResult)) throw $e5ae3f8b7217f137$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $e5ae3f8b7217f137$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $e5ae3f8b7217f137$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $e5ae3f8b7217f137$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $e5ae3f8b7217f137$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $e5ae3f8b7217f137$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $e5ae3f8b7217f137$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $e5ae3f8b7217f137$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $e5ae3f8b7217f137$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e5ae3f8b7217f137$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $e5ae3f8b7217f137$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $e5ae3f8b7217f137$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $e5ae3f8b7217f137$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e5ae3f8b7217f137$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e5ae3f8b7217f137$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e5ae3f8b7217f137$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $e5ae3f8b7217f137$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($e5ae3f8b7217f137$var$isDeferredResult(result)) result = await $e5ae3f8b7217f137$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $e5ae3f8b7217f137$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($e5ae3f8b7217f137$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $e5ae3f8b7217f137$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($e5ae3f8b7217f137$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $e5ae3f8b7217f137$export$3e9cee6b33872309(!$e5ae3f8b7217f137$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $e5ae3f8b7217f137$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $e5ae3f8b7217f137$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $e5ae3f8b7217f137$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $e5ae3f8b7217f137$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($e5ae3f8b7217f137$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $e5ae3f8b7217f137$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Replace : $e5ae3f8b7217f137$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $e5ae3f8b7217f137$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($e5ae3f8b7217f137$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $e5ae3f8b7217f137$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $e5ae3f8b7217f137$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $e5ae3f8b7217f137$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $e5ae3f8b7217f137$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $e5ae3f8b7217f137$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($e5ae3f8b7217f137$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $e5ae3f8b7217f137$var$ResultType.redirect,
                response: $e5ae3f8b7217f137$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $e5ae3f8b7217f137$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $e5ae3f8b7217f137$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $e5ae3f8b7217f137$var$ResultType.error,
                    error: $e5ae3f8b7217f137$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $e5ae3f8b7217f137$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $e5ae3f8b7217f137$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $e5ae3f8b7217f137$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $e5ae3f8b7217f137$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $e5ae3f8b7217f137$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $e5ae3f8b7217f137$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $e5ae3f8b7217f137$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $e5ae3f8b7217f137$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $e5ae3f8b7217f137$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $e5ae3f8b7217f137$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $e5ae3f8b7217f137$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $e5ae3f8b7217f137$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $e5ae3f8b7217f137$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $e5ae3f8b7217f137$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$e5ae3f8b7217f137$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $e5ae3f8b7217f137$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $e5ae3f8b7217f137$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $e5ae3f8b7217f137$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $e5ae3f8b7217f137$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $e5ae3f8b7217f137$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $e5ae3f8b7217f137$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $e5ae3f8b7217f137$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $e5ae3f8b7217f137$export$4d0306f8f6a4585b = Symbol("deferred");
function $e5ae3f8b7217f137$export$3336b097a6fbc59a(routes, opts) {
    $e5ae3f8b7217f137$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e5ae3f8b7217f137$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $e5ae3f8b7217f137$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $e5ae3f8b7217f137$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e5ae3f8b7217f137$var$createLocation("", $e5ae3f8b7217f137$export$fe53371bee54353d(url), null, "default");
        let matches = $e5ae3f8b7217f137$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e5ae3f8b7217f137$var$isValidMethod(method) && method !== "HEAD") {
            let error = $e5ae3f8b7217f137$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $e5ae3f8b7217f137$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $e5ae3f8b7217f137$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e5ae3f8b7217f137$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($e5ae3f8b7217f137$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $e5ae3f8b7217f137$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e5ae3f8b7217f137$var$createLocation("", $e5ae3f8b7217f137$export$fe53371bee54353d(url), null, "default");
        let matches = $e5ae3f8b7217f137$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e5ae3f8b7217f137$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $e5ae3f8b7217f137$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $e5ae3f8b7217f137$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $e5ae3f8b7217f137$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $e5ae3f8b7217f137$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $e5ae3f8b7217f137$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($e5ae3f8b7217f137$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$e5ae3f8b7217f137$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $e5ae3f8b7217f137$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($e5ae3f8b7217f137$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $e5ae3f8b7217f137$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $e5ae3f8b7217f137$var$isResponse(result) ? result : $e5ae3f8b7217f137$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($e5ae3f8b7217f137$var$isDataStrategyResult(e) && $e5ae3f8b7217f137$var$isResponse(e.result)) {
                if (e.type === $e5ae3f8b7217f137$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($e5ae3f8b7217f137$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $e5ae3f8b7217f137$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e5ae3f8b7217f137$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $e5ae3f8b7217f137$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($e5ae3f8b7217f137$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($e5ae3f8b7217f137$var$isDeferredResult(result)) {
            let error = $e5ae3f8b7217f137$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e5ae3f8b7217f137$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($e5ae3f8b7217f137$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($e5ae3f8b7217f137$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $e5ae3f8b7217f137$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $e5ae3f8b7217f137$var$_extends({}, context, {
                statusCode: $e5ae3f8b7217f137$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $e5ae3f8b7217f137$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $e5ae3f8b7217f137$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $e5ae3f8b7217f137$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $e5ae3f8b7217f137$var$isErrorResult(pendingActionResult[1]) ? $e5ae3f8b7217f137$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $e5ae3f8b7217f137$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $e5ae3f8b7217f137$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $e5ae3f8b7217f137$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $e5ae3f8b7217f137$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $e5ae3f8b7217f137$var$callDataStrategyImpl(dataStrategy || $e5ae3f8b7217f137$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($e5ae3f8b7217f137$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $e5ae3f8b7217f137$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($e5ae3f8b7217f137$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $e5ae3f8b7217f137$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $e5ae3f8b7217f137$export$fec11da027c70692(routes, context, error) {
    let newContext = $e5ae3f8b7217f137$var$_extends({}, context, {
        statusCode: $e5ae3f8b7217f137$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $e5ae3f8b7217f137$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $e5ae3f8b7217f137$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $e5ae3f8b7217f137$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $e5ae3f8b7217f137$export$cae722b0cc860f13(to ? to : ".", $e5ae3f8b7217f137$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $e5ae3f8b7217f137$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $e5ae3f8b7217f137$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $e5ae3f8b7217f137$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $e5ae3f8b7217f137$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $e5ae3f8b7217f137$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$e5ae3f8b7217f137$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$e5ae3f8b7217f137$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $e5ae3f8b7217f137$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $e5ae3f8b7217f137$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $e5ae3f8b7217f137$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$e5ae3f8b7217f137$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$e5ae3f8b7217f137$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $e5ae3f8b7217f137$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $e5ae3f8b7217f137$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $e5ae3f8b7217f137$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $e5ae3f8b7217f137$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $e5ae3f8b7217f137$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($e5ae3f8b7217f137$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $e5ae3f8b7217f137$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $e5ae3f8b7217f137$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $e5ae3f8b7217f137$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $e5ae3f8b7217f137$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $e5ae3f8b7217f137$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $e5ae3f8b7217f137$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $e5ae3f8b7217f137$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $e5ae3f8b7217f137$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $e5ae3f8b7217f137$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $e5ae3f8b7217f137$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($e5ae3f8b7217f137$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $e5ae3f8b7217f137$var$shouldRevalidateLoader(match, $e5ae3f8b7217f137$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $e5ae3f8b7217f137$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $e5ae3f8b7217f137$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $e5ae3f8b7217f137$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $e5ae3f8b7217f137$var$shouldRevalidateLoader(fetcherMatch, $e5ae3f8b7217f137$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $e5ae3f8b7217f137$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $e5ae3f8b7217f137$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $e5ae3f8b7217f137$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $e5ae3f8b7217f137$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $e5ae3f8b7217f137$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $e5ae3f8b7217f137$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$e5ae3f8b7217f137$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $e5ae3f8b7217f137$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $e5ae3f8b7217f137$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$e5ae3f8b7217f137$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $e5ae3f8b7217f137$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $e5ae3f8b7217f137$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $e5ae3f8b7217f137$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$e5ae3f8b7217f137$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $e5ae3f8b7217f137$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $e5ae3f8b7217f137$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $e5ae3f8b7217f137$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $e5ae3f8b7217f137$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $e5ae3f8b7217f137$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $e5ae3f8b7217f137$var$ResultType.data,
                result: undefined
            });
        };
        return $e5ae3f8b7217f137$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $e5ae3f8b7217f137$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $e5ae3f8b7217f137$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $e5ae3f8b7217f137$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $e5ae3f8b7217f137$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $e5ae3f8b7217f137$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $e5ae3f8b7217f137$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $e5ae3f8b7217f137$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($e5ae3f8b7217f137$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $e5ae3f8b7217f137$var$ResultType.error,
                error: e
            };
        }
        if (type === $e5ae3f8b7217f137$var$ResultType.error) return {
            type: $e5ae3f8b7217f137$var$ResultType.error,
            error: new $e5ae3f8b7217f137$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $e5ae3f8b7217f137$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $e5ae3f8b7217f137$var$ResultType.error) {
        if ($e5ae3f8b7217f137$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $e5ae3f8b7217f137$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $e5ae3f8b7217f137$var$ResultType.error,
                error: new $e5ae3f8b7217f137$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $e5ae3f8b7217f137$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $e5ae3f8b7217f137$var$ResultType.error,
            error: result,
            statusCode: $e5ae3f8b7217f137$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($e5ae3f8b7217f137$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $e5ae3f8b7217f137$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($e5ae3f8b7217f137$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $e5ae3f8b7217f137$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $e5ae3f8b7217f137$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $e5ae3f8b7217f137$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $e5ae3f8b7217f137$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$e5ae3f8b7217f137$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $e5ae3f8b7217f137$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $e5ae3f8b7217f137$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($e5ae3f8b7217f137$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $e5ae3f8b7217f137$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $e5ae3f8b7217f137$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $e5ae3f8b7217f137$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($e5ae3f8b7217f137$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $e5ae3f8b7217f137$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $e5ae3f8b7217f137$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $e5ae3f8b7217f137$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $e5ae3f8b7217f137$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $e5ae3f8b7217f137$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $e5ae3f8b7217f137$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $e5ae3f8b7217f137$export$3e9cee6b33872309(!$e5ae3f8b7217f137$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($e5ae3f8b7217f137$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $e5ae3f8b7217f137$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $e5ae3f8b7217f137$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($e5ae3f8b7217f137$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $e5ae3f8b7217f137$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $e5ae3f8b7217f137$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $e5ae3f8b7217f137$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($e5ae3f8b7217f137$var$isErrorResult(result)) {
            let boundaryMatch = $e5ae3f8b7217f137$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $e5ae3f8b7217f137$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($e5ae3f8b7217f137$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $e5ae3f8b7217f137$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($e5ae3f8b7217f137$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $e5ae3f8b7217f137$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $e5ae3f8b7217f137$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $e5ae3f8b7217f137$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $e5ae3f8b7217f137$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $e5ae3f8b7217f137$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $e5ae3f8b7217f137$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $e5ae3f8b7217f137$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $e5ae3f8b7217f137$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $e5ae3f8b7217f137$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $e5ae3f8b7217f137$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $e5ae3f8b7217f137$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($e5ae3f8b7217f137$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $e5ae3f8b7217f137$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $e5ae3f8b7217f137$export$8ccf933b0513f8d0(path) : path;
    return $e5ae3f8b7217f137$export$fe53371bee54353d($e5ae3f8b7217f137$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $e5ae3f8b7217f137$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $e5ae3f8b7217f137$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $e5ae3f8b7217f137$var$ResultType.data || result.type === $e5ae3f8b7217f137$var$ResultType.error);
}
function $e5ae3f8b7217f137$var$isRedirectDataStrategyResultResult(result) {
    return $e5ae3f8b7217f137$var$isResponse(result.result) && $e5ae3f8b7217f137$var$redirectStatusCodes.has(result.result.status);
}
function $e5ae3f8b7217f137$var$isDeferredResult(result) {
    return result.type === $e5ae3f8b7217f137$var$ResultType.deferred;
}
function $e5ae3f8b7217f137$var$isErrorResult(result) {
    return result.type === $e5ae3f8b7217f137$var$ResultType.error;
}
function $e5ae3f8b7217f137$var$isRedirectResult(result) {
    return (result && result.type) === $e5ae3f8b7217f137$var$ResultType.redirect;
}
function $e5ae3f8b7217f137$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $e5ae3f8b7217f137$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $e5ae3f8b7217f137$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $e5ae3f8b7217f137$var$isRedirectResponse(result) {
    if (!$e5ae3f8b7217f137$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $e5ae3f8b7217f137$var$isValidMethod(method) {
    return $e5ae3f8b7217f137$var$validRequestMethods.has(method.toLowerCase());
}
function $e5ae3f8b7217f137$var$isMutationMethod(method) {
    return $e5ae3f8b7217f137$var$validMutationMethods.has(method.toLowerCase());
}
async function $e5ae3f8b7217f137$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$e5ae3f8b7217f137$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($e5ae3f8b7217f137$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $e5ae3f8b7217f137$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $e5ae3f8b7217f137$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($e5ae3f8b7217f137$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $e5ae3f8b7217f137$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $e5ae3f8b7217f137$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $e5ae3f8b7217f137$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $e5ae3f8b7217f137$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $e5ae3f8b7217f137$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $e5ae3f8b7217f137$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $e5ae3f8b7217f137$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $e5ae3f8b7217f137$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $e5ae3f8b7217f137$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $e5ae3f8b7217f137$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $e5ae3f8b7217f137$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $e5ae3f8b7217f137$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $e5ae3f8b7217f137$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $e5ae3f8b7217f137$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $e5ae3f8b7217f137$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $e5ae3f8b7217f137$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $e5ae3f8b7217f137$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $e5ae3f8b7217f137$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($e5ae3f8b7217f137$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $e5ae3f8b7217f137$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($e5ae3f8b7217f137$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $e5ae3f8b7217f137$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("ZNHD9", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $0b9c408b616e5110$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $0b9c408b616e5110$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $0b9c408b616e5110$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $0b9c408b616e5110$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $0b9c408b616e5110$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $0b9c408b616e5110$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $0b9c408b616e5110$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $0b9c408b616e5110$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $0b9c408b616e5110$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $0b9c408b616e5110$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $0b9c408b616e5110$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $0b9c408b616e5110$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $0b9c408b616e5110$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $0b9c408b616e5110$export$b273b3273281a049);
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", () => $0b9c408b616e5110$export$db5148ec97d6af7a);
$parcel$export(module.exports, "Router", () => $0b9c408b616e5110$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $0b9c408b616e5110$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $0b9c408b616e5110$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $0b9c408b616e5110$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $0b9c408b616e5110$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $0b9c408b616e5110$export$52b333d321859367);
/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3OyDL = parcelRequire("3OyDL");

var $jIAfL = parcelRequire("jIAfL");
function $0b9c408b616e5110$var$_extends() {
    return $0b9c408b616e5110$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0b9c408b616e5110$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $0b9c408b616e5110$export$3add0d5dce533e2e = /*#__PURE__*/ $3OyDL.createContext(null);
const $0b9c408b616e5110$export$145dfa71566a64dc = /*#__PURE__*/ $3OyDL.createContext(null);
const $0b9c408b616e5110$var$AwaitContext = /*#__PURE__*/ $3OyDL.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $0b9c408b616e5110$export$26749e8557646306 = /*#__PURE__*/ $3OyDL.createContext(null);
const $0b9c408b616e5110$export$c7914228fb69b0f5 = /*#__PURE__*/ $3OyDL.createContext(null);
const $0b9c408b616e5110$export$9072aa6dd1f93057 = /*#__PURE__*/ $3OyDL.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $0b9c408b616e5110$var$RouteErrorContext = /*#__PURE__*/ $3OyDL.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $0b9c408b616e5110$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$0b9c408b616e5110$export$9c954a9d03d32f4a() && (0, $jIAfL.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $3OyDL.useContext($0b9c408b616e5110$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $0b9c408b616e5110$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $jIAfL.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $0b9c408b616e5110$export$9c954a9d03d32f4a() {
    return $3OyDL.useContext($0b9c408b616e5110$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $0b9c408b616e5110$export$45d76561a5302f2b() {
    !$0b9c408b616e5110$export$9c954a9d03d32f4a() && (0, $jIAfL.UNSAFE_invariant)(false);
    return $3OyDL.useContext($0b9c408b616e5110$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $0b9c408b616e5110$export$1b3f31771c5d07c() {
    return $3OyDL.useContext($0b9c408b616e5110$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $0b9c408b616e5110$export$6c330e8992e8a295(pattern) {
    !$0b9c408b616e5110$export$9c954a9d03d32f4a() && (0, $jIAfL.UNSAFE_invariant)(false);
    let { pathname: pathname } = $0b9c408b616e5110$export$45d76561a5302f2b();
    return $3OyDL.useMemo(()=>(0, $jIAfL.matchPath)(pattern, (0, $jIAfL.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $0b9c408b616e5110$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $0b9c408b616e5110$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $3OyDL.useContext($0b9c408b616e5110$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $3OyDL.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $0b9c408b616e5110$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $3OyDL.useContext($0b9c408b616e5110$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $0b9c408b616e5110$var$useNavigateStable() : $0b9c408b616e5110$var$useNavigateUnstable();
}
function $0b9c408b616e5110$var$useNavigateUnstable() {
    !$0b9c408b616e5110$export$9c954a9d03d32f4a() && (0, $jIAfL.UNSAFE_invariant)(false);
    let dataRouterContext = $3OyDL.useContext($0b9c408b616e5110$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $3OyDL.useContext($0b9c408b616e5110$export$26749e8557646306);
    let { matches: matches } = $3OyDL.useContext($0b9c408b616e5110$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0b9c408b616e5110$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $jIAfL.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $3OyDL.useRef(false);
    $0b9c408b616e5110$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $3OyDL.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $jIAfL.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $jIAfL.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $0b9c408b616e5110$var$OutletContext = /*#__PURE__*/ $3OyDL.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $0b9c408b616e5110$export$4138103a3ae699cc() {
    return $3OyDL.useContext($0b9c408b616e5110$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $0b9c408b616e5110$export$a3be3530d8e40d0b(context) {
    let outlet = $3OyDL.useContext($0b9c408b616e5110$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $0b9c408b616e5110$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $3OyDL.useContext($0b9c408b616e5110$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $0b9c408b616e5110$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $3OyDL.useContext($0b9c408b616e5110$export$26749e8557646306);
    let { matches: matches } = $3OyDL.useContext($0b9c408b616e5110$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0b9c408b616e5110$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $jIAfL.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $3OyDL.useMemo(()=>(0, $jIAfL.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $0b9c408b616e5110$export$5d3fca4a98652595(routes, locationArg) {
    return $0b9c408b616e5110$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $0b9c408b616e5110$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$0b9c408b616e5110$export$9c954a9d03d32f4a() && (0, $jIAfL.UNSAFE_invariant)(false);
    let { navigator: navigator } = $3OyDL.useContext($0b9c408b616e5110$export$26749e8557646306);
    let { matches: parentMatches } = $3OyDL.useContext($0b9c408b616e5110$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $0b9c408b616e5110$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $jIAfL.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $jIAfL.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $jIAfL.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $0b9c408b616e5110$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $jIAfL.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $jIAfL.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $0b9c408b616e5110$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $jIAfL.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $0b9c408b616e5110$var$DefaultErrorComponent() {
    let error = $0b9c408b616e5110$export$ed527bf60f6e05f2();
    let message = (0, $jIAfL.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $3OyDL.createElement($3OyDL.Fragment, null, /*#__PURE__*/ $3OyDL.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $3OyDL.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $3OyDL.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $0b9c408b616e5110$var$defaultErrorElement = /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$var$DefaultErrorComponent, null);
class $0b9c408b616e5110$var$RenderErrorBoundary extends $3OyDL.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $0b9c408b616e5110$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $3OyDL.useContext($0b9c408b616e5110$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $0b9c408b616e5110$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $jIAfL.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $0b9c408b616e5110$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $0b9c408b616e5110$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $3OyDL.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $0b9c408b616e5110$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($0b9c408b616e5110$var$DataRouterHook || {});
var $0b9c408b616e5110$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($0b9c408b616e5110$var$DataRouterStateHook || {});
function $0b9c408b616e5110$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $0b9c408b616e5110$var$useDataRouterContext(hookName) {
    let ctx = $3OyDL.useContext($0b9c408b616e5110$export$3add0d5dce533e2e);
    !ctx && (0, $jIAfL.UNSAFE_invariant)(false);
    return ctx;
}
function $0b9c408b616e5110$var$useDataRouterState(hookName) {
    let state = $3OyDL.useContext($0b9c408b616e5110$export$145dfa71566a64dc);
    !state && (0, $jIAfL.UNSAFE_invariant)(false);
    return state;
}
function $0b9c408b616e5110$var$useRouteContext(hookName) {
    let route = $3OyDL.useContext($0b9c408b616e5110$export$9072aa6dd1f93057);
    !route && (0, $jIAfL.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $0b9c408b616e5110$var$useCurrentRouteId(hookName) {
    let route = $0b9c408b616e5110$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $jIAfL.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $0b9c408b616e5110$export$5fc8298006ad9e58() {
    return $0b9c408b616e5110$var$useCurrentRouteId($0b9c408b616e5110$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $0b9c408b616e5110$export$d0fd4b7106de2769() {
    let state = $0b9c408b616e5110$var$useDataRouterState($0b9c408b616e5110$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $0b9c408b616e5110$export$600dc272ed516c15() {
    let dataRouterContext = $0b9c408b616e5110$var$useDataRouterContext($0b9c408b616e5110$var$DataRouterHook.UseRevalidator);
    let state = $0b9c408b616e5110$var$useDataRouterState($0b9c408b616e5110$var$DataRouterStateHook.UseRevalidator);
    return $3OyDL.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $0b9c408b616e5110$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $0b9c408b616e5110$var$useDataRouterState($0b9c408b616e5110$var$DataRouterStateHook.UseMatches);
    return $3OyDL.useMemo(()=>matches.map((m)=>(0, $jIAfL.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $0b9c408b616e5110$export$1448a5050d252c4d() {
    let state = $0b9c408b616e5110$var$useDataRouterState($0b9c408b616e5110$var$DataRouterStateHook.UseLoaderData);
    let routeId = $0b9c408b616e5110$var$useCurrentRouteId($0b9c408b616e5110$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $0b9c408b616e5110$export$fd5d37484eab868d(routeId) {
    let state = $0b9c408b616e5110$var$useDataRouterState($0b9c408b616e5110$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $0b9c408b616e5110$export$fdc00f3f26066d5e() {
    let state = $0b9c408b616e5110$var$useDataRouterState($0b9c408b616e5110$var$DataRouterStateHook.UseActionData);
    let routeId = $0b9c408b616e5110$var$useCurrentRouteId($0b9c408b616e5110$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $0b9c408b616e5110$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $3OyDL.useContext($0b9c408b616e5110$var$RouteErrorContext);
    let state = $0b9c408b616e5110$var$useDataRouterState($0b9c408b616e5110$var$DataRouterStateHook.UseRouteError);
    let routeId = $0b9c408b616e5110$var$useCurrentRouteId($0b9c408b616e5110$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $0b9c408b616e5110$export$78a72ddb39bdd145() {
    let value = $3OyDL.useContext($0b9c408b616e5110$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $0b9c408b616e5110$export$17f53340677d5831() {
    let value = $3OyDL.useContext($0b9c408b616e5110$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $0b9c408b616e5110$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $0b9c408b616e5110$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $0b9c408b616e5110$var$useDataRouterContext($0b9c408b616e5110$var$DataRouterHook.UseBlocker);
    let state = $0b9c408b616e5110$var$useDataRouterState($0b9c408b616e5110$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $3OyDL.useState("");
    let blockerFunction = $3OyDL.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $0b9c408b616e5110$var$_extends({}, currentLocation, {
                pathname: (0, $jIAfL.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $0b9c408b616e5110$var$_extends({}, nextLocation, {
                pathname: (0, $jIAfL.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $3OyDL.useEffect(()=>{
        let key = String(++$0b9c408b616e5110$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $3OyDL.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $jIAfL.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $0b9c408b616e5110$var$useNavigateStable() {
    let { router: router } = $0b9c408b616e5110$var$useDataRouterContext($0b9c408b616e5110$var$DataRouterHook.UseNavigateStable);
    let id = $0b9c408b616e5110$var$useCurrentRouteId($0b9c408b616e5110$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $3OyDL.useRef(false);
    $0b9c408b616e5110$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $3OyDL.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $0b9c408b616e5110$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $0b9c408b616e5110$var$alreadyWarned$1 = {};
function $0b9c408b616e5110$var$warningOnce(key, cond, message) {
    if (!cond && !$0b9c408b616e5110$var$alreadyWarned$1[key]) $0b9c408b616e5110$var$alreadyWarned$1[key] = true;
}
const $0b9c408b616e5110$var$alreadyWarned = {};
function $0b9c408b616e5110$var$warnOnce(key, message) {}
const $0b9c408b616e5110$var$logDeprecation = (flag, msg, link)=>$0b9c408b616e5110$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $0b9c408b616e5110$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $0b9c408b616e5110$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $0b9c408b616e5110$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $0b9c408b616e5110$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $0b9c408b616e5110$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $0b9c408b616e5110$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $0b9c408b616e5110$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0b9c408b616e5110$var$START_TRANSITION = "startTransition";
const $0b9c408b616e5110$var$startTransitionImpl = $3OyDL[$0b9c408b616e5110$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0b9c408b616e5110$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $3OyDL.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3OyDL.useCallback((newState)=>{
        if (v7_startTransition && $0b9c408b616e5110$var$startTransitionImpl) $0b9c408b616e5110$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $3OyDL.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $3OyDL.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $3OyDL.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $3OyDL.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $3OyDL.useEffect(()=>$0b9c408b616e5110$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $3OyDL.createElement($3OyDL.Fragment, null, /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $0b9c408b616e5110$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $0b9c408b616e5110$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $0b9c408b616e5110$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $3OyDL.useRef();
    if (historyRef.current == null) historyRef.current = (0, $jIAfL.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3OyDL.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3OyDL.useCallback((newState)=>{
        v7_startTransition && $0b9c408b616e5110$var$startTransitionImpl ? $0b9c408b616e5110$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3OyDL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $3OyDL.useEffect(()=>$0b9c408b616e5110$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $0b9c408b616e5110$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$0b9c408b616e5110$export$9c954a9d03d32f4a() && (0, $jIAfL.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $3OyDL.useContext($0b9c408b616e5110$export$26749e8557646306);
    let { matches: matches } = $3OyDL.useContext($0b9c408b616e5110$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0b9c408b616e5110$export$45d76561a5302f2b();
    let navigate = $0b9c408b616e5110$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $jIAfL.resolveTo)(to, (0, $jIAfL.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $3OyDL.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $0b9c408b616e5110$export$910ae8079b2c2852(props) {
    return $0b9c408b616e5110$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $0b9c408b616e5110$export$e7b0ac011bb776c6(_props) {
    (0, $jIAfL.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $0b9c408b616e5110$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $jIAfL.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$0b9c408b616e5110$export$9c954a9d03d32f4a() && (0, $jIAfL.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $3OyDL.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $0b9c408b616e5110$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $jIAfL.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $3OyDL.useMemo(()=>{
        let trailingPathname = (0, $jIAfL.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $0b9c408b616e5110$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $0b9c408b616e5110$export$5d3fca4a98652595($0b9c408b616e5110$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $0b9c408b616e5110$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$var$ResolveAwait, null, children));
}
var $0b9c408b616e5110$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($0b9c408b616e5110$var$AwaitRenderStatus || {});
const $0b9c408b616e5110$var$neverSettledPromise = new Promise(()=>{});
class $0b9c408b616e5110$var$AwaitErrorBoundary extends $3OyDL.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $0b9c408b616e5110$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $0b9c408b616e5110$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $0b9c408b616e5110$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $0b9c408b616e5110$var$AwaitRenderStatus.error : "_data" in promise ? $0b9c408b616e5110$var$AwaitRenderStatus.success : $0b9c408b616e5110$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $0b9c408b616e5110$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $0b9c408b616e5110$var$AwaitRenderStatus.error && promise._error instanceof (0, $jIAfL.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $0b9c408b616e5110$var$neverSettledPromise;
        if (status === $0b9c408b616e5110$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $0b9c408b616e5110$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $0b9c408b616e5110$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $3OyDL.createElement($0b9c408b616e5110$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $0b9c408b616e5110$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $0b9c408b616e5110$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $3OyDL.createElement($3OyDL.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $0b9c408b616e5110$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $3OyDL.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $3OyDL.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $3OyDL.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $0b9c408b616e5110$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $0b9c408b616e5110$export$e7b0ac011bb776c6) && (0, $jIAfL.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $jIAfL.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $0b9c408b616e5110$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $0b9c408b616e5110$export$daf73786167a7f72(matches) {
    return $0b9c408b616e5110$var$_renderMatches(matches);
}
function $0b9c408b616e5110$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $3OyDL.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $3OyDL.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $3OyDL.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $0b9c408b616e5110$export$f30f7e456d254e83(routes, opts) {
    return (0, $jIAfL.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0b9c408b616e5110$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $jIAfL.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $0b9c408b616e5110$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("djixo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e938191631de2cb$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $3OyDL = parcelRequire("3OyDL");

var $8atfs = parcelRequire("8atfs");

var $fh636 = parcelRequire("fh636");

var $162Of = parcelRequire("162Of");

var $kDNj7 = parcelRequire("kDNj7");
const $9e938191631de2cb$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $3OyDL.forwardRef)(({ className: className, ...props }, ref)=>(0, $3OyDL.createElement)((0, $kDNj7.default), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $8atfs.mergeClasses)(`lucide-${(0, $fh636.toKebabCase)((0, $162Of.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $162Of.toPascalCase)(iconName);
    return Component;
};

});
parcelRegister("8atfs", function(module, exports) {

$parcel$export(module.exports, "mergeClasses", () => $61f8ff0877489b25$export$3d46f4579dba46e5);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $61f8ff0877489b25$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();

});

parcelRegister("fh636", function(module, exports) {

$parcel$export(module.exports, "toKebabCase", () => $fabdd5780111a1c2$export$73bda83cddbc7187);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $fabdd5780111a1c2$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

});

parcelRegister("162Of", function(module, exports) {

$parcel$export(module.exports, "toPascalCase", () => $cb26814ad89fee89$export$6fb43ff9addf7357);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9UZ2z = parcelRequire("9UZ2z");
const $cb26814ad89fee89$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $9UZ2z.toCamelCase)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};

});
parcelRegister("9UZ2z", function(module, exports) {

$parcel$export(module.exports, "toCamelCase", () => $11c3f9278b54c88f$export$86f54f62aa7a7514);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $11c3f9278b54c88f$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());

});


parcelRegister("kDNj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f21ffdea1758d0$export$2e2bcd8739ae039);

var $3OyDL = parcelRequire("3OyDL");

var $c80S6 = parcelRequire("c80S6");

var $6am3K = parcelRequire("6am3K");

var $8atfs = parcelRequire("8atfs");

var $7dHBa = parcelRequire("7dHBa");
"use strict";
"use client";
const $61f21ffdea1758d0$export$2e2bcd8739ae039 = (0, $3OyDL.forwardRef)(({ color: color, size: size, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    const { size: contextSize = 24, strokeWidth: contextStrokeWidth = 2, absoluteStrokeWidth: contextAbsoluteStrokeWidth = false, color: contextColor = "currentColor", className: contextClass = "" } = (0, $7dHBa.useLucideContext)() ?? {};
    const calculatedStrokeWidth = absoluteStrokeWidth ?? contextAbsoluteStrokeWidth ? Number(strokeWidth ?? contextStrokeWidth) * 24 / Number(size ?? contextSize) : strokeWidth ?? contextStrokeWidth;
    return (0, $3OyDL.createElement)("svg", {
        ref: ref,
        ...(0, $c80S6.default),
        width: size ?? contextSize ?? (0, $c80S6.default).width,
        height: size ?? contextSize ?? (0, $c80S6.default).height,
        stroke: color ?? contextColor,
        strokeWidth: calculatedStrokeWidth,
        className: (0, $8atfs.mergeClasses)("lucide", contextClass, className),
        ...!children && !(0, $6am3K.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $3OyDL.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});

});
parcelRegister("c80S6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eae790e9fe20040$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $3eae790e9fe20040$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

});

parcelRegister("6am3K", function(module, exports) {

$parcel$export(module.exports, "hasA11yProp", () => $b532c20c1aacaca8$export$ab365959aa6deed0);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $b532c20c1aacaca8$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};

});

parcelRegister("7dHBa", function(module, exports) {

$parcel$export(module.exports, "useLucideContext", () => $b65c25c05eb65268$export$52ee7576b6cde767);

var $3OyDL = parcelRequire("3OyDL");
"use strict";
"use client";
const $b65c25c05eb65268$var$LucideContext = (0, $3OyDL.createContext)({});
function $b65c25c05eb65268$export$f4a5ae9d8b2d8a16({ children: children, size: size, color: color, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className }) {
    const value = (0, $3OyDL.useMemo)(()=>({
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            className: className
        }), [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        className
    ]);
    return (0, $3OyDL.createElement)($b65c25c05eb65268$var$LucideContext.Provider, {
        value: value
    }, children);
}
const $b65c25c05eb65268$export$52ee7576b6cde767 = ()=>(0, $3OyDL.useContext)($b65c25c05eb65268$var$LucideContext);

});



parcelRegister("68l1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $bccfa51b058f35ab$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $bccfa51b058f35ab$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v3",
            key: "1ioesn"
        }
    ],
    [
        "path",
        {
            d: "M16 2v3",
            key: "otl347"
        }
    ],
    [
        "rect",
        {
            x: "3",
            y: "3",
            width: "18",
            height: "18",
            rx: "2",
            key: "h1oib"
        }
    ],
    [
        "path",
        {
            d: "M3 9h18",
            key: "1pudct"
        }
    ],
    [
        "path",
        {
            d: "M8 13h.01",
            key: "1sbv64"
        }
    ],
    [
        "path",
        {
            d: "M12 13h.01",
            key: "y0uutt"
        }
    ],
    [
        "path",
        {
            d: "M16 13h.01",
            key: "wip0gl"
        }
    ],
    [
        "path",
        {
            d: "M8 17h.01",
            key: "p3bg7i"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ],
    [
        "path",
        {
            d: "M16 17h.01",
            key: "ql8jdd"
        }
    ]
];
const $bccfa51b058f35ab$export$2e2bcd8739ae039 = (0, $djixo.default)("calendar-days", $bccfa51b058f35ab$export$3efd853dbb351e94);

});

parcelRegister("gPhVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $14b90cbc8ae4aba7$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $14b90cbc8ae4aba7$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "3",
            y: "3",
            rx: "1",
            key: "10lvy0"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "14",
            y: "3",
            rx: "1",
            key: "16une8"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "14",
            y: "12",
            rx: "1",
            key: "1hutg5"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "3",
            y: "16",
            rx: "1",
            key: "ldoo1y"
        }
    ]
];
const $14b90cbc8ae4aba7$export$2e2bcd8739ae039 = (0, $djixo.default)("layout-dashboard", $14b90cbc8ae4aba7$export$3efd853dbb351e94);

});

parcelRegister("3wlwv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a36a2c0fe789428$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $5a36a2c0fe789428$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 17 5-5-5-5",
            key: "1bji2h"
        }
    ],
    [
        "path",
        {
            d: "M21 12H9",
            key: "dn1m92"
        }
    ],
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ]
];
const $5a36a2c0fe789428$export$2e2bcd8739ae039 = (0, $djixo.default)("log-out", $5a36a2c0fe789428$export$3efd853dbb351e94);

});

parcelRegister("7k3Wx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea21a75fe3ce490a$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $ea21a75fe3ce490a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
            key: "18887p"
        }
    ]
];
const $ea21a75fe3ce490a$export$2e2bcd8739ae039 = (0, $djixo.default)("message-square", $ea21a75fe3ce490a$export$3efd853dbb351e94);

});

parcelRegister("dRGZn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b626204b1cfe4a0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $3b626204b1cfe4a0$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            x: "16",
            y: "16",
            width: "6",
            height: "6",
            rx: "1",
            key: "4q2zg0"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "16",
            width: "6",
            height: "6",
            rx: "1",
            key: "8cvhb9"
        }
    ],
    [
        "rect",
        {
            x: "9",
            y: "2",
            width: "6",
            height: "6",
            rx: "1",
            key: "1egb70"
        }
    ],
    [
        "path",
        {
            d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3",
            key: "1jsf9p"
        }
    ],
    [
        "path",
        {
            d: "M12 12V8",
            key: "2874zd"
        }
    ]
];
const $3b626204b1cfe4a0$export$2e2bcd8739ae039 = (0, $djixo.default)("network", $3b626204b1cfe4a0$export$3efd853dbb351e94);

});

parcelRegister("vMEqK", function(module, exports) {

$parcel$export(module.exports, "default", () => $97e95034a97ed76c$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $97e95034a97ed76c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 3h20",
            key: "91anmk"
        }
    ],
    [
        "path",
        {
            d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3",
            key: "2k9sn8"
        }
    ],
    [
        "path",
        {
            d: "m7 21 5-5 5 5",
            key: "bip4we"
        }
    ]
];
const $97e95034a97ed76c$export$2e2bcd8739ae039 = (0, $djixo.default)("presentation", $97e95034a97ed76c$export$3efd853dbb351e94);

});

parcelRegister("8n6ke", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c4ebe59a3fbe61$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $32c4ebe59a3fbe61$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $32c4ebe59a3fbe61$export$2e2bcd8739ae039 = (0, $djixo.default)("shield-check", $32c4ebe59a3fbe61$export$3efd853dbb351e94);

});

parcelRegister("6tkl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f30b73baf6e4a7ed$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $f30b73baf6e4a7ed$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $f30b73baf6e4a7ed$export$2e2bcd8739ae039 = (0, $djixo.default)("triangle-alert", $f30b73baf6e4a7ed$export$3efd853dbb351e94);

});

parcelRegister("bi4P4", function(module, exports) {

$parcel$export(module.exports, "default", () => $731e0bdb1025504f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $731e0bdb1025504f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $731e0bdb1025504f$export$2e2bcd8739ae039 = (0, $djixo.default)("x", $731e0bdb1025504f$export$3efd853dbb351e94);

});

parcelRegister("i5Xd5", function(module, exports) {

$parcel$export(module.exports, "Content", () => $57ee2c8c242d2cab$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Description", () => $57ee2c8c242d2cab$export$393edc798c47379d);
$parcel$export(module.exports, "Close", () => $57ee2c8c242d2cab$export$f39c2d165cd861fe);
$parcel$export(module.exports, "Overlay", () => $57ee2c8c242d2cab$export$bd1d06c79be19e17);
$parcel$export(module.exports, "Portal", () => $57ee2c8c242d2cab$export$dad7c95542bacce0);
$parcel$export(module.exports, "Root", () => $57ee2c8c242d2cab$export$3ddf2d174ce01153);
$parcel$export(module.exports, "Title", () => $57ee2c8c242d2cab$export$16f7638e4a34b909);
$parcel$export(module.exports, "Trigger", () => $57ee2c8c242d2cab$export$2e1e1122cf0cba88);

var $3OyDL = parcelRequire("3OyDL");

var $3j7Yq = parcelRequire("3j7Yq");

var $i8Ljd = parcelRequire("i8Ljd");

var $9DRZr = parcelRequire("9DRZr");

var $lQlfC = parcelRequire("lQlfC");

var $2UbMs = parcelRequire("2UbMs");

var $dTBEM = parcelRequire("dTBEM");

var $5VxZp = parcelRequire("5VxZp");

var $74zAC = parcelRequire("74zAC");

var $c1I0K = parcelRequire("c1I0K");

var $869fj = parcelRequire("869fj");

var $5JQjG = parcelRequire("5JQjG");

var $7jvAT = parcelRequire("7jvAT");

var $3lFTR = parcelRequire("3lFTR");

var $aDFmZ = parcelRequire("aDFmZ");

var $2M70Q = parcelRequire("2M70Q");
"use client";
var $57ee2c8c242d2cab$var$DIALOG_NAME = "Dialog";
var [$57ee2c8c242d2cab$var$createDialogContext, $57ee2c8c242d2cab$export$cc702773b8ea3e41] = (0, $9DRZr.createContextScope)($57ee2c8c242d2cab$var$DIALOG_NAME);
var [$57ee2c8c242d2cab$var$DialogProvider, $57ee2c8c242d2cab$var$useDialogContext] = $57ee2c8c242d2cab$var$createDialogContext($57ee2c8c242d2cab$var$DIALOG_NAME);
var $57ee2c8c242d2cab$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $3OyDL.useRef(null);
    const contentRef = $3OyDL.useRef(null);
    const [open, setOpen] = (0, $2UbMs.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $57ee2c8c242d2cab$var$DIALOG_NAME
    });
    return /* @__PURE__ */ (0, $2M70Q.jsx)($57ee2c8c242d2cab$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $lQlfC.useId)(),
        titleId: (0, $lQlfC.useId)(),
        descriptionId: (0, $lQlfC.useId)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $3OyDL.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$57ee2c8c242d2cab$export$3ddf2d174ce01153.displayName = $57ee2c8c242d2cab$var$DIALOG_NAME;
var $57ee2c8c242d2cab$var$TRIGGER_NAME = "DialogTrigger";
var $57ee2c8c242d2cab$export$2e1e1122cf0cba88 = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $57ee2c8c242d2cab$var$useDialogContext($57ee2c8c242d2cab$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $i8Ljd.useComposedRefs)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : void 0,
        "data-state": $57ee2c8c242d2cab$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $3j7Yq.composeEventHandlers)(props.onClick, context.onOpenToggle)
    });
});
$57ee2c8c242d2cab$export$2e1e1122cf0cba88.displayName = $57ee2c8c242d2cab$var$TRIGGER_NAME;
var $57ee2c8c242d2cab$var$PORTAL_NAME = "DialogPortal";
var [$57ee2c8c242d2cab$var$PortalProvider, $57ee2c8c242d2cab$var$usePortalContext] = $57ee2c8c242d2cab$var$createDialogContext($57ee2c8c242d2cab$var$PORTAL_NAME, {
    forceMount: void 0
});
var $57ee2c8c242d2cab$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $57ee2c8c242d2cab$var$useDialogContext($57ee2c8c242d2cab$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $2M70Q.jsx)($57ee2c8c242d2cab$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $3OyDL.Children.map(children, (child)=>/* @__PURE__ */ (0, $2M70Q.jsx)((0, $c1I0K.Presence), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $2M70Q.jsx)((0, $74zAC.Portal), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$57ee2c8c242d2cab$export$dad7c95542bacce0.displayName = $57ee2c8c242d2cab$var$PORTAL_NAME;
var $57ee2c8c242d2cab$var$OVERLAY_NAME = "DialogOverlay";
var $57ee2c8c242d2cab$export$bd1d06c79be19e17 = $3OyDL.forwardRef((props, forwardedRef)=>{
    const portalContext = $57ee2c8c242d2cab$var$usePortalContext($57ee2c8c242d2cab$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $57ee2c8c242d2cab$var$useDialogContext($57ee2c8c242d2cab$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $2M70Q.jsx)((0, $c1I0K.Presence), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $2M70Q.jsx)($57ee2c8c242d2cab$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$57ee2c8c242d2cab$export$bd1d06c79be19e17.displayName = $57ee2c8c242d2cab$var$OVERLAY_NAME;
var $57ee2c8c242d2cab$var$Slot = (0, $aDFmZ.createSlot)("DialogOverlay.RemoveScroll");
var $57ee2c8c242d2cab$var$DialogOverlayImpl = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $57ee2c8c242d2cab$var$useDialogContext($57ee2c8c242d2cab$var$OVERLAY_NAME, __scopeDialog);
    const registerDismissableSurface = (0, $dTBEM.useDismissableLayerSurface)();
    const composedRefs = (0, $i8Ljd.useComposedRefs)(forwardedRef, registerDismissableSurface);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $2M70Q.jsx)((0, $7jvAT.default), {
        as: $57ee2c8c242d2cab$var$Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).div, {
            "data-state": $57ee2c8c242d2cab$var$getState(context.open),
            ...overlayProps,
            ref: composedRefs,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $57ee2c8c242d2cab$var$CONTENT_NAME = "DialogContent";
var $57ee2c8c242d2cab$export$7c6e2c02157bb7d2 = $3OyDL.forwardRef((props, forwardedRef)=>{
    const portalContext = $57ee2c8c242d2cab$var$usePortalContext($57ee2c8c242d2cab$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $57ee2c8c242d2cab$var$useDialogContext($57ee2c8c242d2cab$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $c1I0K.Presence), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $2M70Q.jsx)($57ee2c8c242d2cab$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $2M70Q.jsx)($57ee2c8c242d2cab$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$57ee2c8c242d2cab$export$7c6e2c02157bb7d2.displayName = $57ee2c8c242d2cab$var$CONTENT_NAME;
var $57ee2c8c242d2cab$var$DialogContentModal = $3OyDL.forwardRef((props, forwardedRef)=>{
    const context = $57ee2c8c242d2cab$var$useDialogContext($57ee2c8c242d2cab$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $3OyDL.useRef(null);
    const composedRefs = (0, $i8Ljd.useComposedRefs)(forwardedRef, context.contentRef, contentRef);
    $3OyDL.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $3lFTR.hideOthers)(content);
    }, []);
    return /* @__PURE__ */ (0, $2M70Q.jsx)($57ee2c8c242d2cab$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        onCloseAutoFocus: (0, $3j7Yq.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $3j7Yq.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $3j7Yq.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $57ee2c8c242d2cab$var$DialogContentNonModal = $3OyDL.forwardRef((props, forwardedRef)=>{
    const context = $57ee2c8c242d2cab$var$useDialogContext($57ee2c8c242d2cab$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $3OyDL.useRef(false);
    const hasPointerDownOutsideRef = $3OyDL.useRef(false);
    return /* @__PURE__ */ (0, $2M70Q.jsx)($57ee2c8c242d2cab$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $57ee2c8c242d2cab$var$DialogContentImpl = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $57ee2c8c242d2cab$var$useDialogContext($57ee2c8c242d2cab$var$CONTENT_NAME, __scopeDialog);
    (0, $5JQjG.useFocusGuards)();
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: /* @__PURE__ */ (0, $2M70Q.jsx)((0, $5VxZp.FocusScope), {
            asChild: true,
            loop: true,
            trapped: trapFocus,
            onMountAutoFocus: onOpenAutoFocus,
            onUnmountAutoFocus: onCloseAutoFocus,
            children: /* @__PURE__ */ (0, $2M70Q.jsx)((0, $dTBEM.DismissableLayer), {
                role: "dialog",
                id: context.contentId,
                "aria-describedby": context.descriptionId,
                "aria-labelledby": context.titleId,
                "data-state": $57ee2c8c242d2cab$var$getState(context.open),
                ...contentProps,
                ref: forwardedRef,
                deferPointerDownOutside: true,
                onDismiss: ()=>context.onOpenChange(false)
            })
        })
    });
});
var $57ee2c8c242d2cab$var$TITLE_NAME = "DialogTitle";
var $57ee2c8c242d2cab$export$16f7638e4a34b909 = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $57ee2c8c242d2cab$var$useDialogContext($57ee2c8c242d2cab$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$57ee2c8c242d2cab$export$16f7638e4a34b909.displayName = $57ee2c8c242d2cab$var$TITLE_NAME;
var $57ee2c8c242d2cab$var$DESCRIPTION_NAME = "DialogDescription";
var $57ee2c8c242d2cab$export$393edc798c47379d = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $57ee2c8c242d2cab$var$useDialogContext($57ee2c8c242d2cab$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$57ee2c8c242d2cab$export$393edc798c47379d.displayName = $57ee2c8c242d2cab$var$DESCRIPTION_NAME;
var $57ee2c8c242d2cab$var$CLOSE_NAME = "DialogClose";
var $57ee2c8c242d2cab$export$f39c2d165cd861fe = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $57ee2c8c242d2cab$var$useDialogContext($57ee2c8c242d2cab$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $3j7Yq.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$57ee2c8c242d2cab$export$f39c2d165cd861fe.displayName = $57ee2c8c242d2cab$var$CLOSE_NAME;
var $57ee2c8c242d2cab$export$69b62a49393917d6 = (props)=>{
    return props.children;
};
function $57ee2c8c242d2cab$var$getState(open) {
    return open ? "open" : "closed";
}

});
parcelRegister("3j7Yq", function(module, exports) {

$parcel$export(module.exports, "composeEventHandlers", () => $e124effc608fdedc$export$b9ecd428b558ff10);
// src/primitive.tsx
var $e124effc608fdedc$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $e124effc608fdedc$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function $e124effc608fdedc$export$f21a1ffae260145a(element) {
    if (!$e124effc608fdedc$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function $e124effc608fdedc$export$b204af158042fbac(element) {
    if (!$e124effc608fdedc$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function $e124effc608fdedc$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $e124effc608fdedc$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($e124effc608fdedc$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $e124effc608fdedc$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $e124effc608fdedc$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function $e124effc608fdedc$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}

});

parcelRegister("i8Ljd", function(module, exports) {

$parcel$export(module.exports, "useComposedRefs", () => $69b7565e6d0efb67$export$c7b2cbe3552a0d05);
// src/compose-refs.tsx

var $3OyDL = parcelRequire("3OyDL");
function $69b7565e6d0efb67$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $69b7565e6d0efb67$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $69b7565e6d0efb67$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $69b7565e6d0efb67$var$setRef(refs[i], null);
            }
        };
    };
}
function $69b7565e6d0efb67$export$c7b2cbe3552a0d05(...refs) {
    return $3OyDL.useCallback($69b7565e6d0efb67$export$43e446d32b3d21af(...refs), refs);
}

});

parcelRegister("9DRZr", function(module, exports) {

$parcel$export(module.exports, "createContextScope", () => $f7dfc2ee61f32d86$export$50c7b4e9d9f19c1);
// src/create-context.tsx

var $3OyDL = parcelRequire("3OyDL");

var $2M70Q = parcelRequire("2M70Q");
function $f7dfc2ee61f32d86$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $3OyDL.createContext(defaultContext);
    Context.displayName = rootComponentName + "Context";
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $3OyDL.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $2M70Q.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName, options = {}) {
        const { optional: optional = false } = options;
        const context = $3OyDL.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        if (optional) return void 0;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $f7dfc2ee61f32d86$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $3OyDL.createContext(defaultContext);
        BaseContext.displayName = rootComponentName + "Context";
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $3OyDL.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $2M70Q.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope, options = {}) {
            const { optional: optional = false } = options;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $3OyDL.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            if (optional) return void 0;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $3OyDL.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $3OyDL.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $f7dfc2ee61f32d86$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $f7dfc2ee61f32d86$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $3OyDL.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}

});

parcelRegister("lQlfC", function(module, exports) {

$parcel$export(module.exports, "useId", () => $d7020c784cc9d058$export$f680877a34711e37);
// src/id.tsx

var $3OyDL = parcelRequire("3OyDL");

var $4mdWM = parcelRequire("4mdWM");
var $d7020c784cc9d058$var$useReactId = $3OyDL[" useId ".trim().toString()] || (()=>void 0);
var $d7020c784cc9d058$var$count = 0;
function $d7020c784cc9d058$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $3OyDL.useState($d7020c784cc9d058$var$useReactId());
    (0, $4mdWM.useLayoutEffect)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($d7020c784cc9d058$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}

});
parcelRegister("4mdWM", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $c2fc90232f3046e4$export$e5c5a5f917a5871c);
// src/use-layout-effect.tsx

var $3OyDL = parcelRequire("3OyDL");
var $c2fc90232f3046e4$export$e5c5a5f917a5871c = globalThis?.document ? $3OyDL.useLayoutEffect : ()=>{};

});


parcelRegister("2UbMs", function(module, exports) {

$parcel$export(module.exports, "useControllableState", () => $ea01aceff57508a6$export$6f32135080cb4c3);
// src/use-controllable-state.tsx

var $3OyDL = parcelRequire("3OyDL");

var $4mdWM = parcelRequire("4mdWM");

var $MQbK0 = parcelRequire("MQbK0");
var $ea01aceff57508a6$var$useInsertionEffect = $3OyDL[" useInsertionEffect ".trim().toString()] || (0, $4mdWM.useLayoutEffect);
function $ea01aceff57508a6$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $ea01aceff57508a6$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $3OyDL.useRef(prop !== void 0);
        $3OyDL.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $3OyDL.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $ea01aceff57508a6$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $ea01aceff57508a6$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $3OyDL.useState(defaultProp);
    const prevValueRef = $3OyDL.useRef(value);
    const onChangeRef = $3OyDL.useRef(onChange);
    $ea01aceff57508a6$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $3OyDL.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $ea01aceff57508a6$var$isFunction(value) {
    return typeof value === "function";
}
var $ea01aceff57508a6$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $ea01aceff57508a6$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $MQbK0.useEffectEvent)(onChangeProp);
    {
        const isControlledRef = $3OyDL.useRef(controlledState !== void 0);
        $3OyDL.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $3OyDL.useReducer((state2, action)=>{
        if (action.type === $ea01aceff57508a6$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $3OyDL.useRef(uncontrolledState);
    $3OyDL.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $3OyDL.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $3OyDL.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $ea01aceff57508a6$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}

});
parcelRegister("MQbK0", function(module, exports) {

$parcel$export(module.exports, "useEffectEvent", () => $c6a230ea153cf100$export$7f54fc3180508a52);
// src/use-effect-event.tsx

var $4mdWM = parcelRequire("4mdWM");

var $3OyDL = parcelRequire("3OyDL");
var $c6a230ea153cf100$var$useReactEffectEvent = $3OyDL[" useEffectEvent ".trim().toString()];
var $c6a230ea153cf100$var$useReactInsertionEffect = $3OyDL[" useInsertionEffect ".trim().toString()];
function $c6a230ea153cf100$export$7f54fc3180508a52(callback) {
    if (typeof $c6a230ea153cf100$var$useReactEffectEvent === "function") return $c6a230ea153cf100$var$useReactEffectEvent(callback);
    const ref = $3OyDL.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $c6a230ea153cf100$var$useReactInsertionEffect === "function") $c6a230ea153cf100$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $4mdWM.useLayoutEffect)(()=>{
        ref.current = callback;
    });
    return $3OyDL.useMemo(()=>(...args)=>ref.current?.(...args), []);
}

});


parcelRegister("dTBEM", function(module, exports) {

$parcel$export(module.exports, "DismissableLayer", () => $121bfaa99a0dfa34$export$177fb62ff3ec1f22);
$parcel$export(module.exports, "useDismissableLayerSurface", () => $121bfaa99a0dfa34$export$210785236bdfcb27);

var $3OyDL = parcelRequire("3OyDL");

var $3j7Yq = parcelRequire("3j7Yq");

var $869fj = parcelRequire("869fj");

var $i8Ljd = parcelRequire("i8Ljd");

var $fMVre = parcelRequire("fMVre");

var $2M70Q = parcelRequire("2M70Q");
"use client";
var $121bfaa99a0dfa34$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $121bfaa99a0dfa34$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $121bfaa99a0dfa34$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $121bfaa99a0dfa34$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $121bfaa99a0dfa34$var$originalBodyPointerEvents;
var $121bfaa99a0dfa34$var$DismissableLayerContext = $3OyDL.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set(),
    // Outside elements that belong to a layer's own dismiss affordance (eg, a
    // dialog overlay). Pressing them should dismiss the layer regardless of
    // whether or not they stop propagation.
    //
    // See https://github.com/radix-ui/primitives/issues/3346
    dismissableSurfaces: /* @__PURE__ */ new Set()
});
var $121bfaa99a0dfa34$export$177fb62ff3ec1f22 = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, deferPointerDownOutside: deferPointerDownOutside = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $3OyDL.useContext($121bfaa99a0dfa34$var$DismissableLayerContext);
    const [node, setNode] = $3OyDL.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $3OyDL.useState({});
    const composedRefs = (0, $i8Ljd.useComposedRefs)(forwardedRef, setNode);
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = highestLayerWithOutsidePointerEventsDisabled ? layers.indexOf(highestLayerWithOutsidePointerEventsDisabled) : -1;
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const isDeferredPointerDownOutsideRef = $3OyDL.useRef(false);
    const pointerDownOutside = $121bfaa99a0dfa34$var$usePointerDownOutside((event)=>{
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, {
        ownerDocument: ownerDocument,
        deferPointerDownOutside: deferPointerDownOutside,
        isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef,
        dismissableSurfaces: context.dismissableSurfaces,
        shouldHandlePointerDownOutside: $3OyDL.useCallback((target)=>{
            if (!(target instanceof Node)) return false;
            const isPointerDownOnBranch = [
                ...context.branches
            ].some((branch)=>branch.contains(target));
            return isPointerEventsEnabled && !isPointerDownOnBranch;
        }, [
            context.branches,
            isPointerEventsEnabled
        ])
    });
    const focusOutside = $121bfaa99a0dfa34$var$useFocusOutside((event)=>{
        if (deferPointerDownOutside && isDeferredPointerDownOutsideRef.current) return;
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const isHighestLayer = node ? index === layers.length - 1 : false;
    const handleKeyDown = (0, $fMVre.useCallbackRef)((event)=>{
        if (event.key !== "Escape") return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    });
    $3OyDL.useEffect(()=>{
        if (!isHighestLayer) return;
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        ownerDocument,
        isHighestLayer,
        handleKeyDown
    ]);
    $3OyDL.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $121bfaa99a0dfa34$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $121bfaa99a0dfa34$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents) {
                context.layersWithOutsidePointerEventsDisabled.delete(node);
                if (context.layersWithOutsidePointerEventsDisabled.size === 0) ownerDocument.body.style.pointerEvents = $121bfaa99a0dfa34$var$originalBodyPointerEvents;
            }
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $3OyDL.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $121bfaa99a0dfa34$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $3OyDL.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($121bfaa99a0dfa34$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($121bfaa99a0dfa34$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $3j7Yq.composeEventHandlers)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $3j7Yq.composeEventHandlers)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $3j7Yq.composeEventHandlers)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$121bfaa99a0dfa34$export$177fb62ff3ec1f22.displayName = $121bfaa99a0dfa34$var$DISMISSABLE_LAYER_NAME;
var $121bfaa99a0dfa34$var$BRANCH_NAME = "DismissableLayerBranch";
var $121bfaa99a0dfa34$export$4d5eb2109db14228 = $3OyDL.forwardRef((props, forwardedRef)=>{
    const context = $3OyDL.useContext($121bfaa99a0dfa34$var$DismissableLayerContext);
    const ref = $3OyDL.useRef(null);
    const composedRefs = (0, $i8Ljd.useComposedRefs)(forwardedRef, ref);
    $3OyDL.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).div, {
        ...props,
        ref: composedRefs
    });
});
$121bfaa99a0dfa34$export$4d5eb2109db14228.displayName = $121bfaa99a0dfa34$var$BRANCH_NAME;
function $121bfaa99a0dfa34$export$210785236bdfcb27() {
    const context = $3OyDL.useContext($121bfaa99a0dfa34$var$DismissableLayerContext);
    const [node, setNode] = $3OyDL.useState(null);
    $3OyDL.useEffect(()=>{
        if (!node) return;
        context.dismissableSurfaces.add(node);
        return ()=>{
            context.dismissableSurfaces.delete(node);
        };
    }, [
        node,
        context.dismissableSurfaces
    ]);
    return setNode;
}
var $121bfaa99a0dfa34$var$IS_TRUE = ()=>true;
function $121bfaa99a0dfa34$var$usePointerDownOutside(onPointerDownOutside, args) {
    const { ownerDocument: ownerDocument = globalThis?.document, deferPointerDownOutside: deferPointerDownOutside = false, isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef, dismissableSurfaces: dismissableSurfaces, shouldHandlePointerDownOutside: shouldHandlePointerDownOutside = $121bfaa99a0dfa34$var$IS_TRUE } = args;
    const handlePointerDownOutside = (0, $fMVre.useCallbackRef)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $3OyDL.useRef(false);
    const isPointerDownOutsideRef = $3OyDL.useRef(false);
    const interceptedOutsideInteractionEventsRef = $3OyDL.useRef(/* @__PURE__ */ new Map());
    const handleClickRef = $3OyDL.useRef(()=>{});
    $3OyDL.useEffect(()=>{
        function resetOutsideInteraction() {
            isPointerDownOutsideRef.current = false;
            isDeferredPointerDownOutsideRef.current = false;
            interceptedOutsideInteractionEventsRef.current.clear();
        }
        function isOutsideInteractionIntercepted() {
            return Array.from(interceptedOutsideInteractionEventsRef.current.values()).some(Boolean);
        }
        function handleInteractionCapture(event) {
            if (!isPointerDownOutsideRef.current) return;
            const target = event.target;
            const isDismissableSurface = target instanceof Node && [
                ...dismissableSurfaces
            ].some((surface)=>surface.contains(target));
            if (!isDismissableSurface) interceptedOutsideInteractionEventsRef.current.set(event.type, true);
            if (event.type === "click") window.setTimeout(()=>{
                if (isPointerDownOutsideRef.current) handleClickRef.current();
            }, 0);
        }
        function handleInteractionBubble(event) {
            if (isPointerDownOutsideRef.current) interceptedOutsideInteractionEventsRef.current.set(event.type, false);
        }
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    const wasOutsideInteractionIntercepted = isOutsideInteractionIntercepted();
                    resetOutsideInteraction();
                    if (!wasOutsideInteractionIntercepted) $121bfaa99a0dfa34$var$handleAndDispatchCustomEvent($121bfaa99a0dfa34$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                if (!shouldHandlePointerDownOutside(event.target)) {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    resetOutsideInteraction();
                    isPointerInsideReactTreeRef.current = false;
                    return;
                }
                const eventDetail = {
                    originalEvent: event
                };
                isPointerDownOutsideRef.current = true;
                isDeferredPointerDownOutsideRef.current = deferPointerDownOutside && event.button === 0;
                interceptedOutsideInteractionEventsRef.current.clear();
                if (!deferPointerDownOutside || event.button !== 0) handleAndDispatchPointerDownOutsideEvent2();
                else {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                }
            } else {
                ownerDocument.removeEventListener("click", handleClickRef.current);
                resetOutsideInteraction();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        const outsideInteractionEvents = [
            "pointerup",
            "mousedown",
            "mouseup",
            "touchstart",
            "touchend",
            "click"
        ];
        for (const eventName of outsideInteractionEvents){
            ownerDocument.addEventListener(eventName, handleInteractionCapture, true);
            ownerDocument.addEventListener(eventName, handleInteractionBubble);
        }
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
            for (const eventName of outsideInteractionEvents){
                ownerDocument.removeEventListener(eventName, handleInteractionCapture, true);
                ownerDocument.removeEventListener(eventName, handleInteractionBubble);
            }
        };
    }, [
        ownerDocument,
        handlePointerDownOutside,
        deferPointerDownOutside,
        isDeferredPointerDownOutsideRef,
        dismissableSurfaces,
        shouldHandlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $121bfaa99a0dfa34$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $fMVre.useCallbackRef)(onFocusOutside);
    const isFocusInsideReactTreeRef = $3OyDL.useRef(false);
    $3OyDL.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $121bfaa99a0dfa34$var$handleAndDispatchCustomEvent($121bfaa99a0dfa34$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $121bfaa99a0dfa34$var$dispatchUpdate() {
    const event = new CustomEvent($121bfaa99a0dfa34$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $121bfaa99a0dfa34$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $869fj.dispatchDiscreteCustomEvent)(target, event);
    else target.dispatchEvent(event);
}
var $121bfaa99a0dfa34$export$be92b6f5f03c0fe9 = $121bfaa99a0dfa34$export$177fb62ff3ec1f22;
var $121bfaa99a0dfa34$export$aecb2ddcb55c95be = $121bfaa99a0dfa34$export$4d5eb2109db14228;

});
parcelRegister("869fj", function(module, exports) {

$parcel$export(module.exports, "Primitive", () => $da6eb8c30cd53552$export$250ffa63cdc0d034);
$parcel$export(module.exports, "dispatchDiscreteCustomEvent", () => $da6eb8c30cd53552$export$6d1a0317bde7de7f);
// src/primitive.tsx

var $3OyDL = parcelRequire("3OyDL");

var $dy6Cj = parcelRequire("dy6Cj");

var $aDFmZ = parcelRequire("aDFmZ");

var $2M70Q = parcelRequire("2M70Q");
var $da6eb8c30cd53552$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $da6eb8c30cd53552$export$250ffa63cdc0d034 = $da6eb8c30cd53552$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $aDFmZ.createSlot)(`Primitive.${node}`);
    const Node = $3OyDL.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $2M70Q.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $da6eb8c30cd53552$export$6d1a0317bde7de7f(target, event) {
    if (target) $dy6Cj.flushSync(()=>target.dispatchEvent(event));
}
var $da6eb8c30cd53552$export$be92b6f5f03c0fe9 = $da6eb8c30cd53552$export$250ffa63cdc0d034;

});
parcelRegister("aDFmZ", function(module, exports) {

$parcel$export(module.exports, "createSlot", () => $b04331abc4032561$export$e88b45bda5c13eb9);
$parcel$export(module.exports, "createSlottable", () => $b04331abc4032561$export$bf68c29d8281d0f7);
$parcel$export(module.exports, "Slot", () => $b04331abc4032561$export$be92b6f5f03c0fe9);
// src/slot.tsx

var $3OyDL = parcelRequire("3OyDL");

var $i8Ljd = parcelRequire("i8Ljd");
// @__NO_SIDE_EFFECTS__
function $b04331abc4032561$export$e88b45bda5c13eb9(ownerName) {
    const Slot2 = $3OyDL.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        let slottableElement = null;
        let hasSlottable = false;
        const newChildren = [];
        if ($b04331abc4032561$var$isLazyComponent(children) && typeof $b04331abc4032561$var$use === "function") children = $b04331abc4032561$var$use(children._payload);
        $3OyDL.Children.forEach(children, (maybeSlottable)=>{
            if ($b04331abc4032561$var$isSlottable(maybeSlottable)) {
                hasSlottable = true;
                const slottable = maybeSlottable;
                let child = "child" in slottable.props ? slottable.props.child : slottable.props.children;
                if ($b04331abc4032561$var$isLazyComponent(child) && typeof $b04331abc4032561$var$use === "function") child = $b04331abc4032561$var$use(child._payload);
                slottableElement = $b04331abc4032561$var$getSlottableElementFromSlottable(slottable, child);
                newChildren.push(slottableElement?.props?.children);
            } else newChildren.push(maybeSlottable);
        });
        if (slottableElement) slottableElement = $3OyDL.cloneElement(slottableElement, void 0, newChildren);
        else if (// A `Slottable` was found but it didn't resolve to a single element (e.g.
        // it wrapped multiple elements, text, or a render-prop `child` that
        // wasn't an element). Don't fall back to treating the `Slottable` wrapper
        // itself as the slot target — throw a descriptive error below instead.
        !hasSlottable && $3OyDL.Children.count(children) === 1 && $3OyDL.isValidElement(children)) slottableElement = children;
        const slottableElementRef = slottableElement ? $b04331abc4032561$var$getElementRef(slottableElement) : void 0;
        const composedRef = (0, $i8Ljd.useComposedRefs)(forwardedRef, slottableElementRef);
        if (!slottableElement) {
            if (children || children === 0) throw new Error(hasSlottable ? $b04331abc4032561$var$createSlottableError(ownerName) : $b04331abc4032561$var$createSlotError(ownerName));
            return children;
        }
        const mergedProps = $b04331abc4032561$var$mergeProps(slotProps, slottableElement.props ?? {});
        if (slottableElement.type !== $3OyDL.Fragment) mergedProps.ref = forwardedRef ? composedRef : slottableElementRef;
        return $3OyDL.cloneElement(slottableElement, mergedProps);
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $b04331abc4032561$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $b04331abc4032561$export$e88b45bda5c13eb9("Slot");
var $b04331abc4032561$var$SLOTTABLE_IDENTIFIER = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $b04331abc4032561$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = (props)=>"child" in props ? props.children(props.child) : props.children;
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $b04331abc4032561$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $b04331abc4032561$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $b04331abc4032561$export$bf68c29d8281d0f7("Slottable");
var $b04331abc4032561$var$getSlottableElementFromSlottable = (slottable, child)=>{
    if ("child" in slottable.props) {
        const child2 = slottable.props.child;
        if (!$3OyDL.isValidElement(child2)) return null;
        return $3OyDL.cloneElement(child2, void 0, slottable.props.children(child2.props.children));
    }
    return $3OyDL.isValidElement(child) ? child : null;
};
function $b04331abc4032561$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $b04331abc4032561$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
function $b04331abc4032561$var$isSlottable(child) {
    return $3OyDL.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $b04331abc4032561$var$SLOTTABLE_IDENTIFIER;
}
var $b04331abc4032561$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
function $b04331abc4032561$var$isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === $b04331abc4032561$var$REACT_LAZY_TYPE && "_payload" in element && $b04331abc4032561$var$isPromiseLike(element._payload);
}
function $b04331abc4032561$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
var $b04331abc4032561$var$createSlotError = (ownerName)=>{
    return `${ownerName} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`;
};
var $b04331abc4032561$var$createSlottableError = (ownerName)=>{
    return `${ownerName} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`;
};
var $b04331abc4032561$var$use = $3OyDL[" use ".trim().toString()];

});


parcelRegister("fMVre", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $0d98af83e4ac9117$export$25bec8c6f54ee79a);
// src/use-callback-ref.tsx

var $3OyDL = parcelRequire("3OyDL");
function $0d98af83e4ac9117$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $3OyDL.useRef(callback);
    $3OyDL.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $3OyDL.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}

});


parcelRegister("5VxZp", function(module, exports) {

$parcel$export(module.exports, "FocusScope", () => $e304d0fdd5a97065$export$20e40289641fbbb6);

var $3OyDL = parcelRequire("3OyDL");

var $i8Ljd = parcelRequire("i8Ljd");

var $869fj = parcelRequire("869fj");

var $fMVre = parcelRequire("fMVre");

var $2M70Q = parcelRequire("2M70Q");
"use client";
var $e304d0fdd5a97065$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $e304d0fdd5a97065$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $e304d0fdd5a97065$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $e304d0fdd5a97065$var$FOCUS_SCOPE_NAME = "FocusScope";
var $e304d0fdd5a97065$export$20e40289641fbbb6 = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $3OyDL.useState(null);
    const onMountAutoFocus = (0, $fMVre.useCallbackRef)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $fMVre.useCallbackRef)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $3OyDL.useRef(null);
    const composedRefs = (0, $i8Ljd.useComposedRefs)(forwardedRef, setContainer);
    const focusScope = $3OyDL.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $3OyDL.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $e304d0fdd5a97065$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $e304d0fdd5a97065$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $e304d0fdd5a97065$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $3OyDL.useEffect(()=>{
        if (container) {
            $e304d0fdd5a97065$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($e304d0fdd5a97065$var$AUTOFOCUS_ON_MOUNT, $e304d0fdd5a97065$var$EVENT_OPTIONS);
                container.addEventListener($e304d0fdd5a97065$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $e304d0fdd5a97065$var$focusFirst($e304d0fdd5a97065$var$removeLinks($e304d0fdd5a97065$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $e304d0fdd5a97065$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($e304d0fdd5a97065$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($e304d0fdd5a97065$var$AUTOFOCUS_ON_UNMOUNT, $e304d0fdd5a97065$var$EVENT_OPTIONS);
                    container.addEventListener($e304d0fdd5a97065$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $e304d0fdd5a97065$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($e304d0fdd5a97065$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $e304d0fdd5a97065$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $3OyDL.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $e304d0fdd5a97065$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $e304d0fdd5a97065$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $e304d0fdd5a97065$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$e304d0fdd5a97065$export$20e40289641fbbb6.displayName = $e304d0fdd5a97065$var$FOCUS_SCOPE_NAME;
function $e304d0fdd5a97065$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $e304d0fdd5a97065$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $e304d0fdd5a97065$var$getTabbableEdges(container) {
    const candidates = $e304d0fdd5a97065$var$getTabbableCandidates(container);
    const first = $e304d0fdd5a97065$var$findVisible(candidates, container);
    const last = $e304d0fdd5a97065$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $e304d0fdd5a97065$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $e304d0fdd5a97065$var$findVisible(elements, container) {
    const canUseCheckVisibility = typeof container.checkVisibility === "function" && container.checkVisibility({
        checkVisibilityCSS: true
    });
    for (const element of elements){
        const hidden = canUseCheckVisibility ? !element.checkVisibility({
            checkVisibilityCSS: true
        }) : $e304d0fdd5a97065$var$isHidden(element, {
            upTo: container
        });
        if (!hidden) return element;
    }
}
function $e304d0fdd5a97065$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $e304d0fdd5a97065$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $e304d0fdd5a97065$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $e304d0fdd5a97065$var$isSelectableInput(element) && select) element.select();
    }
}
var $e304d0fdd5a97065$var$focusScopesStack = $e304d0fdd5a97065$var$createFocusScopesStack();
function $e304d0fdd5a97065$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $e304d0fdd5a97065$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $e304d0fdd5a97065$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $e304d0fdd5a97065$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $e304d0fdd5a97065$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $e304d0fdd5a97065$export$be92b6f5f03c0fe9 = $e304d0fdd5a97065$export$20e40289641fbbb6;

});

parcelRegister("74zAC", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $d591806618755acd$export$602eac185826482c);

var $3OyDL = parcelRequire("3OyDL");

var $dy6Cj = parcelRequire("dy6Cj");

var $869fj = parcelRequire("869fj");

var $4mdWM = parcelRequire("4mdWM");

var $2M70Q = parcelRequire("2M70Q");
"use client";
var $d591806618755acd$var$PORTAL_NAME = "Portal";
var $d591806618755acd$export$602eac185826482c = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $3OyDL.useState(false);
    (0, $4mdWM.useLayoutEffect)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? $dy6Cj.createPortal(/* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$d591806618755acd$export$602eac185826482c.displayName = $d591806618755acd$var$PORTAL_NAME;
var $d591806618755acd$export$be92b6f5f03c0fe9 = $d591806618755acd$export$602eac185826482c;

});

parcelRegister("c1I0K", function(module, exports) {

$parcel$export(module.exports, "Presence", () => $9668ae57b0fc1b6b$export$99c2b779aa4e8b8b);

var $3OyDL = parcelRequire("3OyDL");

var $4mdWM = parcelRequire("4mdWM");
"use client";
function $9668ae57b0fc1b6b$var$useStateMachine(initialState, machine) {
    return $3OyDL.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var $9668ae57b0fc1b6b$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $9668ae57b0fc1b6b$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $3OyDL.Children.only(children);
    const ref = $9668ae57b0fc1b6b$var$useStableComposedRefs(presence.ref, $9668ae57b0fc1b6b$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $3OyDL.cloneElement(child, {
        ref: ref
    }) : null;
};
$9668ae57b0fc1b6b$export$99c2b779aa4e8b8b.displayName = "Presence";
function $9668ae57b0fc1b6b$var$usePresence(present) {
    const [node, setNode] = $3OyDL.useState();
    const stylesRef = $3OyDL.useRef(null);
    const prevPresentRef = $3OyDL.useRef(present);
    const prevAnimationNameRef = $3OyDL.useRef("none");
    const mountAnimationNameRef = $3OyDL.useRef(void 0);
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $9668ae57b0fc1b6b$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $3OyDL.useEffect(()=>{
        if (state === "mounted") {
            prevAnimationNameRef.current = mountAnimationNameRef.current ?? $9668ae57b0fc1b6b$var$getAnimationName(stylesRef.current);
            mountAnimationNameRef.current = void 0;
        } else prevAnimationNameRef.current = "none";
    }, [
        state
    ]);
    (0, $4mdWM.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $9668ae57b0fc1b6b$var$getAnimationName(styles);
            if (present) {
                mountAnimationNameRef.current = currentAnimationName;
                send("MOUNT");
            } else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $4mdWM.useLayoutEffect)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $9668ae57b0fc1b6b$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $9668ae57b0fc1b6b$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $3OyDL.useCallback((node2)=>{
            if (node2) {
                const styles = getComputedStyle(node2);
                stylesRef.current = styles;
                mountAnimationNameRef.current = $9668ae57b0fc1b6b$var$getAnimationName(styles);
            } else stylesRef.current = null;
            setNode(node2);
        }, [])
    };
}
function $9668ae57b0fc1b6b$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $9668ae57b0fc1b6b$var$useStableComposedRefs(...refs) {
    const refsRef = $3OyDL.useRef(refs);
    refsRef.current = refs;
    return $3OyDL.useCallback((node)=>{
        const currentRefs = refsRef.current;
        let hasCleanup = false;
        const cleanups = currentRefs.map((ref)=>{
            const cleanup = $9668ae57b0fc1b6b$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $9668ae57b0fc1b6b$var$setRef(currentRefs[i], null);
            }
        };
    }, []);
}
function $9668ae57b0fc1b6b$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $9668ae57b0fc1b6b$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $9668ae57b0fc1b6b$export$be92b6f5f03c0fe9 = $9668ae57b0fc1b6b$export$99c2b779aa4e8b8b;

});

parcelRegister("5JQjG", function(module, exports) {

$parcel$export(module.exports, "useFocusGuards", () => $e666899d3eaf6b2a$export$b7ece24a22aeda8c);

var $3OyDL = parcelRequire("3OyDL");
"use client";
var $e666899d3eaf6b2a$var$count = 0;
var $e666899d3eaf6b2a$var$guards = null;
function $e666899d3eaf6b2a$export$ac5b58043b79449b(props) {
    $e666899d3eaf6b2a$export$b7ece24a22aeda8c();
    return props.children;
}
function $e666899d3eaf6b2a$export$b7ece24a22aeda8c() {
    $3OyDL.useEffect(()=>{
        if (!$e666899d3eaf6b2a$var$guards) $e666899d3eaf6b2a$var$guards = {
            start: $e666899d3eaf6b2a$var$createFocusGuard(),
            end: $e666899d3eaf6b2a$var$createFocusGuard()
        };
        const { start: start, end: end } = $e666899d3eaf6b2a$var$guards;
        if (document.body.firstElementChild !== start) document.body.insertAdjacentElement("afterbegin", start);
        if (document.body.lastElementChild !== end) document.body.insertAdjacentElement("beforeend", end);
        $e666899d3eaf6b2a$var$count++;
        return ()=>{
            if ($e666899d3eaf6b2a$var$count === 1) {
                $e666899d3eaf6b2a$var$guards?.start.remove();
                $e666899d3eaf6b2a$var$guards?.end.remove();
                $e666899d3eaf6b2a$var$guards = null;
            }
            $e666899d3eaf6b2a$var$count = Math.max(0, $e666899d3eaf6b2a$var$count - 1);
        };
    }, []);
}
function $e666899d3eaf6b2a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}

});

parcelRegister("7jvAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5532d0a56b8262ab$export$2e2bcd8739ae039);

var $b8xcN = parcelRequire("b8xcN");

var $3OyDL = parcelRequire("3OyDL");

var $8hX62 = parcelRequire("8hX62");

var $0P1ah = parcelRequire("0P1ah");
var $5532d0a56b8262ab$var$ReactRemoveScroll = $3OyDL.forwardRef(function(props, ref) {
    return $3OyDL.createElement((0, $8hX62.RemoveScroll), (0, $b8xcN.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $0P1ah.default)
    }));
});
$5532d0a56b8262ab$var$ReactRemoveScroll.classNames = (0, $8hX62.RemoveScroll).classNames;
var $5532d0a56b8262ab$export$2e2bcd8739ae039 = $5532d0a56b8262ab$var$ReactRemoveScroll;

});
parcelRegister("8hX62", function(module, exports) {

$parcel$export(module.exports, "RemoveScroll", () => $608dc08ee01d7ff0$export$22940b497e769dee);

var $b8xcN = parcelRequire("b8xcN");

var $3OyDL = parcelRequire("3OyDL");

var $2YR3o = parcelRequire("2YR3o");

var $eDKsz = parcelRequire("eDKsz");

var $8Cemh = parcelRequire("8Cemh");
var $608dc08ee01d7ff0$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $608dc08ee01d7ff0$export$22940b497e769dee = $3OyDL.forwardRef(function(props, parentRef) {
    var ref = $3OyDL.useRef(null);
    var _a = $3OyDL.useState({
        onScrollCapture: $608dc08ee01d7ff0$var$nothing,
        onWheelCapture: $608dc08ee01d7ff0$var$nothing,
        onTouchMoveCapture: $608dc08ee01d7ff0$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $b8xcN.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $eDKsz.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, rest), callbacks);
    return $3OyDL.createElement($3OyDL.Fragment, null, enabled && $3OyDL.createElement(SideCar, {
        sideCar: (0, $8Cemh.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $3OyDL.cloneElement($3OyDL.Children.only(children), (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, containerProps), {
        ref: containerRef
    })) : $3OyDL.createElement(Container, (0, $b8xcN.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$608dc08ee01d7ff0$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$608dc08ee01d7ff0$export$22940b497e769dee.classNames = {
    fullWidth: (0, $2YR3o.fullWidthClassName),
    zeroRight: (0, $2YR3o.zeroRightClassName)
};

});
parcelRegister("2YR3o", function(module, exports) {

$parcel$export(module.exports, "zeroRightClassName", () => $22ba56bfa130f7bd$export$1da7500147d4bc3);
$parcel$export(module.exports, "fullWidthClassName", () => $22ba56bfa130f7bd$export$898e37bbd2a0ae4e);
$parcel$export(module.exports, "noScrollbarsClassName", () => $22ba56bfa130f7bd$export$bb813dfbbc432abc);
$parcel$export(module.exports, "removedBarSizeVariable", () => $22ba56bfa130f7bd$export$63d0edf80fea83b1);
var $22ba56bfa130f7bd$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $22ba56bfa130f7bd$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $22ba56bfa130f7bd$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $22ba56bfa130f7bd$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';

});

parcelRegister("eDKsz", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $aa88bf274b37c686$export$74665b213cb5c4cf);

var $3OyDL = parcelRequire("3OyDL");

var $64IOF = parcelRequire("64IOF");

var $77ruG = parcelRequire("77ruG");
var $aa88bf274b37c686$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $3OyDL.useLayoutEffect : $3OyDL.useEffect;
var $aa88bf274b37c686$var$currentValues = new WeakMap();
function $aa88bf274b37c686$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $77ruG.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $64IOF.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $aa88bf274b37c686$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $aa88bf274b37c686$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $64IOF.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $64IOF.assignRef)(ref, current_1);
            });
        }
        $aa88bf274b37c686$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("64IOF", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $46c5e15a575741af$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $46c5e15a575741af$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("77ruG", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $52ee839075ae8794$export$25bec8c6f54ee79a);

var $3OyDL = parcelRequire("3OyDL");
function $52ee839075ae8794$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $3OyDL.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("8Cemh", function(module, exports) {

$parcel$export(module.exports, "effectCar", () => $645d029bce654ff2$export$e27363444bedfeac);

var $jrEpl = parcelRequire("jrEpl");
var $645d029bce654ff2$export$e27363444bedfeac = (0, $jrEpl.createSidecarMedium)();

});
parcelRegister("jrEpl", function(module, exports) {

$parcel$export(module.exports, "createSidecarMedium", () => $e27fe213c7b51f0f$export$e13ec7dd7a14088d);

var $b8xcN = parcelRequire("b8xcN");
function $e27fe213c7b51f0f$var$ItoI(a) {
    return a;
}
function $e27fe213c7b51f0f$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $e27fe213c7b51f0f$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $e27fe213c7b51f0f$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $e27fe213c7b51f0f$var$ItoI;
    return $e27fe213c7b51f0f$var$innerCreateMedium(defaults, middleware);
}
function $e27fe213c7b51f0f$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $e27fe213c7b51f0f$var$innerCreateMedium(null);
    medium.options = (0, $b8xcN.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});



parcelRegister("0P1ah", function(module, exports) {

$parcel$export(module.exports, "default", () => $00279345a08a1641$export$2e2bcd8739ae039);

var $7150Q = parcelRequire("7150Q");

var $8PlgZ = parcelRequire("8PlgZ");

var $8Cemh = parcelRequire("8Cemh");
var $00279345a08a1641$export$2e2bcd8739ae039 = (0, $7150Q.exportSidecar)((0, $8Cemh.effectCar), (0, $8PlgZ.RemoveScrollSideCar));

});
parcelRegister("7150Q", function(module, exports) {

$parcel$export(module.exports, "exportSidecar", () => $51bc83d008a05e79$export$6cacc8fb0a9b94ce);

var $b8xcN = parcelRequire("b8xcN");

var $3OyDL = parcelRequire("3OyDL");
var $51bc83d008a05e79$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $b8xcN.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $3OyDL.createElement(Target, (0, $b8xcN.__assign)({}, rest));
};
$51bc83d008a05e79$var$SideCar.isSideCarExport = true;
function $51bc83d008a05e79$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $51bc83d008a05e79$var$SideCar;
}

});

parcelRegister("8PlgZ", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollSideCar", () => $66d3968921a3e04f$export$a09dbff87b5da2d);

var $b8xcN = parcelRequire("b8xcN");

var $3OyDL = parcelRequire("3OyDL");
parcelRequire("91ssC");
var $lOJmM = parcelRequire("lOJmM");
parcelRequire("aCixc");
var $kgnsX = parcelRequire("kgnsX");

var $4IrRG = parcelRequire("4IrRG");

var $7AFTA = parcelRequire("7AFTA");
var $66d3968921a3e04f$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $66d3968921a3e04f$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $66d3968921a3e04f$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $66d3968921a3e04f$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $66d3968921a3e04f$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $66d3968921a3e04f$var$idCounter = 0;
var $66d3968921a3e04f$var$lockStack = [];
function $66d3968921a3e04f$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $3OyDL.useRef([]);
    var touchStartRef = $3OyDL.useRef([
        0,
        0
    ]);
    var activeAxis = $3OyDL.useRef();
    var id = $3OyDL.useState($66d3968921a3e04f$var$idCounter++)[0];
    var Style = $3OyDL.useState((0, $kgnsX.styleSingleton))[0];
    var lastProps = $3OyDL.useRef(props);
    $3OyDL.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $3OyDL.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $b8xcN.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($66d3968921a3e04f$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $3OyDL.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $66d3968921a3e04f$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $7AFTA.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $7AFTA.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $7AFTA.handleScroll)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $3OyDL.useCallback(function(_event) {
        var event = _event;
        if (!$66d3968921a3e04f$var$lockStack.length || $66d3968921a3e04f$var$lockStack[$66d3968921a3e04f$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $66d3968921a3e04f$export$39efaa2ca254a28d(event) : $66d3968921a3e04f$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $66d3968921a3e04f$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($66d3968921a3e04f$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $3OyDL.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $66d3968921a3e04f$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $3OyDL.useCallback(function(event) {
        touchStartRef.current = $66d3968921a3e04f$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $3OyDL.useCallback(function(event) {
        shouldCancel(event.type, $66d3968921a3e04f$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $3OyDL.useCallback(function(event) {
        shouldCancel(event.type, $66d3968921a3e04f$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $3OyDL.useEffect(function() {
        $66d3968921a3e04f$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $4IrRG.nonPassive));
        document.addEventListener('touchmove', shouldPrevent, (0, $4IrRG.nonPassive));
        document.addEventListener('touchstart', scrollTouchStart, (0, $4IrRG.nonPassive));
        return function() {
            $66d3968921a3e04f$var$lockStack = $66d3968921a3e04f$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $4IrRG.nonPassive));
            document.removeEventListener('touchmove', shouldPrevent, (0, $4IrRG.nonPassive));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $4IrRG.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $3OyDL.createElement($3OyDL.Fragment, null, inert ? $3OyDL.createElement(Style, {
        styles: $66d3968921a3e04f$var$generateStyle(id)
    }) : null, removeScrollBar ? $3OyDL.createElement((0, $lOJmM.RemoveScrollBar), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $66d3968921a3e04f$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

});
parcelRegister("91ssC", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => (parcelRequire("lOJmM")).RemoveScrollBar);

var $lOJmM = parcelRequire("lOJmM");

var $2YR3o = parcelRequire("2YR3o");

var $2E1Wy = parcelRequire("2E1Wy");

});
parcelRegister("lOJmM", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => $fe2175524037841f$export$9aa43b459c5ae9b9);

var $3OyDL = parcelRequire("3OyDL");
parcelRequire("aCixc");
var $kgnsX = parcelRequire("kgnsX");

var $2YR3o = parcelRequire("2YR3o");

var $2E1Wy = parcelRequire("2E1Wy");
var $fe2175524037841f$var$Style = (0, $kgnsX.styleSingleton)();
var $fe2175524037841f$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $fe2175524037841f$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $2YR3o.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($fe2175524037841f$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $2YR3o.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $2YR3o.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $2YR3o.zeroRightClassName), " .").concat((0, $2YR3o.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $2YR3o.fullWidthClassName), " .").concat((0, $2YR3o.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($fe2175524037841f$export$65254d5f26cb9564, "] {\n    ").concat((0, $2YR3o.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var $fe2175524037841f$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($fe2175524037841f$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $fe2175524037841f$export$a1939b1f9f9b02dc = function() {
    $3OyDL.useEffect(function() {
        document.body.setAttribute($fe2175524037841f$export$65254d5f26cb9564, ($fe2175524037841f$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $fe2175524037841f$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($fe2175524037841f$export$65254d5f26cb9564);
            else document.body.setAttribute($fe2175524037841f$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $fe2175524037841f$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $fe2175524037841f$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $3OyDL.useMemo(function() {
        return (0, $2E1Wy.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return $3OyDL.createElement($fe2175524037841f$var$Style, {
        styles: $fe2175524037841f$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};

});
parcelRegister("aCixc", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => (parcelRequire("kgnsX")).styleSingleton);

var $kgnsX = parcelRequire("kgnsX");

var $331L0 = parcelRequire("331L0");

var $dRHMl = parcelRequire("dRHMl");

});
parcelRegister("kgnsX", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => $ec07811de160fa39$export$c1248ee86ba532c8);

var $dRHMl = parcelRequire("dRHMl");
var $ec07811de160fa39$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $dRHMl.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

});
parcelRegister("dRHMl", function(module, exports) {

$parcel$export(module.exports, "styleHookSingleton", () => $a1822f284d4446e5$export$7d7b35c2d250e94c);

var $3OyDL = parcelRequire("3OyDL");

var $331L0 = parcelRequire("331L0");
var $a1822f284d4446e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $331L0.stylesheetSingleton)();
    return function(styles, isDynamic) {
        $3OyDL.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

});
parcelRegister("331L0", function(module, exports) {

$parcel$export(module.exports, "stylesheetSingleton", () => $238303db899fb565$export$7c74eec858d5d226);

var $8Jyx9 = parcelRequire("8Jyx9");
function $238303db899fb565$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $8Jyx9.getNonce)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $238303db899fb565$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $238303db899fb565$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $238303db899fb565$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $238303db899fb565$var$makeStyleTag()) {
                    $238303db899fb565$var$injectStyles(stylesheet, style);
                    $238303db899fb565$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

});
parcelRegister("8Jyx9", function(module, exports) {

$parcel$export(module.exports, "getNonce", () => $65bd50613b9319a7$export$2b85b721e524d74b);
var $65bd50613b9319a7$var$currentNonce;
var $65bd50613b9319a7$export$c5f670b24c0ae95a = function(nonce) {
    $65bd50613b9319a7$var$currentNonce = nonce;
};
var $65bd50613b9319a7$export$2b85b721e524d74b = function() {
    if ($65bd50613b9319a7$var$currentNonce) return $65bd50613b9319a7$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};

});





parcelRegister("2E1Wy", function(module, exports) {

$parcel$export(module.exports, "getGapWidth", () => $1ed0d322c1bfb662$export$75f2ca8f029c77f4);
var $1ed0d322c1bfb662$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $1ed0d322c1bfb662$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $1ed0d322c1bfb662$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $1ed0d322c1bfb662$var$parse(left),
        $1ed0d322c1bfb662$var$parse(top),
        $1ed0d322c1bfb662$var$parse(right)
    ];
};
var $1ed0d322c1bfb662$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $1ed0d322c1bfb662$export$efed13b5d0ca3386;
    var offsets = $1ed0d322c1bfb662$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

});



parcelRegister("4IrRG", function(module, exports) {

$parcel$export(module.exports, "nonPassive", () => $36f0e2d84da86b09$export$10a6e88623fa9454);
var $36f0e2d84da86b09$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $36f0e2d84da86b09$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $36f0e2d84da86b09$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $36f0e2d84da86b09$var$options, $36f0e2d84da86b09$var$options);
    // @ts-ignore
    window.removeEventListener('test', $36f0e2d84da86b09$var$options, $36f0e2d84da86b09$var$options);
} catch (err) {
    $36f0e2d84da86b09$var$passiveSupported = false;
}
var $36f0e2d84da86b09$export$10a6e88623fa9454 = $36f0e2d84da86b09$var$passiveSupported ? {
    passive: false
} : false;

});

parcelRegister("7AFTA", function(module, exports) {

$parcel$export(module.exports, "locationCouldBeScrolled", () => $586c64c3ba714015$export$9ec64480cae49817);
$parcel$export(module.exports, "handleScroll", () => $586c64c3ba714015$export$dde0441bd4a6ded8);
var $586c64c3ba714015$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $586c64c3ba714015$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$586c64c3ba714015$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $586c64c3ba714015$var$elementCouldBeVScrolled = function(node) {
    return $586c64c3ba714015$var$elementCanBeScrolled(node, 'overflowY');
};
var $586c64c3ba714015$var$elementCouldBeHScrolled = function(node) {
    return $586c64c3ba714015$var$elementCanBeScrolled(node, 'overflowX');
};
var $586c64c3ba714015$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $586c64c3ba714015$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $586c64c3ba714015$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $586c64c3ba714015$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $586c64c3ba714015$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $586c64c3ba714015$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $586c64c3ba714015$var$elementCouldBeVScrolled(node) : $586c64c3ba714015$var$elementCouldBeHScrolled(node);
};
var $586c64c3ba714015$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $586c64c3ba714015$var$getVScrollVariables(node) : $586c64c3ba714015$var$getHScrollVariables(node);
};
var $586c64c3ba714015$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $586c64c3ba714015$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $586c64c3ba714015$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $586c64c3ba714015$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($586c64c3ba714015$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

});




parcelRegister("3lFTR", function(module, exports) {

$parcel$export(module.exports, "hideOthers", () => $2703d5bd16801142$export$6e33d16126ed003c);
var $2703d5bd16801142$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $2703d5bd16801142$var$counterMap = new WeakMap();
var $2703d5bd16801142$var$uncontrolledNodes = new WeakMap();
var $2703d5bd16801142$var$markerMap = {};
var $2703d5bd16801142$var$lockCount = 0;
var $2703d5bd16801142$var$unwrapHost = function(node) {
    return node && (node.host || $2703d5bd16801142$var$unwrapHost(node.parentNode));
};
var $2703d5bd16801142$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $2703d5bd16801142$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $2703d5bd16801142$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $2703d5bd16801142$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$2703d5bd16801142$var$markerMap[markerName]) $2703d5bd16801142$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $2703d5bd16801142$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($2703d5bd16801142$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $2703d5bd16801142$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $2703d5bd16801142$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $2703d5bd16801142$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $2703d5bd16801142$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $2703d5bd16801142$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$2703d5bd16801142$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $2703d5bd16801142$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $2703d5bd16801142$var$lockCount--;
        if (!$2703d5bd16801142$var$lockCount) {
            // clear
            $2703d5bd16801142$var$counterMap = new WeakMap();
            $2703d5bd16801142$var$counterMap = new WeakMap();
            $2703d5bd16801142$var$uncontrolledNodes = new WeakMap();
            $2703d5bd16801142$var$markerMap = {};
        }
    };
};
var $2703d5bd16801142$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $2703d5bd16801142$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $2703d5bd16801142$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $2703d5bd16801142$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $2703d5bd16801142$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $2703d5bd16801142$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $2703d5bd16801142$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $2703d5bd16801142$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($2703d5bd16801142$export$cc95fea82d705fca() ? $2703d5bd16801142$export$59151cc8db999a24 : $2703d5bd16801142$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};

});


parcelRegister("1tMez", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6db6a3b6b4236c0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $d6db6a3b6b4236c0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const $d6db6a3b6b4236c0$export$2e2bcd8739ae039 = (0, $djixo.default)("chevron-left", $d6db6a3b6b4236c0$export$3efd853dbb351e94);

});

parcelRegister("eH742", function(module, exports) {

$parcel$export(module.exports, "default", () => $381a11db85854c37$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $381a11db85854c37$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $381a11db85854c37$export$2e2bcd8739ae039 = (0, $djixo.default)("chevron-right", $381a11db85854c37$export$3efd853dbb351e94);

});

parcelRegister("6PxCH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aaa7627499b6e99$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $0aaa7627499b6e99$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $0aaa7627499b6e99$export$2e2bcd8739ae039 = (0, $djixo.default)("plus", $0aaa7627499b6e99$export$3efd853dbb351e94);

});

parcelRegister("krsAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $995dca0c2986978c$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $995dca0c2986978c$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 6v6l4 2",
            key: "mmk7yg"
        }
    ]
];
const $995dca0c2986978c$export$2e2bcd8739ae039 = (0, $djixo.default)("clock", $995dca0c2986978c$export$3efd853dbb351e94);

});

parcelRegister("74E7N", function(module, exports) {

$parcel$export(module.exports, "default", () => $3836ede5eba1b5db$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $3836ede5eba1b5db$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $3836ede5eba1b5db$export$2e2bcd8739ae039 = (0, $djixo.default)("arrow-right", $3836ede5eba1b5db$export$3efd853dbb351e94);

});

parcelRegister("hZu6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $daba7ef20cff310f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $daba7ef20cff310f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
            key: "1sd12s"
        }
    ]
];
const $daba7ef20cff310f$export$2e2bcd8739ae039 = (0, $djixo.default)("message-circle", $daba7ef20cff310f$export$3efd853dbb351e94);

});

parcelRegister("619y7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e58429e77b9cfd6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $5e58429e77b9cfd6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
            key: "9njp5v"
        }
    ]
];
const $5e58429e77b9cfd6$export$2e2bcd8739ae039 = (0, $djixo.default)("phone", $5e58429e77b9cfd6$export$3efd853dbb351e94);

});

parcelRegister("c7uHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5907f9ba435b74ee$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $5907f9ba435b74ee$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
            key: "1ffxy3"
        }
    ],
    [
        "path",
        {
            d: "m21.854 2.147-10.94 10.939",
            key: "12cjpa"
        }
    ]
];
const $5907f9ba435b74ee$export$2e2bcd8739ae039 = (0, $djixo.default)("send", $5907f9ba435b74ee$export$3efd853dbb351e94);

});

parcelRegister("jVTfU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d1c1d2ea341493c$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $4d1c1d2ea341493c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
            key: "18u6gg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "13",
            r: "3",
            key: "1vg3eu"
        }
    ]
];
const $4d1c1d2ea341493c$export$2e2bcd8739ae039 = (0, $djixo.default)("camera", $4d1c1d2ea341493c$export$3efd853dbb351e94);

});

parcelRegister("2vK0R", function(module, exports) {

$parcel$export(module.exports, "default", () => $88c7c68a0f8cf428$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $88c7c68a0f8cf428$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
];
const $88c7c68a0f8cf428$export$2e2bcd8739ae039 = (0, $djixo.default)("pencil", $88c7c68a0f8cf428$export$3efd853dbb351e94);

});

parcelRegister("8PPl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5add1583d8bb3a70$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $5add1583d8bb3a70$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $5add1583d8bb3a70$export$2e2bcd8739ae039 = (0, $djixo.default)("search", $5add1583d8bb3a70$export$3efd853dbb351e94);

});

parcelRegister("bcl5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbcc84972a28592$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $2cbcc84972a28592$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 14v2.2l1.6 1",
            key: "fo4ql5"
        }
    ],
    [
        "path",
        {
            d: "M16 2v3",
            key: "otl347"
        }
    ],
    [
        "path",
        {
            d: "M21 7.338V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h2.338",
            key: "7hb8p4"
        }
    ],
    [
        "path",
        {
            d: "M3 9h5.859",
            key: "numkqi"
        }
    ],
    [
        "path",
        {
            d: "M8 2v3",
            key: "1ioesn"
        }
    ],
    [
        "circle",
        {
            cx: "16",
            cy: "16",
            r: "6",
            key: "qoo3c4"
        }
    ]
];
const $2cbcc84972a28592$export$2e2bcd8739ae039 = (0, $djixo.default)("calendar-clock", $2cbcc84972a28592$export$3efd853dbb351e94);

});

parcelRegister("b6UhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $23cf232779ee0c36$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $23cf232779ee0c36$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 18h6",
            key: "987eiv"
        }
    ],
    [
        "path",
        {
            d: "M16 2v3",
            key: "otl347"
        }
    ],
    [
        "path",
        {
            d: "M19 15v6",
            key: "10aioa"
        }
    ],
    [
        "path",
        {
            d: "M21 11.5V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h8.3",
            key: "jgwkxf"
        }
    ],
    [
        "path",
        {
            d: "M3 9h18",
            key: "1pudct"
        }
    ],
    [
        "path",
        {
            d: "M8 2v3",
            key: "1ioesn"
        }
    ]
];
const $23cf232779ee0c36$export$2e2bcd8739ae039 = (0, $djixo.default)("calendar-plus", $23cf232779ee0c36$export$3efd853dbb351e94);

});

parcelRegister("jqtUP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6e92d875b474dfb$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $b6e92d875b474dfb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $b6e92d875b474dfb$export$2e2bcd8739ae039 = (0, $djixo.default)("refresh-cw", $b6e92d875b474dfb$export$3efd853dbb351e94);

});

parcelRegister("aNyTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $54060e031c197273$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $54060e031c197273$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $54060e031c197273$export$2e2bcd8739ae039 = (0, $djixo.default)("check", $54060e031c197273$export$3efd853dbb351e94);

});

parcelRegister("9ZCAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $953f134a50430214$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $953f134a50430214$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $953f134a50430214$export$2e2bcd8739ae039 = (0, $djixo.default)("chevron-down", $953f134a50430214$export$3efd853dbb351e94);

});

parcelRegister("gcf4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $99bb10c470762e24$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $99bb10c470762e24$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const $99bb10c470762e24$export$2e2bcd8739ae039 = (0, $djixo.default)("chevron-up", $99bb10c470762e24$export$3efd853dbb351e94);

});

parcelRegister("9sIvk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d16e23c5f9c4cd94$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $d16e23c5f9c4cd94$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
            key: "vktsd0"
        }
    ],
    [
        "circle",
        {
            cx: "7.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "kqv944"
        }
    ]
];
const $d16e23c5f9c4cd94$export$2e2bcd8739ae039 = (0, $djixo.default)("tag", $d16e23c5f9c4cd94$export$3efd853dbb351e94);

});

parcelRegister("bQbUH", function(module, exports) {

$parcel$export(module.exports, "default", () => $58498ddf47db9089$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $58498ddf47db9089$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 7h6v6",
            key: "box55l"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.5 8.5-5-5L2 17",
            key: "1t1m79"
        }
    ]
];
const $58498ddf47db9089$export$2e2bcd8739ae039 = (0, $djixo.default)("trending-up", $58498ddf47db9089$export$3efd853dbb351e94);

});

parcelRegister("fohPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f04d32e7f6c316a9$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $f04d32e7f6c316a9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
            key: "1c8476"
        }
    ],
    [
        "path",
        {
            d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
            key: "1ydtos"
        }
    ],
    [
        "path",
        {
            d: "M7 3v4a1 1 0 0 0 1 1h7",
            key: "t51u73"
        }
    ]
];
const $f04d32e7f6c316a9$export$2e2bcd8739ae039 = (0, $djixo.default)("save", $f04d32e7f6c316a9$export$3efd853dbb351e94);

});

parcelRegister("kvlXp", function(module, exports) {

$parcel$export(module.exports, "default", () => $874116a3acc9311b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $874116a3acc9311b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "path",
        {
            d: "M16 3.128a4 4 0 0 1 0 7.744",
            key: "16gr8j"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ]
];
const $874116a3acc9311b$export$2e2bcd8739ae039 = (0, $djixo.default)("users", $874116a3acc9311b$export$3efd853dbb351e94);

});

parcelRegister("5Quto", function(module, exports) {

$parcel$export(module.exports, "default", () => $03a03cced02ebda0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $03a03cced02ebda0$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M4.929 4.929 19.07 19.071",
            key: "196cmz"
        }
    ]
];
const $03a03cced02ebda0$export$2e2bcd8739ae039 = (0, $djixo.default)("ban", $03a03cced02ebda0$export$3efd853dbb351e94);

});

parcelRegister("hb5XY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e4a2f4794013b22$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $0e4a2f4794013b22$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
            key: "10ikf1"
        }
    ]
];
const $0e4a2f4794013b22$export$2e2bcd8739ae039 = (0, $djixo.default)("play", $0e4a2f4794013b22$export$3efd853dbb351e94);

});

parcelRegister("ks4jt", function(module, exports) {

$parcel$export(module.exports, "default", () => $851615128e002daf$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $851615128e002daf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 17H7A5 5 0 0 1 7 7h2",
            key: "8i5ue5"
        }
    ],
    [
        "path",
        {
            d: "M15 7h2a5 5 0 1 1 0 10h-2",
            key: "1b9ql8"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "16",
            y1: "12",
            y2: "12",
            key: "1jonct"
        }
    ]
];
const $851615128e002daf$export$2e2bcd8739ae039 = (0, $djixo.default)("link-2", $851615128e002daf$export$3efd853dbb351e94);

});

parcelRegister("brQlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b84109f2bab65ed6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $b84109f2bab65ed6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "M12 8v4",
            key: "1got3b"
        }
    ],
    [
        "path",
        {
            d: "M12 16h.01",
            key: "1drbdi"
        }
    ]
];
const $b84109f2bab65ed6$export$2e2bcd8739ae039 = (0, $djixo.default)("shield-alert", $b84109f2bab65ed6$export$3efd853dbb351e94);

});

parcelRegister("3ci4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab90bfb68d7b914c$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $ab90bfb68d7b914c$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m16 9-5.5 5.5L8 12",
            key: "xofnsj"
        }
    ]
];
const $ab90bfb68d7b914c$export$2e2bcd8739ae039 = (0, $djixo.default)("circle-check", $ab90bfb68d7b914c$export$3efd853dbb351e94);

});

parcelRegister("5gte0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f74ea3e15297751$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $2f74ea3e15297751$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 3h6v6",
            key: "1q9fwt"
        }
    ],
    [
        "path",
        {
            d: "M10 14 21 3",
            key: "gplh6r"
        }
    ],
    [
        "path",
        {
            d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
            key: "a6xqqp"
        }
    ]
];
const $2f74ea3e15297751$export$2e2bcd8739ae039 = (0, $djixo.default)("external-link", $2f74ea3e15297751$export$3efd853dbb351e94);

});

parcelRegister("gXlfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d2e364a1d974fa4$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $0d2e364a1d974fa4$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const $0d2e364a1d974fa4$export$2e2bcd8739ae039 = (0, $djixo.default)("circle-x", $0d2e364a1d974fa4$export$3efd853dbb351e94);

});


//# sourceMappingURL=app.429ed9d7.js.map
